// import React, { useState, useEffect, useRef } from "react";
// import { useHistory, useLocation } from "react-router-dom";
// import {
//   Typography,
//   Input,
//   Button,
//   Select,
//   Form,
//   Col,
//   Row,
//   DatePicker,
//   message,
//   Table,
//   Radio, 
//   Popconfirm,
//   Upload,
//   Card,
//   Descriptions,
// } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
// import moment from "moment";
// import { platformApi } from "../../../../../api";
// import { getUUID } from "../../../../../_helpers/utils";
// import { GST18, GST28, GST12, GST5 } from "../../../../../utils";
// import GSTTable from "./GSTTable";
// import WrappedCustomerAddModal from "../../../../../components/TransactionMasters/JobOrder/JobOrderModal/VehicleDetails/AddCustomer";

// const { Title, Text } = Typography;
// const { Option } = Select;
// const { Group } = Radio;
// const EstimateForm = (props) => {
//   const {
//     form,
//     estimateNo,
//     id,
//     jobNo,
//     setJobNo,
//     partsData,
//     setPartsData,
//     jobCode,
//     setJobCode,
//     editData,
//     editable,
//     onEdit,
//     modifyType,
//   } = props;

//   const partItemData = {
//     id: getUUID(),
//     partNumber: {},
//     imageUrl: "",
//     code: "",
//     hsn: {},
//     quantity: "",
//     unitRate: "",
//     discount: "",
//     rate: "",
//     igst: 0,
//     cgst: 0,
//     sgst: 0,
//     gstRate: 0,
//     grandTotal: 0,
//     igstAmount: 0,
//     cgstAmount: 0,
//     sgstAmount: 0,
//     discountAmount: 0,
//     discountPercent: 0,
//     remove: "",
//   };

//   const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
//   const history = useHistory();
//   const location = useLocation();
//   const [model, setModel] = useState();
//   const [branch, setBranch] = useState("");
//   const [gst, setGst] = useState("");
//   const [stateName, setStateName] = useState("");
//   const [selectedPart, setSelectedPart] = useState("");
//   const [itemList, setItemList] = useState([partItemData]);
//   const [selectItemObj, setSelectItemObj] = useState({});
//   const [discountType, setDiscountType] = useState("");
//   const [discountLevel, setDiscountLevel] = useState("TransactionLevel");

//   const [serviceType, setServiceType] = useState("");
//   const [claimType, setClaimType] = useState("");
//   const [insurerList, setInsurerList] = useState([]);
//   const [survivorList, setSurvivorList] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [contact, setContact] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [cusId, setCusId] = useState(null);
//   const [claimStatus, setClaimStatus] = useState();
//   const [vehicleDetail, setVehicleDetail] = useState();

//   const [recPart, setRecPart] = useState("");
//   const [quantity, setquantity] = useState();
//   const [unitRate, setUnitRate] = useState();
//   const [rate, setRate] = useState(0);
//   const [discountAmount, setDiscountAmount] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const [totalDiscount, setTotalDiscount] = useState(0);
//   const [grandTtl, setGrandTotal] = useState(0);
//   const [SGST, setSGST] = useState();
//   const [CGST, setCGST] = useState();
//   const [IGST, setIGST] = useState();
//   const [GSTRate18, setGSTRate18] = useState(false);
//   const [GSTRate28, setGSTRate28] = useState(false);
//   const [GSTRate12, setGSTRate12] = useState(false);
//   const [GSTRate5, setGSTRate5] = useState(false);
//   const [SGSTAmount, setSGSTAmount] = useState();
//   const [CGSTAmount, setCGSTAmount] = useState();
//   const [IGSTAmount, setIGSTAmount] = useState();
//   const [deleteItem, setDeleteItem] = useState(false);
//   const [dataTemp, setDataTemp] = useState([]);
//   const [deleteData1, setDeleteData1] = useState([]);
//   const [deleteData2, setDeleteData2] = useState([]);
//   const [pid, setPid] = useState([]);
//   const [jid, setJid] = useState([]);
//   const [pBranch, setPBranch] = useState("");
//   const [btnFlag, setBtnFlag] = useState(false);
//   // const partRef = useRef(null);
//   const partsRef = {};
//   let sgstAmt = 0;
//   let cgstAmt = 0;
//   let igstAmt = 0;
//   const lastSearchRef = useRef("");

//   const uploadCsv = async (file) => {
//     const formData = new FormData();
//     formData.append("csv", file);

//     try {
//       const response = await platformApi.post(
//         `api/partsMaster/upload-csv`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       if (response.data.code === 200 && response.data.data) {
//         // Process each CSV item
//         const existingItems = itemList.filter(
//           (item) =>
//             item.partNumber &&
//             (item.partNumber.partNumber || item.partNumber.code || item.jobCode)
//         );

//         const csvLength = response.data.data.length;

//         let newItemList = [...existingItems];
//         let currentTotal = parseFloat(grandTtl) || 0;
//         let TotalCgst = 0;
//         let TotalSgst = 0;
//         let TotalIgst = 0;
//         let pCharge = 0;
//         let labourCharge = 0;
//         let consumableCharge = 0;

//         // Process CSV items sequentially
//         for (const csvItem of response.data.data) {
//           try {
//             // Search for the part
//             const searchResponse = await platformApi.post(
//               "/api/purchaseSpareInvoice/search",
//               { search: csvItem.partNumber }
//             );

//             if (
//               searchResponse.data.code === 200 &&
//               searchResponse.data.response.code === 200 &&
//               searchResponse.data.response.data.partsMasterData.length > 0
//             ) {
//               const existingPart =
//                 searchResponse.data.response.data.partsMasterData[0];

//               // Create new row
//               const newRow = {
//                 ...partItemData,
//                 id: getUUID(),
//                 partNumber: existingPart,
//                 hsn: existingPart.hsn,
//                 cgst: existingPart.hsn.cgst,
//                 igst: existingPart.hsn.igst,
//                 sgst: existingPart.hsn.sgst,
//                 gstRate: existingPart.hsn.cgst + existingPart.hsn.sgst,
//                 unitRate: existingPart.mrp,
//                 quantity: csvItem.quantity || 1,
//                 rate: existingPart.mrp * (csvItem.quantity || 1),
//                 grossAmount: existingPart.mrp * (csvItem.quantity || 1),
//                 isFromCsv: true,
//               };
//               // Calculate GST amounts
//               newRow.sgstAmount = parseFloat(
//                 // (newRow.sgst / 100) * newRow.rate
//                 newRow.rate - newRow.rate / (1 + newRow.sgstAmount / 100)
//               ).toFixed(2);
//               newRow.igstAmount = parseFloat(
//                 newRow.rate - newRow.rate / (1 + newRow.igstAmount / 100)
//                 // (newRow.igst / 100) * newRow.rate
//               ).toFixed(2);
//               newRow.cgstAmount = parseFloat(
//                 newRow.rate - newRow.rate / (1 + newRow.cgstAmount / 100)
//                 // (newRow.cgst / 100) * newRow.rate
//               ).toFixed(2);

//               // Update totals
//               currentTotal += parseFloat(newRow.rate);
//               TotalCgst += parseFloat(newRow.cgstAmount);
//               TotalSgst += parseFloat(newRow.sgstAmount);
//               TotalIgst += parseFloat(newRow.igstAmount);

//               // Update charges
//               if (newRow.partNumber.hsn) {
//                 pCharge += parseFloat(newRow.rate);
//               }

//               // Add new row
//               newItemList.push(newRow);
//             } else {
//               message.warning(
//                 `Part ${csvItem.partNumber} not found in database`
//               );
//             }
//           } catch (error) {
//             console.error(
//               `Error searching for part ${csvItem.partNumber}:`,
//               error
//             );
//             message.error(`Error processing part ${csvItem.partNumber}`);
//           }
//         }

//         // Add empty row at the end
//         newItemList.push({ ...partItemData, id: getUUID() });

//         // Update form values
//         form.setFieldsValue({
//           totalAmount: currentTotal.toFixed(0),
//           cgst: TotalCgst.toFixed(2),
//           sgst: TotalSgst.toFixed(2),
//           igst: TotalIgst.toFixed(2),
//           partCharge: pCharge.toFixed(2),
//           labourCharge: labourCharge.toFixed(2),
//           consumableCharge: consumableCharge.toFixed(2),
//         });

//         // Update state in a single batch
//         setItemList(newItemList);
//         setGrandTotal(currentTotal.toFixed(2));

//         message.success(`Uploaded ${csvLength} parts from CSV`);
//       } else {
//         message.error(
//           "Failed to upload CSV: " + (response.data.message || "Unknown error")
//         );
//       }
//     } catch (error) {
//       console.error("Error uploading CSV:", error);
//       message.error(
//         "Failed to upload CSV: " + (error.message || "Unknown network error")
//       );
//     }
//   };

//   useEffect(() => {
//     if (location.state && location.state.gst) {
//       setGst(location.state.gst);
//     }
//   }, [location.state]);

//   //EditData
//   useEffect(() => {
//     if (editData && editData.jobOrder) {
//       setVehicleDetail(editData.jobOrder.vehicle);

//       setDiscountLevel(editData.discountLevel);
//       setDiscountType(editData.discountType);
//       setGrandTotal(editData.estTotalAmount ? editData.estTotalAmount : 0);
//       setStateName(
//         editData.jobOrder.customer && editData.jobOrder.customer.GSTNo
//       );

//       if (editData.discountLevel === "TransactionLevel") {
//         if (editData.discountPercent !== 0) {
//           setDiscountAmount(editData.discountPercent);
//           setDiscountType("percent");
//         }
//         if (editData.discountRate !== 0) {
//           setDiscountAmount(editData.discountRate);
//           setDiscountType("rupee");
//         }
//       }

//       const updateItemList = [...editData.estimateItemInvoice];

//       for (let i = 0; i < updateItemList.length; i++) {
//         if (updateItemList[i].jobCode) {
//           updateItemList[i].partNumber = { ...updateItemList[i] };
//           updateItemList[i].rate =
//             updateItemList[i].quantity * updateItemList[i].unitRate;
//           (updateItemList[i].hsn = updateItemList[i].sac),
//             (updateItemList[i].cgst = updateItemList[i].sac.cgst);
//           updateItemList[i].sgst = updateItemList[i].sac.sgst;
//           updateItemList[i].igst = updateItemList[i].sac.igst;
//           updateItemList[i].gstRate =
//             updateItemList[i].sac.cgst + updateItemList[i].sac.sgst;
//           updateItemList[i].gstRate = updateItemList[i].igst;
//           setUnitRate(updateItemList[i].unitRate);
//           if (updateItemList[i].gstRate === GST28) {
//             setGSTRate28(true);
//           }
//           if (updateItemList[i].gstRate === GST18) {
//             setGSTRate18(true);
//           }
//           if (updateItemList[i].gstRate === GST12) {
//             setGSTRate12(true);
//           }
//         } else {
//           updateItemList[i].rate =
//             updateItemList[i].quantity * updateItemList[i].unitRate;
//         }
//       }

//       // Set form values immediately
//       const formValues = {
//         JobNo: editData.jobOrder?.id,
//         branch: editData.jobOrder?.branch?.name,
//         serviceType: editData.serviceType,
//         discountType: editData.discountType,
//         discountLevel: editData.discountLevel,
//         labourCharge: editData.labourCharge || 0,
//         consumableCharge: editData.consumableCharge || 0,
//         partCharge: editData.partCharge || 0,
//         totalDiscount: editData.totalDiscount || 0,
//         sgst: editData.sgstAmount || 0,
//         cgst: editData.cgstAmount || 0,
//         igst: editData.igstAmount || 0,
//         totalAmount: editData.estTotalAmount || 0,
//       };

//       if (editData.serviceType === "Accidental") {

//         if (editData?.survivor && survivorList.every(s => s.id !== editData.survivor.id)) {
//           setSurvivorList(prev => [...prev, editData.survivor]);
//         }

//         setFieldsValue({
//           ...formValues,
//           claimStatus: editData.claimStatus,
//           claimType: editData.claimType || "",
//           insurer: editData.insurer?.name || "",
//           survivor: editData.survivor
//             ? `${editData.survivor?.name}-${editData.survivor?.contacts[0].phone}`
//             : "",
//         });

//         // Set state values after form values
//         setClaimStatus(editData.claimStatus);
//         setClaimType(editData.claimType || "");
//         setServiceType(editData.serviceType);
//       } else {
//         setFieldsValue(formValues);
//       }

//       // Set job order data
//       setJobNo([editData.jobOrder]);
//       setModel(editData.jobOrder?.vehicle?.vehicle.id);

//       // Set item list
//       setItemList(updateItemList);

//       // Set delete data
//       for (let item of editData.estimateItemInvoice) {
//         if (item.jobCode) {
//           jid.push(item.id);
//         } else {
//           pid.push(item.id);
//         }
//       }
//       setPid(pid);
//       setJid(jid);
//     }
//   }, [editData]);

//   //setBranch
//   useEffect(() => {
//     platformApi.get("/api/user/currentUser").then((result) => {
//       let { data } = result;
//       if (data.code === 200) {
//         let { response } = data;
//         if (response.code === 200) {
//           setBranch(response.data.profile.branch[0].id);
//           setPBranch(response.data.profile.branch[0].id);
//         }
//       }
//     });

//     // Set discount level after a small delay
//     setTimeout(() => {
//       setFieldsValue({
//         discountLevel: discountLevel,
//       });
//     }, 0);
//   }, []);
//   //Props

//   useEffect(() => {
//     if (location.state && location.state.jobNo) {
//       setFieldsValue({
//         JobNo: location.state.jobNo,
//       });
//       if (!jobNo.some((tempItem) => location.state.jobNo === tempItem.id)) {
//         platformApi.get("/api/jobOrder/" + location.state.jobNo).then((res) => {
//           let { data } = res;
//           if (data.code === 200) {
//             let { response } = data;
//             if (response.code === 200) {
//               setVehicleDetail(response.data.vehicle);
//               setStateName(
//                 response.data.customer && response.data.customer?.GSTNo
//               );
//               setJobNo([...jobNo, response.data]);

//               form.setFieldsValue({
//                 branch: response.data.branch?.name,
//                 serviceType:
//                   response.data.serviceType === "Accidental"
//                     ? "Accidental"
//                     : "Non Accidental",
//               });

//               setServiceType(
//                 response.data.serviceType === "Accidental"
//                   ? "Accidental"
//                   : "Non Accidental"
//               );
//             }
//           }
//         });
//       }
//     }
//     // getJobOrder(location.state.jobNo)
//     // fetchJobDetails(location.state.jobNo && location.state.jobNo)
//   }, [location.state, jobNo]);

//   useEffect(() => {
//     if (partsData || jobCode) {
//       let temp = [];
//       partsData.map((item) => {
//         temp.push({
//           label: `${item.partNumber} - ${item.partName}`,
//           value: item.partNumber,
//           id: item.id,
//         });
//       });

//       jobCode.map((item) => {
//         temp.push({
//           label: item.code,
//           value: item.code,
//           id: item.id,
//           consumable: item.consumable,
//         });
//       });
//       setDataTemp(temp);
//     }
//   }, [partsData, jobCode]);

//   useEffect(() => {
//     if (claimStatus) {
//       getInsurer();
//       getSurvivor();
//     }
//   }, [claimStatus]);

//   const getSurvivor = (searchString = "") => {
//     const payload = {
//       module: "customers",
//       column: "phone",
//       fields: ["contacts{phone}"],
//       size: 50,
//       searchColumns: ["contacts", "name"],
//       searchString: searchString,
//     };
//     platformApi.post("/api/options/get", payload).then((res) => {
//       setSurvivorList(res.data.response);
//     });
//   };

//   const getInsurer = () => {
//     platformApi.get("/api/insurance").then((res) => {
//       const result = res.data.response.data;
//       setInsurerList(result);
//     });
//   };

//   const getJobCodes = () => {
//     platformApi
//       .get("/api/jobCode/")
//       .then((res) => {
//         const { data } = res;
//         if (data.code === 200) {
//           setJobCode(data.response.data);
//         }
//       })
//       .catch((err) => {
//         console.error("JobCode Fetch Error: ", err);
//         message.error("Couldn't Fetch JobCodes");
//       });
//   };

//   const getParts = () => {
//     // platformApi
//     //     .post(`/api/sparesInventory/branch/get`, {
//     //         page: 1,
//     //         size: 100,
//     //         searchString: ""
//     //     })
//     //     .then((res) => {
//     //         const { data } = res;
//     //         if (data.code === 200) {
//     //             const { response } = data;
//     //             if (response.code === 200) {
//     //                 let parts = []
//     //                 for (let i = 0; i < response.data.length; i++) {
//     //                     const element = response.data[i];
//     //                     if (element.phyQuantity > 0) {
//     //                         parts.push(element.partNo)
//     //                     }
//     //                 }
//     //                 setPartsData(parts)
//     //             }
//     //         }
//     //         else {
//     //             message.error("Unable to fetch Parts", 2);
//     //         }
//     //     })
//     //     .catch((error) => {
//     //         console.error("Error on Parts Master : ", error);
//     //         message.error("Unable to fetch Parts", 2);
//     //     });
//     let data = {
//       module: "partsMasters",
//       size: 100,
//       column: "partNumber",
//       fields: ["partNumber", "partName"],
//     };
//     platformApi
//       .post("/api/options/get", data)
//       .then((res) => {
//         const { data } = res;
//         setPartsData(data.response);
//       })
//       .catch((err) => {
//         console.error("Part Fetch Error: ", err);
//         message.error("Couldn't Fetch Parts");
//       });
//   };

//   const getJobOrder = (value) => {
//     setFieldsValue({
//       JobNo: value,
//     });
//     let grandTotal = 0;
//     let TotalCgst = 0;
//     let TotalSgst = 0;
//     let TotalIgst = 0;
//     let pCharge = 0;
//     let labourCharge = 0;
//     let consumableCharge = 0;
//     let estTotal = 0;
//     let temp = 0;
//     platformApi
//       .get("/api/materialIssue/jobMaterial/" + value)
//       .then((resp) => {
//         let { data } = resp;
//         if (data.code === 200) {
//           let { response } = data;
//           if (response.code === 200) {
//             if (response.data) {
//               let partItemList = [];
//               if (response.data.length && response.data[0].parts) {
//                 for (let i = 0; i < response.data.length; i++) {
//                   const element = response.data[i];
//                   partItemList.push(...element.parts);
//                 }
//                 // partItemList = [...response.data[0].parts]
//               } else {
//                 message.info("No Materials in this JobOrder");
//               }
//               for (let i = 0; i < partItemList.length; i++) {
//                 const item = { ...partItemList[i].part };
//                 if (
//                   !dataTemp.some(
//                     (tempItem) => item.partNumber === tempItem.value
//                   )
//                 ) {
//                   platformApi.get("/api/partsMaster/" + item.id).then((res) => {
//                     let { data } = res;
//                     if (data.code === 200) {
//                       let { response } = data;
//                       if (response.code === 200) {
//                         const temp = {
//                           label: `${response.data.partNumber} - ${response.data.partName}`,
//                           value: response.data.partNumber,
//                           id: response.data.id,
//                         };
//                         setDataTemp([...dataTemp, temp]);
//                       }
//                     }
//                   });
//                 }

//                 partItemList[i].partNumber = item;
//                 partItemList[i].partNumber.partName = partItemList[i].partName;
//                 partItemList[i].hsn = item.hsn;
//                 partItemList[i].cgst = item.hsn && item.hsn.cgst;
//                 partItemList[i].sgst = item.hsn && item.hsn.sgst;
//                 partItemList[i].igst = item.hsn && item.hsn.igst;
//                 partItemList[i].gstRate = item.hsn && item.hsn.igst;
//                 // partItemList[i].quantity = partItemList[i].quantity
//                 partItemList[i].unitRate = partItemList[i].mrp;
//                 partItemList[i].rate =
//                   partItemList[i].quantity * partItemList[i].unitRate;
//                 partItemList[i].sgstAmount = parseFloat(
//                   (partItemList[i].sgst / 100) * partItemList[i].rate
//                 ).toFixed(2);
//                 partItemList[i].igstAmount = parseFloat(
//                   (partItemList[i].igst / 100) * partItemList[i].rate
//                 ).toFixed(2);
//                 partItemList[i].cgstAmount = parseFloat(
//                   (partItemList[i].cgst / 100) * partItemList[i].rate
//                 ).toFixed(2);

//                 setSelectedPart(item.partNumber);

//                 let total = parseFloat(partItemList[i].rate);
//                 // let finTotal = parseFloat(partItemList[i].rate)
//                 // let gstRateValue = (partItemList[i].gstRate / 100) + parseInt(1);
//                 // taxExlusive = (total * (partItemList[i].gstRate / 100)).toFixed(2);
//                 // total = (parseFloat(total) + parseFloat(taxExlusive)).toFixed(2);
//                 // partItemList[i].grandTotal = finTotal

//                 partItemList[i].grandTotal = total;
//                 if (partItemList[i].gstRate === GST28) {
//                   setGSTRate28(true);
//                 }
//                 if (partItemList[i].gstRate === GST18) {
//                   setGSTRate18(true);
//                 }
//                 if (partItemList[i].gstRate === GST12) {
//                   setGSTRate12(true);
//                 }
//                 if (partItemList[i].gstRate === GST5) {
//                   setGSTRate5(true);
//                 }
//               }
//               let updateItemList = [...partItemList];

//               for (let i = 0; i < updateItemList.length; i++) {
//                 grandTotal =
//                   parseFloat(grandTotal) +
//                   parseFloat(updateItemList[i].grandTotal);
//                 grandTotal = grandTotal.toFixed(2);
//                 estTotal =
//                   parseFloat(estTotal) +
//                   parseFloat(updateItemList[i].grandTotal);
//                 estTotal = estTotal.toFixed(0);
//                 TotalCgst =
//                   parseFloat(TotalCgst) +
//                   parseFloat(updateItemList[i].cgstAmount);
//                 TotalCgst = TotalCgst.toFixed(2);
//                 TotalSgst =
//                   parseFloat(TotalSgst) +
//                   parseFloat(updateItemList[i].sgstAmount);
//                 TotalSgst = TotalSgst.toFixed(2);
//                 TotalIgst =
//                   parseFloat(TotalIgst) +
//                   parseFloat(updateItemList[i].igstAmount);
//                 TotalIgst = TotalIgst.toFixed(2);

//                 if (updateItemList[i].rate) {
//                   if (
//                     updateItemList[i].partNumber.code ||
//                     updateItemList[i].jobCode
//                   ) {
//                     if (
//                       updateItemList[i].partNumber?.consumable ||
//                       updateItemList[i].jobCode?.consumable
//                     ) {
//                       consumableCharge =
//                         parseFloat(consumableCharge) +
//                         parseFloat(updateItemList[i].rate);
//                     } else {
//                       labourCharge =
//                         parseFloat(labourCharge) +
//                         parseFloat(updateItemList[i].rate);
//                     }
//                   } else if (updateItemList[i].partNumber.hsn) {
//                     pCharge =
//                       parseFloat(pCharge) + parseFloat(updateItemList[i].rate);
//                   }
//                 }
//                 let roundoff = String(grandTotal).split(".");
//                 if (roundoff[1] === "00") {
//                   temp = "0.00";
//                 } else if (parseInt(roundoff[1]) >= 50) {
//                   temp = 100 - parseInt(roundoff[1]);
//                   temp = `+0.${temp}`;
//                 } else if (parseInt(roundoff[1]) < 50) {
//                   temp = 100 - parseInt(roundoff[1]);
//                   temp = `-0.${parseInt(roundoff[1])}`;
//                 }
//               }
//               form.setFieldsValue({
//                 grantTotal: estTotal,
//                 totalInvoice: estTotal,
//                 partCharge: pCharge,
//                 labourCharge: labourCharge,
//                 consumableCharge: consumableCharge,
//                 cgst: TotalCgst,
//                 sgst: TotalSgst,
//                 igst: TotalIgst,
//                 roundoff: temp,
//               });
//               // setGrandTotal(grandTotal);
//               // setTotalInvoice(estTotal);
//               // setInitialData(updateItemList)
//               setItemList((prev) => {
//                 // build newItemList based on prev, not on a possibly stale closure
//                 const existingItems = prev.filter(
//                   (item) =>
//                     item.partNumber &&
//                     (item.partNumber.partNumber ||
//                       item.partNumber.code ||
//                       item.jobCode)
//                 );
//                 const updatedList = [
//                   ...existingItems,
//                   ...updateItemList,
//                   { ...partItemData, id: getUUID() },
//                 ];
//                 return updatedList;
//               });
//             }
//           }
//         }
//       })
//       .catch((error) => {
//         message.error("Unable to get Materials");
//         console.error("Error on get Materials : ", error);
//       });
//     platformApi.get("/api/jobOrder/" + value).then((res) => {
//       let { data } = res;
//       if (data.code === 200) {
//         let { response } = data;
//         if (response.code === 200) {
//           if (response.data) {
//             setVehicleDetail(response.data.vehicle);
//             setStateName(
//               response.data.customer && response.data.customer.GSTNo
//             );
//             setPBranch(response.data.branch && response.data.branch.id);
//             setJobNo([...jobNo, response.data]);
//             setModel(
//               response.data.vehicle && response.data.vehicle?.vehicle.id
//             );
//             form.setFieldsValue({
//               branch: response.data.branch?.name,
//             });
//           }
//         }
//       }
//     });
//     // getJobNo();
//   };
//   //itemList
//   useEffect(() => {
//     // Only add new row if the last item has data
//     if (
//       itemList &&
//       itemList?.length > 0 &&
//       (itemList[itemList?.length - 1].partNumber?.partNumber ||
//         itemList[itemList?.length - 1].partNumber?.code ||
//         itemList[itemList?.length - 1].quantity?.length > 0) &&
//       !itemList[itemList?.length - 1].isFromCsv // Add this check
//     ) {
//       handleAdd();
//     }
//     const selectItem = {};
//     if (itemList && Array.isArray(itemList)) {
//       for (const item of itemList) {
//         if (item && item.partNumber && item.partNumber.id) {
//           selectItem[item.partNumber.id] = item.partNumber;
//         }
//       }
//     }
//     setSelectItemObj(selectItem);
//   }, [itemList]);

//   //Quantity
//   useEffect(() => {
//     let num = 0;
//     let newItemList = [...itemList];
//     if (unitRate > 0 && quantity > 0) {
//       if (newItemList.length > 0) {
//         for (let i = 0; i < newItemList.length; i++) {
//           if (newItemList[i].quantity > 0 && newItemList[i].unitRate > 0) {
//             newItemList[i].rate = (
//               parseFloat(newItemList[i].quantity) *
//               parseFloat(newItemList[i].unitRate)
//             ).toFixed(2);
//             newItemList[i].sgstAmount = parseFloat(
//               (newItemList[i].sgst / 100) * newItemList[i].rate
//             ).toFixed(2);
//             newItemList[i].igstAmount = parseFloat(
//               (newItemList[i].igst / 100) * newItemList[i].rate
//             ).toFixed(2);
//             newItemList[i].cgstAmount = parseFloat(
//               (newItemList[i].cgst / 100) * newItemList[i].rate
//             ).toFixed(2);
//             sgstAmt = newItemList[i].sgstAmount;
//             cgstAmt = newItemList[i].cgstAmount;
//             igstAmt = newItemList[i].igstAmount;
//           }
//         }
//       }
//       setSGSTAmount(sgstAmt);
//       setIGSTAmount(igstAmt);
//       setCGSTAmount(cgstAmt);
//       setItemList(newItemList);
//       setquantity(undefined);
//       // setUnitRate(undefined)
//     }
//   }, [unitRate, quantity]);

//   //PMC
//   useEffect(() => {
//     let grandTotal = 0;
//     let TotalCgst = 0;
//     let TotalSgst = 0;
//     let TotalIgst = 0;
//     let pCharge = 0;
//     let taxExlusive = 0;
//     let labourCharge = 0;
//     let consumableCharge = 0;
//     let estTotal = 0;
//     let temp = 0;
//     if (recPart === "yes") {
//       const jobId = jobNo.filter((item) => {
//         return item.id === getFieldValue("JobNo");
//       });
//       if (jobId.length) {
//         platformApi
//           .post("/api/pmc/getCodes", {
//             model: jobId[0].vehicle?.vehicle?.id,
//             kms: jobId[0].kms,
//             serviceNo: jobId[0].serviceNo,
//             serviceType: jobId[0].serviceType,
//           })
//           .then((res) => {
//             let { data } = res;
//             if (data.code === 200) {
//               let { response } = data;
//               if (response.code === 200) {
//                 if (
//                   response.data.length &&
//                   (response.data[0].jobCodes.length ||
//                     response.data[0].partsConsumable.length)
//                 ) {
//                   let jobCodeItemList = [];
//                   let partItemList = [];
//                   if (response.data[0].jobCodes) {
//                     jobCodeItemList = [...response.data[0].jobCodes];
//                   }
//                   if (response.data[0].partsConsumable) {
//                     partItemList = [...response.data[0].partsConsumable];
//                   }

//                   for (let i = 0; i < partItemList.length; i++) {
//                     const item = { ...partItemList[i].partNumber };
//                     if (
//                       !dataTemp.some(
//                         (tempItem) => item.partNumber === tempItem.value
//                       )
//                     ) {
//                       platformApi
//                         .get("/api/partsMaster/" + item.id)
//                         .then((res) => {
//                           let { data } = res;
//                           if (data.code === 200) {
//                             let { response } = data;
//                             if (response.code === 200 && response.data && response.data.id) {
//                               const temp = {
//                                 label: `${response.data.partNumber} - ${response.data.partName}`,
//                                 value: response.data.partNumber,
//                                 id: response.data.id,
//                               };
//                               setDataTemp([...dataTemp, temp]);
//                             }
//                           }
//                         });
//                     }
//                     partItemList[i].partNumber = item.partNumber;
//                     partItemList[i].hsn = item.hsn;
//                     partItemList[i].cgst = item.hsn && item.hsn.cgst;
//                     partItemList[i].sgst = item.hsn && item.hsn.sgst;
//                     partItemList[i].igst = item.hsn && item.hsn.igst;
//                     partItemList[i].gstRate = item.hsn && item.hsn.igst;
//                     partItemList[i].unitRate = item.mrp ? item.mrp : 1;
//                     partItemList[i].rate =
//                       partItemList[i].quantity * partItemList[i].unitRate;
//                     partItemList[i].sgstAmount = parseFloat(
//                       (partItemList[i].sgst / 100) * partItemList[i].rate
//                     ).toFixed(2);
//                     partItemList[i].igstAmount = parseFloat(
//                       (partItemList[i].igst / 100) * partItemList[i].rate
//                     ).toFixed(2);
//                     partItemList[i].cgstAmount = parseFloat(
//                       (partItemList[i].cgst / 100) * partItemList[i].rate
//                     ).toFixed(2);
//                     setSelectedPart(item.partNumber);
//                     // setUnitRate(item.mrp)

//                     let total = parseFloat(partItemList[i].rate);
//                     let finTotal = parseFloat(partItemList[i].rate);
//                     let gstRateValue =
//                       partItemList[i].gstRate / 100 + parseInt(1);
//                     taxExlusive = (
//                       total *
//                       (partItemList[i].gstRate / 100)
//                     ).toFixed(2);
//                     total = (
//                       parseFloat(total) + parseFloat(taxExlusive)
//                     ).toFixed(2);

//                     // partItemList[i].grandTotal = total
//                     partItemList[i].grandTotal = finTotal;
//                     if (partItemList[i].gstRate === GST28) {
//                       setGSTRate28(true);
//                     }
//                     if (partItemList[i].gstRate === GST18) {
//                       setGSTRate18(true);
//                     }
//                     if (partItemList[i].gstRate === GST12) {
//                       setGSTRate12(true);
//                     }
//                     if (partItemList[i].gstRate === GST5) {
//                       setGSTRate5(true);
//                     }

//                     // setSGSTAmount(sgstAmt)
//                     // setIGSTAmount(igstAmt)
//                     // setCGSTAmount(cgstAmt)
//                   }

//                   for (let j = 0; j < jobCodeItemList.length; j++) {
//                     jobCodeItemList[j].partNumber = { ...jobCodeItemList[j] };
//                     jobCodeItemList[j].hsn = jobCodeItemList[j].jobCode?.sac;
//                     jobCodeItemList[j].cgst =
//                       jobCodeItemList[j].jobCode?.sac?.cgst;
//                     jobCodeItemList[j].sgst =
//                       jobCodeItemList[j].jobCode?.sac?.sgst;
//                     jobCodeItemList[j].igst =
//                       jobCodeItemList[j].jobCode?.sac?.igst;
//                     jobCodeItemList[j].gstRate =
//                       (jobCodeItemList[j].jobCode?.sac?.cgst || 0) +
//                       (jobCodeItemList[j].jobCode?.sac?.sgst || 0);
//                     (jobCodeItemList[j].unitRate =
//                       jobCodeItemList[j]?.jobCode?.vehicleModel?.[0]?.price),
//                       setSelectedPart(jobCodeItemList[j].jobCode?.code);
//                     jobCodeItemList[j].rate = (
//                       parseFloat(jobCodeItemList[j].quantity) *
//                       parseFloat(jobCodeItemList[j].unitRate)
//                     ).toFixed(2);
//                     jobCodeItemList[j].sgstAmount = parseFloat(
//                       (jobCodeItemList[j].sgst / 100) * jobCodeItemList[j].rate
//                     ).toFixed(2);
//                     jobCodeItemList[j].igstAmount = parseFloat(
//                       (jobCodeItemList[j].igst / 100) * jobCodeItemList[j].rate
//                     ).toFixed(2);
//                     jobCodeItemList[j].cgstAmount = parseFloat(
//                       (jobCodeItemList[j].cgst / 100) * jobCodeItemList[j].rate
//                     ).toFixed(2);

//                     let total = parseFloat(jobCodeItemList[j].rate);

//                     // let gstRateValue = (jobCodeItemList[j].gstRate / 100) + parseInt(1);
//                     // taxExlusive = (total * (jobCodeItemList[j].gstRate / 100)).toFixed(2);
//                     // total = (parseFloat(total) + parseFloat(taxExlusive)).toFixed(2);

//                     total =
//                       total +
//                       parseFloat((jobCodeItemList[j].gstRate / 100) * total);

//                     jobCodeItemList[j].grandTotal = total;

//                     if (jobCodeItemList[j].gstRate === GST28) {
//                       setGSTRate28(true);
//                     }
//                     if (jobCodeItemList[j].gstRate === GST18) {
//                       setGSTRate18(true);
//                     }
//                     if (jobCodeItemList[j].gstRate === GST12) {
//                       setGSTRate12(true);
//                     }
//                     if (jobCodeItemList[j].gstRate === GST5) {
//                       setGSTRate5(true);
//                     }
//                   }
//                   let updateItemList = [...partItemList, ...jobCodeItemList];

//                   for (let i = 0; i < updateItemList.length; i++) {
//                     grandTotal =
//                       parseFloat(grandTotal) +
//                       parseFloat(updateItemList[i].grandTotal);
//                     grandTotal = grandTotal.toFixed(2);
//                     estTotal =
//                       parseFloat(estTotal) +
//                       parseFloat(updateItemList[i].grandTotal);
//                     TotalCgst =
//                       parseFloat(TotalCgst) +
//                       parseFloat(updateItemList[i].cgstAmount);
//                     TotalCgst = TotalCgst.toFixed(2);
//                     TotalSgst =
//                       parseFloat(TotalSgst) +
//                       parseFloat(updateItemList[i].sgstAmount);
//                     TotalSgst = TotalSgst.toFixed(2);
//                     TotalIgst =
//                       parseFloat(TotalIgst) +
//                       parseFloat(updateItemList[i].igstAmount);
//                     TotalIgst = TotalIgst.toFixed(2);

//                     if (updateItemList[i].rate) {
//                       if (
//                         updateItemList[i].partNumber?.code ||
//                         updateItemList[i].jobCode
//                       ) {
//                         if (
//                           updateItemList[i].partNumber?.consumable ||
//                           updateItemList[i].jobCode?.consumable
//                         ) {
//                           consumableCharge =
//                             parseFloat(consumableCharge) +
//                             parseFloat(updateItemList[i].rate);
//                         } else {
//                           labourCharge =
//                             parseFloat(labourCharge) +
//                             parseFloat(updateItemList[i].rate);
//                         }
//                       } else if (updateItemList[i].partNumber?.hsn) {
//                         pCharge =
//                           parseFloat(pCharge) +
//                           parseFloat(updateItemList[i].rate);
//                       }
//                     }
//                     // setGrandTotal(grandTotal);
//                   }
//                   let roundoff = String(grandTotal).split(".");
//                   if (roundoff[1] === "00") {
//                     temp = "0.00";
//                   } else if (parseInt(roundoff[1]) >= 50) {
//                     temp = 100 - parseInt(roundoff[1]);
//                     temp = `+0.${temp}`;
//                   } else if (parseInt(roundoff[1]) < 50) {
//                     temp = 100 - parseInt(roundoff[1]);
//                     temp = `-0.${parseInt(roundoff[1])}`;
//                   }

//                   form.setFieldsValue({
//                     totalAmount: estTotal,
//                     cgst: TotalCgst,
//                     sgst: TotalSgst,
//                     igst: TotalIgst,
//                     partCharge: pCharge,
//                     labourCharge: labourCharge,
//                     consumableCharge: consumableCharge,
//                     roundoff: temp,
//                   });
//                   setItemList((prev) => {
//                     // build newItemList based on prev, not on a possibly stale closure
//                     const existingItems = prev.filter(
//                       (item) =>
//                         item.partNumber &&
//                         (item.partNumber.partNumber ||
//                           item.partNumber.code ||
//                           item.jobCode)
//                     );
//                     const updatedList = [
//                       ...existingItems,
//                       ...updateItemList,
//                       { ...partItemData, id: getUUID() },
//                     ];
//                     return updatedList;
//                   });
//                 } else {
//                   message.info("No Recommended Parts and Job Codes");
//                 }
//               } else {
//                 message.error("No Recommended Parts and Job Codes");
//               }
//             } else {
//               message.error("No Recommended Parts and Job Codes");
//             }
//           })
//           .catch((error) => {
//             console.error("Error on PMC : ", error);
//             message.error("Failed to fetch Parts and Job Codes");
//           });
//       }
//     }
//   }, [recPart]);

//   //Discount
//   useEffect(() => {
//     let val = 0;
//     let discountedPrice = 0;
//     let newItemList = [...itemList];
//     // Transaction level Dicount Calculation
//     if (discountLevel === "TransactionLevel") {
//       for (let i = 0; i < newItemList.length; i++) {
//         let total = parseFloat(
//           newItemList[i].unitRate * newItemList[i].quantity
//         );
//         let gstRateValue = newItemList[i].gstRate / 100 + parseInt(1);
//         if (
//           discountAmount > 0 &&
//           newItemList[i].unitRate > 0 &&
//           newItemList[i].quantity
//         ) {
//           if (discountType === "percent") {
//             discountedPrice = (parseFloat(discountAmount) / 100) * total;
//             val = val + discountedPrice;
//             val = Math.round(val);
//             setTotalDiscount(val || 0);
//             setFieldsValue({
//               totalDiscount: val,
//             });
//           } else if (discountType === "rupee") {
//             val = val + parseFloat(discountAmount);
//             setTotalDiscount(val || 0);
//             setFieldsValue({
//               totalDiscount: val,
//             });
//           }
//         }
//       }
//     }
//     // Item level Discount calculation
//     if (discountLevel === "ItemLevel") {
//       for (let i = 0; i < newItemList.length; i++) {
//         let total = newItemList[i].unitRate * newItemList[i].quantity;
//         let gstRateValue = newItemList[i].gstRate / 100 + parseInt(1);
//         if (newItemList[i].discount > 0) {
//           if (discountType === "percent") {
//             discountedPrice =
//               (parseFloat(newItemList[i].discount) / 100) * total;
//             val = val + discountedPrice;
//             setTotalDiscount(val || 0);
//             setFieldsValue({
//               totalDiscount: val,
//             });
//           } else if (discountType === "rupee") {
//             val = val + parseFloat(newItemList[i].discount);
//             setTotalDiscount(val || 0);
//             setFieldsValue({
//               totalDiscount: val,
//             });
//           }
//         }
//       }
//     }
//     setItemList(newItemList);
//   }, [
//     discountLevel,
//     discountAmount,
//     discountType,
//     discount,
//     quantity,
//     unitRate,
//     rate,
//     grandTtl,
//   ]);

//   const addCustomerData = (customer) => {
//     platformApi
//       .post("/api/customer", customer)
//       .then((result) => {
//         const { data } = result;
//         if (data.code === 200) {
//           const { response } = data;
//           if (response.code === 200) {
//             setSurvivorList([...survivorList, response.data]);
//             message.success("Customer added successfully", 2);
//           } else {
//             message.error("Unable to add customer", 2);
//           }
//         } else if (data.code === 500 && data.err.code === 500) {
//           message.error("Customer name already exists", 2);
//         } else {
//           message.error("Unable to add customer", 2);
//         }
//       })
//       .catch((error) => {
//         message.error("Unable to add customer", 2);
//         console.error("Error on customer : ", error);
//       });
//   };

//   //Render Column
//   const renderColumns = () => {
//     const columns = [
//       {
//         title: "S.No",
//         dataIndex: "sno",
//         key: "sno",
//         width: 80,
//         render: (text, record, index) => (
//           <Form.Item>
//             <span>{index + 1}</span>
//           </Form.Item>
//         ),
//       },
//       {
//         title: "Details",
//         dataIndex: "partNumber",
//         key: "partNumber",
//         width: 300,
//         render: (record, data, key) => (
//           <Form.Item>
//             <Select
//               dropdownStyle={{
//                 overflowY: "auto",
//                 overflowX: "hidden",
//               }}
//               onChange={(event) => {
//                 handlePartDetail(event, data);
//               }}
//               onSearch={async (event) => {
//                 const search = {
//                   module: "partsMasters",
//                   column: "partNumber",
//                   searchString: event,
//                   searchColumns: ["partNumber", "partName"],
//                   setValue: setPartsData,
//                 };
//                 searchParts(search);
//                 const searchjobCode = {
//                   module: "jobCodes",
//                   column: "code",
//                   searchString: event,
//                   searchColumns: ["code"],
//                   setValue: setJobCode,
//                 };
//                 searchJobCode(searchjobCode);
//                 if (dataTemp?.length === 1) {
//                   handlePartDetail(dataTemp[0].value, data);
//                   partsRef[key].focus();
//                 }
//               }}
//               value={
//                 record?.partNumber == undefined
//                   ? record?.code
//                     ? record.code
//                     : record?.jobCode
//                       ? record.jobCode.code
//                       : "Part Number"
//                   : `${record.partNumber} - ${record.partName}`
//               }
//               disabled={editable}
//               showSearch
//               showAction={["click", "focus"]}
//               placeholder="Part Number/Job Code"
//             // filterOption={(input, option) =>
//             //     option.props.children.some(
//             //         (child) => child.toLowerCase().indexOf(input.toLowerCase()) >= 0
//             //     )
//             // }
//             >
//               {dataTemp.map((part) => {
//                 if (part.id in selectItemObj) return null;
//                 return (
//                   <Select.Option key={part.id} value={part.value}>
//                     {part.label}
//                   </Select.Option>
//                 );
//               })}
//             </Select>
//           </Form.Item>
//         ),
//       },
//       serviceType === "Accidental" && {
//         title: "Image",
//         dataIndex: "image",
//         key: "image",
//         width: 130,
//         render: (text, record, index) => {
//           const handleImageUpload = async (info) => {
//             if (!info.file) return;

//             const formData = new FormData();
//             formData.append("profile", info.file);
//             formData.append("master", "Transaction Master");
//             formData.append("module", "Job Order");

//             try {
//               const response = await platformApi.post(
//                 "/api/upload/image",
//                 formData
//               );
//               const imageUrl = response.data?.response?.data?.Location;

//               if (imageUrl) {
//                 const newItemList = [...itemList];
//                 newItemList[index] = {
//                   ...newItemList[index],
//                   imageUrl: imageUrl,
//                 };
//                 setItemList((prev) => {
//                   // build newItemList based on prev, not on a possibly stale closure
//                   const updatedList = [...prev];
//                   updatedList[index] = {
//                     ...updatedList[index],
//                     imageUrl: imageUrl,
//                   };
//                   return updatedList;
//                 });
//                 message.success("Image uploaded successfully");
//               }
//             } catch (error) {
//               console.error("Image upload failed:", error);
//               message.error("Failed to upload image");
//             }
//           };

//           return (
//             <Form.Item>
//               {record.imageUrl ? (
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "8px" }}
//                 >
//                   <img
//                     src={record.imageUrl}
//                     alt="Part"
//                     style={{
//                       width: "50px",
//                       height: "50px",
//                       objectFit: "cover",
//                     }}
//                   />
//                   <Upload
//                     showUploadList={false}
//                     beforeUpload={() => false}
//                     onChange={handleImageUpload}
//                     disabled={
//                       editable || serviceType.toLowerCase() !== "accidental"
//                     }
//                   >
//                     <Button type="link">Change</Button>
//                   </Upload>
//                 </div>
//               ) : (
//                 <Upload
//                   showUploadList={false}
//                   beforeUpload={() => false}
//                   onChange={handleImageUpload}
//                   disabled={
//                     editable || serviceType.toLowerCase() !== "accidental"
//                   }
//                 >
//                   <Button
//                     disabled={
//                       editable || serviceType.toLowerCase() !== "accidental"
//                     }
//                   >
//                     Upload Image
//                   </Button>
//                 </Upload>
//               )}
//             </Form.Item>
//           );
//         },
//       },
//       {
//         title: "Quantity",
//         dataIndex: "quantity",
//         key: "quantity",
//         width: 100,
//         render: (data, record, index) => (
//           <Form.Item>
//             <Input
//               key="quantity"
//               disabled={editable}
//               onChange={(event) => {
//                 handlequantity(event, record);
//               }}
//               ref={(el) => (partsRef[index] = el)}
//               placeholder="quantity"
//               value={record && record.quantity}
//             />
//           </Form.Item>
//         ),
//       },
//       {
//         title: "Unit rate",
//         dataIndex: "unitRate",
//         key: "unitRate",
//         width: 100,
//         render: (data, record, index) => (
//           <Form.Item>
//             <Input
//               key="unitRate"
//               disabled={editable}
//               onChange={(event) => {
//                 handleUnitrate(event, record);
//               }}
//               placeholder="Unit Rate"
//               value={record && record.unitRate}
//             />
//           </Form.Item>
//         ),
//       },
//       {
//         title: "Amount",
//         dataIndex: "rate",
//         key: "rate",
//         width: 120,
//         render: (data, record) => (
//           <Form.Item>
//             <Input
//               key="rate"
//               disabled={editable}
//               placeholder="Amount"
//               value={record && record.quantity * record.unitRate}
//             />
//           </Form.Item>
//         ),
//       },
//       {
//         title: "GST%",
//         dataIndex: "gstRate",
//         key: "gstRate",
//         width: 120,
//         render: (data, record) => (
//           <Form.Item>
//             <span>{record && record.igst}</span>
//           </Form.Item>
//         ),
//       },
//       {
//         title: "Discount",
//         dataIndex: "discount",
//         key: "discount",
//         width: 100,
//         render: (data, record) => (
//           <Form.Item>
//             <Input
//               key="discount"
//               onChange={(event) => {
//                 handleDiscount(event, record);
//               }}
//               disabled={editable}
//               placeholder="Discount"
//               value={record && record.discount}
//             />
//           </Form.Item>
//         ),
//       },
//       {
//         title: "Action",
//         dataIndex: "remove",
//         key: "x",
//         width: 100,
//         render: (data, record) => (
//           <Form.Item>
//             {itemList.length > 1 ? (
//               <Popconfirm
//                 title="Sure to delete?"
//                 onConfirm={() => {
//                   handleDelete(record.id);
//                 }}
//               >
//                 <a style={{ color: "#6c7b8a" }}>Delete</a>
//               </Popconfirm>
//             ) : (
//               <a style={{ color: "#ccc", cursor: "not-allowed" }}>Delete</a>
//             )}
//           </Form.Item>
//         ),
//       },
//     ].filter(Boolean);


//     return columns.filter((col) =>
//       discountLevel === "TransactionLevel" ? col.dataIndex !== "discount" : col
//     );
//   };

//   //Handle PartDetail
//   const handlePartDetail = async (event, data) => {
//     setSelectedPart(event);
//     const newItemList = [...itemList];
//     if (event !== undefined) {
//       partsData.map((part) => {
//         if (part.partNumber === event) {
//           for (let item of newItemList) {
//             if (item.id === data.id) {
//               (item.partNumber = part),
//                 (item.value = part),
//                 (item.hsn = part.hsn),
//                 (item.cgst = part.hsn.cgst);
//               item.igst = part.hsn.igst;
//               item.sgst = part.hsn.sgst;
//               item.gstRate = part.hsn.cgst + part.hsn.sgst;
//               item.unitRate = part.mrp;
//               item.quantity = 1;
//               setquantity(1);
//               setUnitRate(part.mrp);
//               if (item.gstRate === GST18) {
//                 setGSTRate18(true);
//               }
//               if (item.gstRate === GST28) {
//                 setGSTRate28(true);
//               }
//               if (item.gstRate === GST12) {
//                 setGSTRate12(true);
//               }
//               if (item.gstRate === GST5) {
//                 setGSTRate5(true);
//               }
//               setCGST(part.hsn.cgst),
//                 setSGST(part.hsn.sgst),
//                 setIGST(part.hsn.igst);
//             }
//           }
//         }
//       });
//       jobCode.map((part) => {
//         if (part.code === event) {
//           for (let item of newItemList) {
//             if (item.id === data.id) {
//               (item.partNumber = part),
//                 (item.hsn = part.sac),
//                 (item.cgst = part.sac.cgst);
//               item.igst = part.sac.igst;
//               item.sgst = part.sac.sgst;
//               item.gstRate = part.sac.cgst + part.sac.sgst;
//               let price = part.vehicleModel.filter(
//                 (item) => item.vehicle.id === model
//               );
//               item.unitRate = price.length && price[0].price;
//               // item.unitRate = part.vehicleModel[0].price
//               item.quantity = 1;
//               setquantity(1);
//               setUnitRate(price.length && price[0].price);
//               if (item.gstRate === GST18) {
//                 setGSTRate18(true);
//               }
//               if (item.gstRate === GST28) {
//                 setGSTRate28(true);
//               }
//               if (item.gstRate === GST12) {
//                 setGSTRate12(true);
//               }
//               if (item.gstRate === GST5) {
//                 setGSTRate5(true);
//               }
//               setCGST(part.sac.cgst),
//                 setSGST(part.sac.sgst),
//                 setIGST(part.sac.igst);
//             }
//           }
//         }
//       });
//     }
//     setItemList(newItemList);
//     getParts();
//     getJobCodes();
//   };

//   //Calculation
//   useEffect(() => {
//     if (discountLevel === "TransactionLevel") {
//       calculateTransactionTax();
//     } else if (discountLevel === "ItemLevel") {
//       calculateItemTax();
//     }
//   }, [editable, discountLevel]);

//   //TranscationMax
//   const calculateTransactionTax = () => {
//     let taxExclusive = 0;
//     let taxInclusive = 0;
//     let newItemList = [...itemList];
//     let grandTotal = 0;
//     let TotalCgst = 0;
//     let TotalSgst = 0;
//     let TotalIgst = 0;
//     let pCharge = 0;
//     let labourCharge = 0;
//     let consumableCharge = 0;
//     let estTotal = 0;
//     let temp = 0;

//     for (let i = 0; i < newItemList.length; i++) {
//       if (newItemList[i].rate > 0 && newItemList[i].gstRate > 0) {
//         let total = parseFloat(newItemList[i].rate);
//         let gstRateValue = newItemList[i].gstRate / 100 + parseInt(1);
//         if (
//           !newItemList[i].partNumber.partNumber ||
//           newItemList[i].partNumber.sac
//         ) {
//           taxExclusive = (total * (newItemList[i].gstRate / 100)).toFixed(2);
//           if (totalDiscount > 0 && !isNaN(totalDiscount)) {
//             if (discountType === "percent") {
//               total = total - total * (parseFloat(discountAmount) / 100);
//               newItemList[i].sgstAmount = parseFloat(
//                 (newItemList[i].sgst / 100) * newItemList[i].rate
//               ).toFixed(2);
//               newItemList[i].igstAmount = parseFloat(
//                 (newItemList[i].igst / 100) * newItemList[i].rate
//               ).toFixed(2);
//               newItemList[i].cgstAmount = parseFloat(
//                 (newItemList[i].cgst / 100) * newItemList[i].rate
//               ).toFixed(2);
//               sgstAmt = newItemList[i].sgstAmount;
//               cgstAmt = newItemList[i].cgstAmount;
//               igstAmt = newItemList[i].igstAmount;
//             } else {
//               total = total - parseFloat(discountAmount);
//               newItemList[i].sgstAmount = parseFloat(
//                 (newItemList[i].sgst / 100) * newItemList[i].rate
//               ).toFixed(2);
//               newItemList[i].igstAmount = parseFloat(
//                 (newItemList[i].igst / 100) * newItemList[i].rate
//               ).toFixed(2);
//               newItemList[i].cgstAmount = parseFloat(
//                 (newItemList[i].cgst / 100) * newItemList[i].rate
//               ).toFixed(2);
//               sgstAmt = newItemList[i].sgstAmount;
//               cgstAmt = newItemList[i].cgstAmount;
//               igstAmt = newItemList[i].igstAmount;
//             }
//             total = total + parseFloat((newItemList[i].gstRate / 100) * total);
//             setSGSTAmount(sgstAmt);
//             setIGSTAmount(igstAmt);
//             setCGSTAmount(cgstAmt);
//             newItemList[i].grandTotal = total;
//           }
//           // calculate tax for labout charge || consumable charge
//           else {
//             // total = (parseFloat(total) + parseFloat(taxExlusive)).toFixed(2);
//             total = total + parseFloat((newItemList[i].gstRate / 100) * total);
//             newItemList[i].sgstAmount = parseFloat(
//               (newItemList[i].sgst / 100) * parseFloat(newItemList[i].rate)
//             ).toFixed(2);
//             newItemList[i].igstAmount = parseFloat(
//               (newItemList[i].igst / 100) * parseFloat(newItemList[i].rate)
//             ).toFixed(2);
//             newItemList[i].cgstAmount = parseFloat(
//               (newItemList[i].cgst / 100) * parseFloat(newItemList[i].rate)
//             ).toFixed(2);
//             sgstAmt = newItemList[i].sgstAmount;
//             cgstAmt = newItemList[i].cgstAmount;
//             igstAmt = newItemList[i].igstAmount;

//             setSGSTAmount(sgstAmt);
//             setIGSTAmount(igstAmt);
//             setCGSTAmount(cgstAmt);
//             newItemList[i].grandTotal = total;
//           }
//         } else {
//           let rate =
//             parseFloat(newItemList[i].rate) ||
//             Number(newItemList[i].unitRate) * Number(newItemList[i].quantity);
//           let gstRate = parseFloat(newItemList[i].gstRate);

//           // Calculate base and GST from tax-inclusive rate
//           let baseAmount = rate / (1 + gstRate / 100);
//           let gstAmount = rate - baseAmount;

//           if (totalDiscount > 0 && !isNaN(totalDiscount)) {
//             if (discountType === "percent") {
//               let discount = parseFloat(discountAmount) / 100;
//               let discountedRate = rate - rate * discount;

//               let discountedBase = discountedRate / (1 + gstRate / 100);
//               let discountedGST = discountedRate - discountedBase;

//               newItemList[i].sgstAmount = (
//                 (newItemList[i].sgst / gstRate) *
//                 discountedGST
//               ).toFixed(2);
//               newItemList[i].cgstAmount = (
//                 (newItemList[i].cgst / gstRate) *
//                 discountedGST
//               ).toFixed(2);
//               newItemList[i].igstAmount = (
//                 (newItemList[i].igst / gstRate) *
//                 discountedGST
//               ).toFixed(2);

//               sgstAmt = newItemList[i].sgstAmount;
//               cgstAmt = newItemList[i].cgstAmount;
//               igstAmt = newItemList[i].igstAmount;

//               total = discountedRate;
//             } else {
//               let flatDiscount = parseFloat(discountAmount);
//               let discountedRate = rate - flatDiscount;

//               let discountedBase = discountedRate / (1 + gstRate / 100);
//               let discountedGST = discountedRate - discountedBase;

//               newItemList[i].sgstAmount = (
//                 (newItemList[i].sgst / gstRate) *
//                 discountedGST
//               ).toFixed(2);
//               newItemList[i].cgstAmount = (
//                 (newItemList[i].cgst / gstRate) *
//                 discountedGST
//               ).toFixed(2);
//               newItemList[i].igstAmount = (
//                 (newItemList[i].igst / gstRate) *
//                 discountedGST
//               ).toFixed(2);

//               sgstAmt = newItemList[i].sgstAmount;
//               cgstAmt = newItemList[i].cgstAmount;
//               igstAmt = newItemList[i].igstAmount;

//               total = discountedRate;
//             }

//             setSGSTAmount(sgstAmt);
//             setIGSTAmount(igstAmt);
//             setCGSTAmount(cgstAmt);

//             newItemList[i].grandTotal = total;
//           } else {
//             // No discount case
//             newItemList[i].sgstAmount = (
//               (newItemList[i].sgst / gstRate) *
//               gstAmount
//             ).toFixed(2);
//             newItemList[i].cgstAmount = (
//               (newItemList[i].cgst / gstRate) *
//               gstAmount
//             ).toFixed(2);
//             newItemList[i].igstAmount = (
//               (newItemList[i].igst / gstRate) *
//               gstAmount
//             ).toFixed(2);

//             sgstAmt = newItemList[i].sgstAmount;
//             cgstAmt = newItemList[i].cgstAmount;
//             igstAmt = newItemList[i].igstAmount;

//             setSGSTAmount(sgstAmt);
//             setIGSTAmount(igstAmt);
//             setCGSTAmount(cgstAmt);

//             newItemList[i].grandTotal = rate;
//           }
//         }
//       } else {
//         newItemList[i].grandTotal = Number(
//           newItemList[i].quantity * Number(newItemList[i].unitRate)
//         );
//       }
//     }

//     for (let i = 0; i < newItemList.length; i++) {
//       grandTotal =
//         parseFloat(grandTotal) + (parseFloat(newItemList[i].grandTotal) ?? 0);
//       grandTotal = grandTotal.toFixed(2);
//       estTotal =
//         parseFloat(estTotal) + parseFloat(newItemList[i].grandTotal ?? 0);
//       TotalCgst = parseFloat(TotalCgst) + parseFloat(newItemList[i].cgstAmount);
//       TotalCgst = TotalCgst.toFixed(2);
//       TotalSgst = parseFloat(TotalSgst) + parseFloat(newItemList[i].sgstAmount);
//       TotalSgst = TotalSgst.toFixed(2);
//       TotalIgst = parseFloat(TotalIgst) + parseFloat(newItemList[i].igstAmount);
//       TotalIgst = TotalIgst.toFixed(2);

//       if (newItemList[i].rate) {
//         if (newItemList[i].partNumber.code || newItemList[i].jobCode) {
//           if (
//             newItemList[i].partNumber?.consumable ||
//             newItemList[i].jobCode?.consumable
//           ) {
//             consumableCharge =
//               parseFloat(consumableCharge) + parseFloat(newItemList[i].rate);
//           } else {
//             labourCharge =
//               parseFloat(labourCharge) + parseFloat(newItemList[i].rate);
//           }
//         } else if (newItemList[i].partNumber.hsn) {
//           pCharge = parseFloat(pCharge) + parseFloat(newItemList[i].rate);
//         }
//       }
//       setGrandTotal(grandTotal);
//     }

//     let roundoff = String(grandTotal).split(".");
//     if (roundoff[1] === "00") {
//       temp = "0.00";
//     } else if (parseInt(roundoff[1]) >= 50) {
//       temp = 100 - parseInt(roundoff[1]);
//       temp = `+0.${temp}`;
//     } else if (parseInt(roundoff[1]) < 50) {
//       temp = 100 - parseInt(roundoff[1]);
//       temp = `-0.${parseInt(roundoff[1])}`;
//     }
//     estTotal = estTotal.toFixed(0);
//     form.setFieldsValue({
//       totalAmount: Number(estTotal),
//       cgst: TotalCgst,
//       sgst: TotalSgst,
//       igst: TotalIgst,
//       partCharge: pCharge,
//       labourCharge: labourCharge,
//       consumableCharge: consumableCharge,
//       roundoff: temp,
//     });
//     setItemList(newItemList);
//   };
//   //ItemMax
//   const calculateItemTax = () => {
//     let taxExclusive = 0;
//     let taxInclusive = 0;
//     let newItemList = [...itemList];
//     let grandTotal = 0;
//     let pCharge = 0;
//     let labourCharge = 0;
//     let consumableCharge = 0;
//     let TotalCgst = 0;
//     let TotalSgst = 0;
//     let TotalIgst = 0;
//     let estTotal = 0;
//     let temp;

//     for (let i = 0; i < newItemList.length; i++) {
//       if (newItemList[i].rate > 0 && newItemList[i].gstRate > 0) {
//         let total = parseFloat(newItemList[i].rate);
//         let gstRateValue = newItemList[i].gstRate / 100 + parseInt(1);
//         // taxExlusive = (total * (newItemList[i].gstRate / 100)).toFixed(2);
//         if (newItemList[i].partNumber.code || newItemList[i].jobCode) {
//           taxExclusive = (total * (newItemList[i].gstRate / 100)).toFixed(2);
//           if (newItemList[i].discount > 0 && !isNaN(newItemList[i].discount)) {
//             if (discountType === "percent") {
//               total =
//                 total - total * (parseFloat(newItemList[i].discount) / 100);
//               newItemList[i].sgstAmount = parseFloat(
//                 (newItemList[i].sgst / 100) * total
//               ).toFixed(2);
//               newItemList[i].igstAmount = parseFloat(
//                 (newItemList[i].igst / 100) * total
//               ).toFixed(2);
//               newItemList[i].cgstAmount = parseFloat(
//                 (newItemList[i].cgst / 100) * total
//               ).toFixed(2);
//               sgstAmt = newItemList[i].sgstAmount;
//               cgstAmt = newItemList[i].cgstAmount;
//               igstAmt = newItemList[i].igstAmount;
//             } else {
//               total = total - parseFloat(newItemList[i].discount);
//               newItemList[i].sgstAmount = parseFloat(
//                 (newItemList[i].sgst / 100) * total
//               ).toFixed(2);
//               newItemList[i].igstAmount = parseFloat(
//                 (newItemList[i].igst / 100) * total
//               ).toFixed(2);
//               newItemList[i].cgstAmount = parseFloat(
//                 (newItemList[i].cgst / 100) * total
//               ).toFixed(2);
//               sgstAmt = newItemList[i].sgstAmount;
//               cgstAmt = newItemList[i].cgstAmount;
//               igstAmt = newItemList[i].igstAmount;
//             }
//             total = total + parseFloat((newItemList[i].gstRate / 100) * total);
//             setSGSTAmount(sgstAmt);
//             setIGSTAmount(igstAmt);
//             setCGSTAmount(cgstAmt);
//             newItemList[i].grandTotal = total;
//           } else {
//             let Fintotal = parseFloat(total);
//             total = (parseFloat(total) - parseFloat(taxInclusive)).toFixed(2);
//             total = total + parseFloat((newItemList[i].gstRate / 100) * total);
//             newItemList[i].sgstAmount = parseFloat(
//               (newItemList[i].sgst / 100) * parseFloat(newItemList[i].rate)
//             ).toFixed(2);
//             newItemList[i].igstAmount = parseFloat(
//               (newItemList[i].igst / 100) * parseFloat(newItemList[i].rate)
//             ).toFixed(2);
//             newItemList[i].cgstAmount = parseFloat(
//               (newItemList[i].cgst / 100) * parseFloat(newItemList[i].rate)
//             ).toFixed(2);
//             sgstAmt = newItemList[i].sgstAmount;
//             cgstAmt = newItemList[i].cgstAmount;
//             igstAmt = newItemList[i].igstAmount;
//             setSGSTAmount(sgstAmt);
//             setIGSTAmount(igstAmt);
//             setCGSTAmount(cgstAmt);
//             // newItemList[i].grandTotal = total
//             newItemList[i].grandTotal = Fintotal;
//           }
//         } else if (
//           newItemList[i].partNumber.partNumber ||
//           newItemList[i].partNumber.hsn
//         ) {
//           taxInclusive = (
//             parseFloat(total) - parseFloat(total / gstRateValue)
//           ).toFixed(2);
//           if (newItemList[i].discount > 0 && !isNaN(newItemList[i].discount)) {
//             if (discountType === "percent") {
//               total =
//                 total - total * (parseFloat(newItemList[i].discount) / 100);
//               newItemList[i].sgstAmount = parseFloat(
//                 (newItemList[i].sgst / 100) * total
//               ).toFixed(2);
//               newItemList[i].igstAmount = parseFloat(
//                 (newItemList[i].igst / 100) * total
//               ).toFixed(2);
//               newItemList[i].cgstAmount = parseFloat(
//                 (newItemList[i].cgst / 100) * total
//               ).toFixed(2);
//               sgstAmt = newItemList[i].sgstAmount;
//               cgstAmt = newItemList[i].cgstAmount;
//               igstAmt = newItemList[i].igstAmount;
//             } else {
//               total = total - parseFloat(newItemList[i].discount);
//               newItemList[i].sgstAmount = parseFloat(
//                 (newItemList[i].sgst / 100) * total
//               ).toFixed(2);
//               newItemList[i].igstAmount = parseFloat(
//                 (newItemList[i].igst / 100) * total
//               ).toFixed(2);
//               newItemList[i].cgstAmount = parseFloat(
//                 (newItemList[i].cgst / 100) * total
//               ).toFixed(2);
//               sgstAmt = newItemList[i].sgstAmount;
//               cgstAmt = newItemList[i].cgstAmount;
//               igstAmt = newItemList[i].igstAmount;
//             }
//             // total = total + parseFloat((newItemList[i].gstRate / 100) * total)
//             setSGSTAmount(sgstAmt);
//             setIGSTAmount(igstAmt);
//             setCGSTAmount(cgstAmt);
//             newItemList[i].grandTotal = total;
//           } else {
//             let Fintotal = parseFloat(total);
//             total = (parseFloat(total) + parseFloat(taxInclusive)).toFixed(2);
//             newItemList[i].sgstAmount = parseFloat(
//               (newItemList[i].sgst / 100) * total
//             ).toFixed(2);
//             newItemList[i].igstAmount = parseFloat(
//               (newItemList[i].igst / 100) * total
//             ).toFixed(2);
//             newItemList[i].cgstAmount = parseFloat(
//               (newItemList[i].cgst / 100) * total
//             ).toFixed(2);
//             sgstAmt = newItemList[i].sgstAmount;
//             cgstAmt = newItemList[i].cgstAmount;
//             igstAmt = newItemList[i].igstAmount;
//             setSGSTAmount(sgstAmt);
//             setIGSTAmount(igstAmt);
//             setCGSTAmount(cgstAmt);
//             // newItemList[i].grandTotal = total
//             newItemList[i].grandTotal = Fintotal;
//           }
//         }
//       }
//     }

//     for (let i = 0; i < newItemList.length; i++) {
//       grandTotal = (
//         Number(grandTotal) + Number(newItemList[i].grandTotal)
//       ).toFixed(2);
//       estTotal = parseFloat(estTotal) + parseFloat(newItemList[i].grandTotal);
//       TotalCgst = parseFloat(TotalCgst) + parseFloat(newItemList[i].cgstAmount);
//       TotalCgst = TotalCgst.toFixed(2);
//       TotalSgst = parseFloat(TotalSgst) + parseFloat(newItemList[i].sgstAmount);
//       TotalSgst = TotalSgst.toFixed(2);
//       TotalIgst = parseFloat(TotalIgst) + parseFloat(newItemList[i].igstAmount);
//       TotalIgst = TotalIgst.toFixed(2);

//       if (newItemList[i].rate) {
//         if (newItemList[i].partNumber.code || newItemList[i].jobCode) {
//           if (
//             newItemList[i].partNumber?.consumable ||
//             newItemList[i].jobCode?.consumable
//           ) {
//             consumableCharge =
//               parseFloat(consumableCharge) + parseFloat(newItemList[i].rate);
//           } else {
//             labourCharge =
//               parseFloat(labourCharge) + parseFloat(newItemList[i].rate);
//           }
//         } else if (newItemList[i].partNumber.hsn) {
//           pCharge = parseFloat(pCharge) + parseFloat(newItemList[i].rate);
//         }
//       }
//       setGrandTotal(grandTotal);
//     }
//     let roundoff = String(grandTotal).split(".");
//     if (parseInt(roundoff[1]) >= 50) {
//       temp = 100 - parseInt(roundoff[1]);
//       temp = `+0.${temp}`;
//     } else if (parseInt(roundoff[1]) < 50) {
//       temp = 100 - parseInt(roundoff[1]);
//       temp = `-0.${parseInt(roundoff[1])}`;
//     }
//     estTotal = estTotal.toFixed(0);
//     form.setFieldsValue({
//       totalAmount: estTotal,
//       cgst: TotalCgst,
//       sgst: TotalSgst,
//       igst: TotalIgst,
//       partCharge: pCharge,
//       labourCharge: labourCharge,
//       consumableCharge: consumableCharge,
//       roundoff: temp,
//     });
//     setItemList(itemList);
//   };
//   //Handle Add
//   const handleAdd = () => {
//     let newArr = [...itemList, partItemData];
//     setItemList(newArr);
//   };
//   //Handle UnitRate
//   const handleUnitrate = (event, record) => {
//     const cleanValue = event.target.value.replace(/[^0-9.]/g, '');
//     setUnitRate(cleanValue);
//     let newItemList = [...itemList];
//     for (let item of newItemList) {
//       if (item.id === record.id) {
//         item.unitRate = cleanValue;
//         item.rate = item.quantity * item.unitRate;
//         break;
//       }
//     }
//   };
//   //Handle Discount
//   const handleDiscount = (event, record) => {
//     const cleanValue = event.target.value.replace(/[^0-9.]/g, '');
//     setDiscount(cleanValue);
//     let newItemList = [...itemList];
//     for (let item of newItemList) {
//       if (item.id === record.id) {
//         item.discount = cleanValue;
//         break;
//       }
//     }
//   };
//   //Handle Quantity
//   const handlequantity = (event, record) => {
//     const cleanValue = event.target.value.replace(/[^0-9]/g, '');
//     setquantity(cleanValue);
//     let newItemList = [...itemList];
//     for (let item of newItemList) {
//       if (item.id === record.id) {
//         item.quantity = cleanValue;
//         break;
//       }
//     }
//     setItemList(newItemList);
//   };
//   //Handle Cancel
//   const handleCancel = () => {
//     form.resetFields();
//     setGrandTotal(0);
//     setDiscountAmount(0);
//     setSelectedPart("");
//     setItemList([partItemData]);
//     setRecPart("");
//     setJobNo([]);
//     setPartsData([]);
//     setJobCode([]);
//     setDeleteData1([]);
//     setDeleteData2([]);
//     setStateName("");
//     // setJobid('');
//     setGst("");
//     history.push("/autoadmin/estimate");
//   };
//   //Handle Submit
//   const handleSubmit = () => {
//     form.validateFields((validationError) => {
//       let totalSGSTAmt = 0;
//       let totalCGSTAmt = 0;
//       let totalIGSTAmt = 0;
//       let newItemList = [...itemList];
//       // eslint-disable-next-line for-direction
//       for (let i = 0; i < newItemList.length; i++) {
//         if (
//           newItemList[i].sgstAmount > 0 &&
//           newItemList[i].cgstAmount > 0 &&
//           newItemList[i].igstAmount > 0
//         ) {
//           totalSGSTAmt = totalSGSTAmt + parseFloat(newItemList[i].sgstAmount);
//           totalCGSTAmt = totalCGSTAmt + parseFloat(newItemList[i].cgstAmount);
//           totalIGSTAmt = totalIGSTAmt + parseFloat(newItemList[i].igstAmount);
//         }
//         newItemList[i].discountPercent =
//           discountType === "percent" ? newItemList[i].discount : 0;
//         newItemList[i].discountRate =
//           discountType === "rupee" ? newItemList[i].discount : 0;
//       }
//       if (newItemList.length > 1) {
//         newItemList = newItemList.filter((item) => {
//           return (
//             (item.partNumber &&
//               item.hsn &&
//               item.rate &&
//               item.igst &&
//               item.cgst &&
//               item.sgst) ||
//             item.imageUrl
//           );
//         });
//         // newItemList = newItemList.slice(0, newItemList.length - 1)
//       }

//       setItemList(newItemList);

//       // Get survivor data from the selected survivor
//       const selectedSurvivor = getFieldValue("survivor");
//       const survivorData =
//         survivorList.find((s) => s.id === selectedSurvivor) || {};

//       const insurerData =
//         insurerList.find((i) => i.name === getFieldValue("insurer")) || {};

//       const data = {
//         estimateNo: estimateNo,
//         jobOrder: getFieldValue("JobNo"),
//         discountLevel,
//         discountType,
//         currentDate: moment(Date.now()),
//         discountPercent: discountType === "percent" ? discountAmount : 0,
//         discountRate: discountType === "rupee" ? discountAmount : 0,
//         cgstAmount:
//           stateName && stateName?.slice(0, 2) === gst && gst.slice(0, 2)
//             ? totalCGSTAmt
//             : totalCGSTAmt,
//         sgstAmount:
//           stateName && stateName?.slice(0, 2) === gst && gst.slice(0, 2)
//             ? totalSGSTAmt
//             : totalSGSTAmt,
//         igstAmount:
//           stateName && stateName?.slice(0, 2) !== gst && gst.slice(0, 2)
//             ? totalIGSTAmt
//             : null,
//         labourCharge: getFieldValue("labourCharge")
//           ? getFieldValue("labourCharge")
//           : 0,
//         consumableCharge: getFieldValue("consumableCharge")
//           ? getFieldValue("consumableCharge")
//           : 0,
//         partCharge: getFieldValue("partCharge")
//           ? getFieldValue("partCharge")
//           : 0,
//         estTotalAmount: getFieldValue("totalAmount")
//           ? getFieldValue("totalAmount")
//           : grandTtl,
//         totalDiscount,
//         estimateItemInvoice: newItemList,
//         branch: branch,
//         deleteData1: deleteData1,
//         deleteData2: deleteData2,
//         // Add accidental type and related fields
//         serviceType: serviceType,
//         claimStatus: claimStatus,
//         claimType: claimType,
//         insurer: insurerData?.id || null,
//         survivorName: survivorData?.name || null,
//         survivor: survivorData?.id || null,
//         survivorContact: survivorData?.contacts?.[0]?.phone || null,
//       };

//       if (validationError === null) {
//         setBtnFlag(true);
//         if (!modifyType) {
//           platformApi
//             .post("/api/estimate/", data)
//             .then((result) => {
//               let { data } = result;
//               if (data.code === 200) {
//                 let { response } = data;
//                 if (response.code === 200) {
//                   message.success("Estimate Added Successfully");
//                   history.push("/autoadmin/estimate");
//                 }
//               }
//             })
//             .catch((err) => {
//               console.log(err);
//               message.error("Couldn't Add Estimate");
//             });
//         } else {
//           platformApi
//             .put(`/api/estimate/${id}`, data)
//             .then((result) => {
//               let { data } = result;
//               if (data.code === 200) {
//                 let { response } = data;
//                 if (response.code === 200) {
//                   message.success("Estimate Modified Successfully");
//                   history.push("/autoadmin/estimate");
//                 }
//               } else {
//                 message.error("Estimate Modified Failed");
//                 setBtnFlag(false);
//               }
//             })
//             .catch((err) => {
//               console.error("Estimate Add Error: ", err);
//               message.error("Couldn't update Estimate");
//               setBtnFlag(false);
//             });
//         }
//       } else {
//         message.error("select atleast one item list");
//       }
//     });
//   };

//   //Handle Delete
//   const handleDelete = (selectedId) => {
//     let grandTotal = 0;
//     let TotalCgst = 0;
//     let TotalSgst = 0;
//     let TotalIgst = 0;
//     const updatedDataSource = itemList.filter((item) => item.id !== selectedId);
//     for (let i = 0; i < updatedDataSource.length; i++) {
//       grandTotal = (
//         parseFloat(grandTotal) + parseFloat(updatedDataSource[i].grandTotal)
//       ).toFixed(2);
//       setGrandTotal(grandTotal);
//       TotalCgst =
//         parseFloat(TotalCgst) +
//         parseFloat(updatedDataSource[i].cgstAmount).toFixed(2);
//       TotalSgst =
//         parseFloat(TotalSgst) +
//         parseFloat(updatedDataSource[i].sgstAmount).toFixed(2);
//       TotalIgst =
//         parseFloat(TotalIgst) +
//         parseFloat(updatedDataSource[i].igstAmount).toFixed(2);
//       form.setFieldsValue({
//         totalAmount: grandTotal,
//         cgst: TotalCgst,
//         sgst: TotalSgst,
//         igst: TotalIgst,
//       });
//     }
//     deleteParts(selectedId);
//     setItemList(updatedDataSource);
//   };

//   const deleteParts = (e) => {
//     if (pid.indexOf(e) >= 0) {
//       deleteData1.push(e);
//     } else if (jid.indexOf(e) >= 0) {
//       deleteData2.push(e);
//     }
//     setDeleteData1(deleteData1);
//     setDeleteData2(deleteData2);
//   };
//   //Searches
//   const searchJobNo = (search) => {
//     platformApi
//       .post("/api/options/get/", {
//         module: search.module,
//         column: search.column,
//         searchString: search.searchString,
//         fields: search.fields,
//         size: 100,
//         page: 1,
//         except: null,
//       })
//       .then((res) => {
//         search.setValue(res.data.response);
//       });
//   };

//   const searchParts = async (search) => {
//     // const res = await platformApi
//     //     .post("/api/options/get/", {
//     //         module: search.module,
//     //         column: search.column,
//     //         searchString: search.searchString,
//     //         fields: search.fields,
//     //         size: 100,
//     //         page: 1,
//     //         except: null,
//     //         branch: pBranch
//     //     })
//     // let parts = [];
//     // // console.log("Response", res.data)
//     // for (let i = 0; i < res.data.response?.length; i++) {
//     //     const element = res.data.response[i];
//     //     parts.push(element.partNo)
//     // }
//     // search.setValue(parts)
//     // return 1
//     // .then((res) => {
//     //     let parts = [];
//     //     for (let i = 0; i < res.data.response.length; i++) {
//     //         const element = res.data.response[i];
//     //         parts.push(element.partNo)
//     //     }
//     //     setPartsData(parts)
//     //     return parts;
//     // });

//     const res = await platformApi.post("/api/options/get/", {
//       module: search.module,
//       column: search.column,
//       searchString: search.searchString,
//       fields: search.fields,
//       size: 100,
//       page: 1,
//       except: null,
//     });
//     search.setValue(res.data.response);
//     return 1;
//   };

//   const searchJobCode = (search) => {
//     platformApi
//       .post("/api/options/get/", {
//         module: search.module,
//         column: search.column,
//         searchString: search.searchString,
//         fields: search.fields,
//         size: 100,
//         page: 1,
//         except: null,
//       })
//       .then((res) => {
//         search.setValue(() => {
//           return res.data.response;
//         });
//       });
//   };

//   const getJobNo = () => {
//     platformApi
//       .post("/api/jobOrder/getJobNo", {
//         size: 100,
//         page: 1,
//       })
//       .then((res) => {
//         let { data } = res;
//         if (data.code === 200) {
//           let { response } = data;
//           if (response.code === 200) {
//             setJobNo(response.data);
//           } else {
//             message.error("Failed to fetch Job Order");
//           }
//         } else {
//           message.error("Failed to fetch Job Order");
//         }
//       })
//       .catch((error) => {
//         console.error("Error on Job Order : ", error);
//         message.error("Failed to fetch Job Order");
//       });
//   };

//   // Add a useEffect to reset the field value if survivorList changes and only one result is present
//   useEffect(() => {
//     if (survivorList.length === 1) {
//       setFieldsValue({ survivor: survivorList[0].id });
//     }
//   }, [survivorList]);

//   useEffect(() => {
//     if (lastSearchRef.current && survivorList.length > 0) {

//       const match = survivorList.find((survivor) => {
//         const phone = survivor.contacts && survivor.contacts[0]?.phone;
//         if (phone && phone.includes(lastSearchRef.current)) return true;
//         if (
//           survivor.name &&
//           survivor.name
//             .toLowerCase()
//             .includes(lastSearchRef.current.toLowerCase())
//         )
//           return true;
//         return false;
//       });
//       if (match) {
//         setFieldsValue({ survivor: match.id });
//       }
//     }

//   }, [survivorList]);

//   return (
//     <div>
//       <Form className="purchase-form">
//         <Row>
//           <Col span={12}>
//             <Text strong>
//               Estimate No&nbsp;&nbsp;&nbsp;:
//               {!editData ? estimateNo : editData.estimateNo}
//             </Text>
//             <Form.Item
//               className="purchase-form-element"
//               label={<Text strong> Estimate Status&nbsp;&nbsp;&nbsp;</Text>}
//             >
//               <div style={{ marginLeft: "20px" }}>
//                 <Text strong>
//                   {editData && editData.estimateStatus
//                     ? editData.estimateStatus
//                     : "-"}
//                 </Text>
//               </div>
//             </Form.Item>
//           </Col>
//           <Col span={12}>
//             <Form.Item
//               className="purchase-form-element"
//               label="Date & Time"
//               name="currentDate"
//             >
//               <DatePicker
//                 disabled={true}
//                 placeholder={moment(Date.now()).format("LL")}
//               />
//             </Form.Item>
//           </Col>
//         </Row>
//         <Row>
//           <Col span={12}>
//             <Form.Item
//               colon={false}
//               className="purchase-form-element"
//               label={<Text>Ass.Job No</Text>}
//             >
//               {getFieldDecorator("JobNo", {
//                 rules: [
//                   {
//                     required: true,
//                     message: "Select Job No",
//                   },
//                 ],
//               })(
//                 <Select
//                   showAction={["click", "focus"]}
//                   showSearch
//                   filterOption={null}
//                   disabled={editable}
//                   placeholder="Job No"
//                   onSearch={(e) => {
//                     const search = {
//                       module: "jobOrders",
//                       column: "jobNo",
//                       searchString: e,
//                       searchColumns: ["jobNo"],
//                       setValue: setJobNo,
//                     };
//                     searchJobNo(search);
//                   }}
//                   onSelect={getJobOrder}
//                 >
//                   {jobNo.length &&
//                     jobNo.map((item) => (
//                       <Select.Option key={item.id} value={item.id}>
//                         {item.jobNo}
//                       </Select.Option>
//                     ))}
//                 </Select>
//               )}
//             </Form.Item>
//           </Col>
//           <Col span={12}>
//             <Form.Item
//               colon={false}
//               className="purchase-form-element"
//               label={<Text>Branch</Text>}
//             >
//               {getFieldDecorator("branch", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Select Job No",
//                   },
//                 ],
//               })(<Input disabled={true} placeholder={"Branch"} />)}
//             </Form.Item>
//           </Col>
//         </Row>
//         <Row>
//           {vehicleDetail && (
//             <Col span={24}>
//               <Title level={4}>Vehicle Details</Title>
//               <Row gutter={16}>
//                 {" "}
//                 {/* Main row for details and image */}
//                 <Col span={18}>
//                   {" "}
//                   {/* Column for all textual details */}
//                   <Row gutter={16}>
//                     {" "}
//                     {/* First row of 3 details */}
//                     <Col span={8}>
//                       <Form.Item label="Model Name">
//                         <Input
//                           value={vehicleDetail.vehicle?.modelName}
//                           disabled
//                         />
//                       </Form.Item>
//                     </Col>
//                     <Col span={8}>
//                       <Form.Item label="Model Code">
//                         <Input
//                           value={vehicleDetail.vehicle?.modelCode}
//                           disabled
//                         />
//                       </Form.Item>
//                     </Col>
//                     <Col span={8}>
//                       <Form.Item label="Customer Name">
//                         <Input
//                           value={vehicleDetail.customer?.[0]?.customer?.name}
//                           disabled
//                         />
//                       </Form.Item>
//                     </Col>
//                   </Row>
//                   <Row gutter={16}>
//                     {" "}
//                     {/* Second row of 3 details */}
//                     <Col span={8}>
//                       <Form.Item label="Chassis No">
//                         <Input value={vehicleDetail.chassisNo} disabled />
//                       </Form.Item>
//                     </Col>
//                     <Col span={8}>
//                       <Form.Item label="Register No">
//                         <Input value={vehicleDetail.registerNo} disabled />
//                       </Form.Item>
//                     </Col>
//                     <Col span={8}>
//                       <Form.Item label="Engine No">
//                         <Input value={vehicleDetail.engineNo} disabled />
//                       </Form.Item>
//                     </Col>
//                   </Row>
//                 </Col>
//                 <Col
//                   span={6}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   {" "}
//                   {/* Column for the image, effectively spanning rows */}
//                   {vehicleDetail.color?.url && (
//                     <div style={{ textAlign: "center" }}>
//                       <img
//                         src={vehicleDetail.color.url}
//                         alt={vehicleDetail.color.color}
//                         style={{
//                           maxWidth: "100%",
//                           maxHeight: "145px",
//                           objectFit: "contain",
//                         }} /* Adjusted maxHeight */
//                       />
//                       <p style={{ marginTop: "8px" }}>
//                         Color: {vehicleDetail.color.color}
//                       </p>
//                     </div>
//                   )}
//                 </Col>
//               </Row>
//             </Col>
//           )}
//         </Row>

//         <Row gutter={16}>
//           <Col span={12}>
//             <Form.Item
//               className="form-element-type"
//               label={<Text strong>Service type?</Text>}
//             >
//               {getFieldDecorator("serviceType", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Select Service Type",
//                   },
//                 ],
//               })(
//                 <Group
//                   onChange={(e) => {
//                     setFieldsValue({
//                       serviceType: e.target.value,
//                     });
//                     setServiceType(e.target.value);
//                   }}
//                   disabled={editable}
//                 >
//                   <Radio value={"Accidental"}>Accidental</Radio>
//                   <Radio value={"Non Accidental"}>Non Accidental</Radio>
//                 </Group>
//               )}
//             </Form.Item>
//           </Col>

//           {serviceType === "Accidental" && (
//             <>
//               <Col span={12}>
//                 <Form.Item
//                   className="form-element-type"
//                   label={<Text strong>Insurance Claim Status</Text>}
//                 >
//                   {getFieldDecorator("claimStatus", {
//                     rules: [
//                       {
//                         required: true,
//                         message: "Select Insurance Claim Status",
//                       },
//                     ],
//                     initialValue: editData?.claimStatus,
//                   })(
//                     <Group
//                       onChange={(e) => {
//                         setFieldsValue({
//                           claimStatus: e.target.value,
//                         });
//                         setClaimStatus(e.target.value);
//                       }}
//                       disabled={editable}
//                     >
//                       <Radio value={true}>Yes</Radio>
//                       <Radio value={false}>No</Radio>
//                     </Group>
//                   )}
//                 </Form.Item>
//               </Col>
//             </>
//           )}

//           {claimStatus && (
//             <>
//               <Col span={12}>
//                 <Form.Item
//                   className="form-element-type"
//                   label={<Text strong>Claim type</Text>}
//                 >
//                   {getFieldDecorator("claimType", {
//                     rules: [
//                       {
//                         required: true,
//                         message: "Select claim type",
//                       },
//                     ],
//                     initialValue: editData?.claimType || undefined,
//                   })(
//                     <Group
//                       onChange={(e) => {
//                         setFieldsValue({
//                           claimType: e.target.value,
//                         });
//                         setClaimType(e.target.value);
//                       }}
//                       disabled={editable}
//                     >
//                       <Radio value="Cashless">Cashless</Radio>
//                       <Radio value="Non Cashless">Non Cashless</Radio>
//                     </Group>
//                   )}
//                 </Form.Item>
//               </Col>
//             </>
//           )}
//         </Row>

//         {claimStatus && (
//           <Row gutter={16}>
//             <Col span={12}>
//               <Form.Item
//                 colon={false}
//                 className="purchase-form-element"
//                 label={<Text>Insurer name</Text>}
//               >
//                 {getFieldDecorator("insurer", {
//                   rules: [
//                     {
//                       required: true,
//                       message: "Select insurer name",
//                     },
//                   ],
//                   initialValue: editData?.insurer?.name || undefined,
//                 })(
//                   <Select
//                     placeholder="Select insurer"
//                     disabled={editable}
//                     showSearch
//                     filterOption={(input, option) =>
//                       option?.props?.children
//                         ?.toString()
//                         .toLowerCase()
//                         .includes(input.toLowerCase())
//                     }
//                     onChange={(value) => {
//                       setFieldsValue({
//                         insurer: value,
//                       });
//                     }}
//                   >
//                     {insurerList.map((insurer) => (
//                       <Select.Option key={insurer.id} value={insurer.name}>
//                         {insurer.name}
//                       </Select.Option>
//                     ))}
//                   </Select>
//                 )}
//               </Form.Item>
//             </Col>

//             <Col span={12}>
//               <Form.Item
//                 colon={false}
//                 className="purchase-form-element"
//                 label={<Text>Surveyor</Text>}
//               >
//                 {getFieldDecorator("survivor", {
//                   rules: [
//                     {
//                       required: true,
//                       message: "Select Surveyor",
//                     },
//                   ],
//                   initialValue: editData?.survivor
//                     ? editData.survivor.id
//                     : undefined,
//                 })(
//                   <Select
//                     showAction={["click", "focus"]}
//                     showSearch
//                     filterOption={false}
//                     disabled={editable}
//                     placeholder="Surveyor"
//                     value={getFieldValue("survivor")}
//                     onSearch={(value) => {
//                       setSurvivorList([]);
//                       getSurvivor(value);
//                       setContact(value);
//                       if (value) lastSearchRef.current = value;
//                     }}
//                     onChange={(value) => {
//                       setFieldsValue({
//                         survivor: value,
//                       });
//                     }}
//                     notFoundContent={
//                       <Button
//                         type="primary"
//                         style={{
//                           justifyContent: "center",
//                           width: "100%",
//                         }}
//                         onClick={() => {
//                           setContact(lastSearchRef.current); // Restore last search value
//                           setModalOpen(true);
//                         }}
//                       >
//                         Add Surveyor
//                       </Button>
//                     }
//                   >
//                     {survivorList.length > 0
//                       ? survivorList.map((survivor) => (
//                         <Select.Option key={survivor.id} value={survivor.id}>
//                           {survivor.name}
//                           {survivor.contacts[0]?.phone
//                             ? `-${survivor.contacts[0].phone}`
//                             : ""}
//                         </Select.Option>
//                       ))
//                       : null}
//                   </Select>
//                 )}
//               </Form.Item>
//             </Col>
//           </Row>
//         )}

//         <Row>
//           <Col span={12}>
//             <Form.Item
//               className="form-element-type"
//               label={<Text strong>Discount Type?</Text>}
//             >
//               {getFieldDecorator("discountType", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Select discountType",
//                   },
//                 ],
//               })(
//                 <Group
//                   // onChange={(value) => setDiscountType(value)}
//                   onChange={(e) => {
//                     setFieldsValue({
//                       discountType: e.target.value,
//                     });
//                     setDiscountType(e.target.value);
//                   }}
//                   // value={discountLevel}
//                   disabled={editable}
//                 >
//                   <Radio value="percent">Percentage(%) </Radio>
//                   <Radio value="rupee"> Amount (Rs) </Radio>
//                 </Group>
//               )}
//             </Form.Item>
//           </Col>
//           <Col span={12}>
//             <Form.Item
//               className="form-element-type"
//               label={<Text strong>Add Recommended Parts & Services?</Text>}
//             >
//               {getFieldDecorator("recPart", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Select Recommended Parts & Services",
//                   },
//                 ],
//               })(
//                 <Group
//                   onChange={(e) => {
//                     setFieldsValue({
//                       recPart: e.target.value,
//                     });
//                     setRecPart(e.target.value);
//                   }}
//                   // value={discountLevel}
//                   disabled={editable}
//                 >
//                   <Radio value="yes">Yes </Radio>
//                   <Radio value="no"> No </Radio>
//                 </Group>
//               )}
//             </Form.Item>
//           </Col>
//         </Row>
//         <Row>
//           <Col span={12}>
//             <Form.Item
//               className="form-element-type"
//               label="Discount Level"
//               name="dicountLevel"
//             >
//               {getFieldDecorator("discountLevel", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Select Discount Level",
//                   },
//                 ],
//               })(
//                 <Select
//                   showSearch
//                   showAction={["click", "focus"]}
//                   style={{ width: 200 }}
//                   disabled={editable}
//                   placeholder="Select Discount Level"
//                   onChange={(e) => {
//                     setDiscountLevel(e);
//                     setFieldsValue({
//                       discountLevel: e,
//                     });
//                   }}
//                 // onChange={(value) => setDiscountType(value)}
//                 // value={discountType}
//                 >
//                   <Option value="TransactionLevel">At Transaction Level</Option>
//                   {/* <Option value="ItemLevel">At Item Level</Option> */}
//                 </Select>
//               )}
//             </Form.Item>
//           </Col>
//           {discountLevel === "TransactionLevel" && (
//             <Col span={6}>
//               <Form.Item
//                 className="form-element-type"
//                 label={
//                   discountType === "percent"
//                     ? "Discount Percent"
//                     : "Discount Rupee"
//                 }
//                 name="discountAmount"
//                 onChange={(e) => {
//                   const cleanValue = e.target.value.replace(/[^0-9.]/g, '');
//                   setDiscountAmount(cleanValue);
//                 }}
//                 rules={[{}]}
//               >
//                 <Input
//                   disabled={editable}
//                   placeholder={
//                     discountType === "percent"
//                       ? "Discount Percent"
//                       : "Discount Rupee"
//                   }
//                   value={
//                     discountLevel === "TransactionLevel" && discountAmount !== 0
//                       ? discountAmount
//                       : discountAmount
//                   }
//                 />
//               </Form.Item>
//             </Col>
//           )}
//         </Row>
//         <Row>
//           <Col span={3}>
//             <Upload
//               accept=".csv"
//               showUploadList={false}
//               beforeUpload={(file) => {
//                 uploadCsv(file);
//                 return false;
//               }}
//             >
//               <Button
//                 icon={<UploadOutlined />}
//                 style={{ marginTop: "6.4vh", marginRight: "3.4vh" }}
//                 type="primary"
//               >
//                 Upload CSV
//               </Button>
//             </Upload>
//           </Col>
//           <Col span={3}>
//             <Button
//               onClick={() =>
//                 window.open("https://www.yamaha-motor-india.com/", "_blank")
//               }
//               style={{ marginTop: "6.4vh" }}
//               type="primary"
//             >
//               Parts catalogue
//             </Button>
//           </Col>
//         </Row>
//         <Table
//           className="parts-invoice-table"
//           rowKey={(record) => {
//             record.id;
//           }}
//           columns={renderColumns()}
//           dataSource={itemList}
//           tableLayout="fixed"
//           pagination={false}
//           style={{ marginTop: "1rem", marginBottom: "1rem" }}
//         />
//         <br />
//         <Row>
//           <Col span={6}></Col>
//           <Col span={8}>
//             <div className="gst-table">
//               <Title level={4} className="gst-title">
//                 GST Data
//               </Title>
//               <GSTTable
//                 gst={gst}
//                 SGST={SGST}
//                 CGST={CGST}
//                 IGST={IGST}
//                 itemList={itemList}
//                 GSTRate18={GSTRate18}
//                 GSTRate28={GSTRate28}
//                 GSTRate5={GSTRate5}
//                 GSTRate12={GSTRate12}
//               />
//             </div>
//           </Col>
//           <Col span={6}></Col>
//         </Row>
//         <br />
//         <Row gutter={16}>
//           <Col span={7}>
//             <Form.Item className="form-element" label="Labour Charge">
//               {getFieldDecorator("labourCharge", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Enter Labour Charge",
//                   },
//                 ],
//               })(<Input placeholder="Labour Charge" disabled={true} />)}
//             </Form.Item>
//             <Form.Item className="form-element" label="CGST">
//               {getFieldDecorator("cgst", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Enter  CGST",
//                   },
//                 ],
//               })(<Input placeholder="CGST" disabled={true} />)}
//             </Form.Item>
//             <Form.Item className="form-element" label="Total Discount">
//               {getFieldDecorator("totalDiscount", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Enter Total Discount",
//                   },
//                 ],
//               })(<Input placeholder="Total Discount" disabled={true} />)}
//             </Form.Item>
//           </Col>
//           <Col span={10}>
//             <Form.Item className="form-element" label="Consumable Charge">
//               {getFieldDecorator("consumableCharge", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Enter Consumable Charge",
//                   },
//                 ],
//               })(<Input placeholder="Consumable Charge" disabled={true} />)}
//             </Form.Item>
//             <Form.Item className="form-element" label="SGST">
//               {getFieldDecorator("sgst", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Enter SGST",
//                   },
//                 ],
//               })(<Input placeholder="SGST" disabled={true} />)}
//             </Form.Item>
//             <Form.Item className="form-element" label="Round Off">
//               {getFieldDecorator("roundoff", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Enter Roundoff",
//                   },
//                 ],
//               })(<Input placeholder="Round Off" disabled={true} />)}
//             </Form.Item>
//           </Col>
//           <Col span={7}>
//             <Form.Item className="form-element" label="Part Charge">
//               {getFieldDecorator("partCharge", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Enter Part Charge",
//                   },
//                 ],
//               })(<Input placeholder="Part Charge" disabled={true} />)}
//             </Form.Item>

//             {/* <Form.Item
//                             className="form-element"
//                             label="IGST"
//                         >
//                             {
//                                 getFieldDecorator("igst", {
//                                     rules: [
//                                         {
//                                             required: false,
//                                             message: "Enter IGST"
//                                         }
//                                     ]
//                                 })(
//                                     <Input
//                                         placeholder="IGST"
//                                         disabled={true}
//                                     />
//                                 )
//                             }
//                         </Form.Item> */}
//           </Col>
//         </Row>
//         <Row>
//           <Col span={12}></Col>
//           <Col span={12}>
//             <Form.Item
//               className="form-element"
//               label={<Text strong>Total Estimated Amount</Text>}
//             >
//               {getFieldDecorator("totalAmount", {
//                 rules: [
//                   {
//                     required: false,
//                     message: "Enter Estimated Amount",
//                   },
//                 ],
//               })(<Input placeholder="Estimated Amount" disabled={true} />)}
//             </Form.Item>
//           </Col>
//         </Row>
//         <div style={{ float: "right" }}>
//           <Button
//             style={{ marginRight: "1rem" }}
//             size="large"
//             onClick={() => handleCancel()}
//           >
//             Cancel
//           </Button>
//           {!editable ? (
//             <Button
//               type="primary"
//               size="large"
//               disabled={btnFlag}
//               onClick={() => handleSubmit()}
//             >
//               {"Save"}
//             </Button>
//           ) : (
//             editData?.estimateStatus === "PENDING" && (
//               <Button
//                 type="primary"
//                 size="large"
//                 disabled={btnFlag}
//                 onClick={() => onEdit(false)}
//               >
//                 {"Modify"}
//               </Button>
//             )
//           )}
//         </div>
//       </Form>
//       <WrappedCustomerAddModal
//         data={selected}
//         setData={setSelected}
//         contact={contact}
//         emitData={(data) => addCustomerData(data)}
//         open={modalOpen}
//         close={() => {
//           setSelected(null);
//           setModalOpen(false);
//           setContact(lastSearchRef.current);
//           if (lastSearchRef.current) {
//             getSurvivor(lastSearchRef.current);
//           }
//         }}
//         editable={true}
//         cusId={cusId}
//         setCusId={setCusId}
//       />
//     </div>
//   );
// };
// const WrappedEstimateForm = Form.create()(EstimateForm);

// export default WrappedEstimateForm;
import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Typography,
  Input,
  Button,
  Select,
  Form,
  Col,
  Row,
  DatePicker,
  message,
  Table,
  Radio,
  Popconfirm,
  Upload,
  Card,
  Descriptions,
  notification,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import { platformApi } from "../../../../../api";
import { getUUID } from "../../../../../_helpers/utils";
import { GST18, GST28, GST12, GST5 } from "../../../../../utils";
import GSTTable from "./GSTTable";
import WrappedCustomerAddModal from "../../../../../components/TransactionMasters/JobOrder/JobOrderModal/VehicleDetails/AddCustomer";

const { Title, Text } = Typography;
const { Option } = Select;
const { Group } = Radio;
const EstimateForm = (props) => {
  const {
    form,
    estimateNo,
    id,
    jobNo,
    setJobNo,
    partsData,
    setPartsData,
    jobCode,
    setJobCode,
    editData,
    editable,
    onEdit,
    modifyType,
    isCEO,
    modifyAccess,
  } = props;

  const partItemData = {
    id: getUUID(),
    partNumber: {},
    imageUrl: "",
    code: "",
    hsn: {},
    quantity: "",
    unitRate: "",
    discount: "",
    rate: "",
    igst: 0,
    cgst: 0,
    sgst: 0,
    gstRate: 0,
    grandTotal: 0,
    igstAmount: 0,
    cgstAmount: 0,
    sgstAmount: 0,
    discountAmount: 0,
    discountPercent: 0,
    remove: "",
  };

  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const history = useHistory();
  const location = useLocation();
  const [model, setModel] = useState();
  const [branch, setBranch] = useState("");
  const [gst, setGst] = useState("");
  const [stateName, setStateName] = useState("");
  // Tax party GSTIN source: Claim No → job customer; Claim Yes → insurer
  const [jobCustomerTax, setJobCustomerTax] = useState({
    GSTNo: "",
    GSTType: "",
  });
  const [selectedInsurerTax, setSelectedInsurerTax] = useState({
    GSTIN: "",
    dealerType: "",
  });
  const [selectedPart, setSelectedPart] = useState("");
  const [itemList, setItemList] = useState([partItemData]);
  const [selectItemObj, setSelectItemObj] = useState({});
  const [discountType, setDiscountType] = useState("");
  const [discountLevel, setDiscountLevel] = useState("TransactionLevel");

  const [serviceType, setServiceType] = useState("");
  const [claimType, setClaimType] = useState("");
  const [claimNumber, setClaimNumber] = useState("");
  const [insurerList, setInsurerList] = useState([]);
  const [survivorList, setSurvivorList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [contact, setContact] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [cusId, setCusId] = useState(null);
  const [claimStatus, setClaimStatus] = useState();
  const [vehicleDetail, setVehicleDetail] = useState();

  const [recPart, setRecPart] = useState("");
  const [quantity, setquantity] = useState();
  const [unitRate, setUnitRate] = useState();
  const [rate, setRate] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [grandTtl, setGrandTotal] = useState(0);
  const [SGST, setSGST] = useState();
  const [CGST, setCGST] = useState();
  const [IGST, setIGST] = useState();
  const [GSTRate18, setGSTRate18] = useState(false);
  const [GSTRate28, setGSTRate28] = useState(false);
  const [GSTRate12, setGSTRate12] = useState(false);
  const [GSTRate5, setGSTRate5] = useState(false);
  const [SGSTAmount, setSGSTAmount] = useState();
  const [CGSTAmount, setCGSTAmount] = useState();
  const [IGSTAmount, setIGSTAmount] = useState();
  const [deleteItem, setDeleteItem] = useState(false);
  const [dataTemp, setDataTemp] = useState([]);
  // searchResults holds ONLY the live search-API response for the open dropdown.
  // dataTemp continues to hold the persistent registry of pre-loaded parts (for
  // existing estimate rows). Keeping them separate prevents the async load
  // callbacks from re-polluting the dropdown with unrelated items after a search.
  const [searchResults, setSearchResults] = useState([]);
  const [deleteData1, setDeleteData1] = useState([]);
  const [deleteData2, setDeleteData2] = useState([]);
  const [pid, setPid] = useState([]);
  const [jid, setJid] = useState([]);
  const [pBranch, setPBranch] = useState("");
  const [btnFlag, setBtnFlag] = useState(false);
  // const partRef = useRef(null);
  const partsRef = {};
  let sgstAmt = 0;
  let cgstAmt = 0;
  let igstAmt = 0;
  const lastSearchRef = useRef("");
  const currentSearchRef = useRef(""); // tracks latest onSearch value to discard stale responses
  const surveyorErrorShownRef = useRef(false);

  const uploadCsv = async (file) => {
    const formData = new FormData();
    formData.append("csv", file);

    try {
      const response = await platformApi.post(
        `api/partsMaster/upload-csv`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.code === 200 && response.data.data) {
        // Process each CSV item
        const existingItems = itemList.filter(
          (item) =>
            item.partNumber &&
            (item.partNumber.partNumber || item.partNumber.code || item.jobCode)
        );

        const csvLength = response.data.data.length;

        let newItemList = [...existingItems];
        let currentTotal = parseFloat(grandTtl) || 0;
        let TotalCgst = 0;
        let TotalSgst = 0;
        let TotalIgst = 0;
        let pCharge = 0;
        let labourCharge = 0;
        let consumableCharge = 0;

        // Process CSV items sequentially
        for (const csvItem of response.data.data) {
          try {
            // Search for the part
            const searchResponse = await platformApi.post(
              "/api/purchaseSpareInvoice/search",
              { search: csvItem.partNumber }
            );

            if (
              searchResponse.data.code === 200 &&
              searchResponse.data.response.code === 200 &&
              searchResponse.data.response.data.partsMasterData.length > 0
            ) {
              const existingPart =
                searchResponse.data.response.data.partsMasterData[0];

              // Create new row
              const newRow = {
                ...partItemData,
                id: getUUID(),
                partNumber: existingPart,
                hsn: existingPart.hsn || null,
                cgst: existingPart.hsn ? existingPart.hsn.cgst : 0,
                igst: existingPart.hsn ? existingPart.hsn.igst : 0,
                sgst: existingPart.hsn ? existingPart.hsn.sgst : 0,
                gstRate: existingPart.hsn ? (Number(existingPart.hsn.cgst || 0) + Number(existingPart.hsn.sgst || 0)) : 0,
                unitRate: existingPart.mrp,
                quantity: csvItem.quantity || 1,
                rate: existingPart.mrp * (csvItem.quantity || 1),
                grossAmount: existingPart.mrp * (csvItem.quantity || 1),
                isFromCsv: true,
              };
              // Calculate GST amounts
              newRow.sgstAmount = parseFloat(
                // (newRow.sgst / 100) * newRow.rate
                newRow.rate - newRow.rate / (1 + newRow.sgstAmount / 100)
              ).toFixed(2);
              newRow.igstAmount = parseFloat(
                newRow.rate - newRow.rate / (1 + newRow.igstAmount / 100)
                // (newRow.igst / 100) * newRow.rate
              ).toFixed(2);
              newRow.cgstAmount = parseFloat(
                newRow.rate - newRow.rate / (1 + newRow.cgstAmount / 100)
                // (newRow.cgst / 100) * newRow.rate
              ).toFixed(2);

              // Update totals
              currentTotal += parseFloat(newRow.rate);
              TotalCgst += parseFloat(newRow.cgstAmount);
              TotalSgst += parseFloat(newRow.sgstAmount);
              TotalIgst += parseFloat(newRow.igstAmount);

              // Update charges
              if (newRow.partNumber.hsn) {
                pCharge += parseFloat(newRow.rate);
              }

              // Add new row
              newItemList.push(newRow);
            } else {
              message.warning(
                `Part ${csvItem.partNumber} not found in database`
              );
            }
          } catch (error) {
            console.error(
              `Error searching for part ${csvItem.partNumber}:`,
              error
            );
            message.error(`Error processing part ${csvItem.partNumber}`);
          }
        }

        // Add empty row at the end
        newItemList.push({ ...partItemData, id: getUUID() });

        // Update form values
        form.setFieldsValue({
          totalAmount: currentTotal.toFixed(0),
          cgst: TotalCgst.toFixed(2),
          sgst: TotalSgst.toFixed(2),
          igst: TotalIgst.toFixed(2),
          partCharge: pCharge.toFixed(2),
          labourCharge: labourCharge.toFixed(2),
          consumableCharge: consumableCharge.toFixed(2),
        });

        // Update state in a single batch
        setItemList(newItemList);
        setGrandTotal(currentTotal.toFixed(2));

        message.success(`Uploaded ${csvLength} parts from CSV`);
      } else {
        message.error(
          "Failed to upload CSV: " + (response.data.message || "Unknown error")
        );
      }
    } catch (error) {
      console.error("Error uploading CSV:", error);
      message.error(
        "Failed to upload CSV: " + (error.message || "Unknown network error")
      );
    }
  };

  useEffect(() => {
    const obj = {};
    for (const item of itemList) {
      if (item.partNumber && item.partNumber.id) {
        obj[item.partNumber.id] = true;
      }
    }
    setSelectItemObj(obj);
  }, [itemList]);

  useEffect(() => {
    if (location.state) {
      setGst(location.state.gst);
    }
  }, [location.state]);

  // Display tax party GSTIN: Claim Yes → insurer; Claim No → job customer
  useEffect(() => {
    let partyGstin = "";
    if (claimStatus) {
      const dealerType = String(
        selectedInsurerTax?.dealerType || ""
      ).toUpperCase();
      const isRegisteredDealer =
        dealerType.includes("REGISTERED") &&
        !dealerType.includes("UNREGISTERED");
      const insuranceGst = String(
        selectedInsurerTax?.GSTIN || selectedInsurerTax?.gstin || ""
      ).trim();
      if (isRegisteredDealer && insuranceGst) {
        partyGstin = insuranceGst;
      }
    } else {
      const gstType = String(jobCustomerTax?.GSTType || "").toUpperCase();
      const isRegistered =
        (gstType.includes("REGISTERED") || gstType.includes("COMPOSITION")) &&
        !gstType.includes("UNREGISTERED");
      const customerGst = String(jobCustomerTax?.GSTNo || "").trim();
      if (isRegistered && customerGst) {
        partyGstin = customerGst;
      }
    }
    setStateName(partyGstin);
  }, [claimStatus, jobCustomerTax, selectedInsurerTax]);

  //EditData
  useEffect(() => {
    if (editData) {
      if (editData.branch?.id || editData.jobOrder?.branch?.id) {
        setPBranch(editData.branch?.id || editData.jobOrder?.branch?.id);
      }
      setVehicleDetail(editData.jobOrder.vehicle);

      setDiscountLevel(editData.discountLevel);
      setDiscountType(editData.discountType);
      setGrandTotal(editData.estTotalAmount ? editData.estTotalAmount : 0);
      const editCustomer = editData.jobOrder?.customer;
      setJobCustomerTax({
        GSTNo: editCustomer?.GSTNo || "",
        GSTType: editCustomer?.GSTType || "",
      });
      // Claim Yes tax party: insurer may be slim (id/name) — fall back to Insurance
      const editInsurer = editData.insurer || editData.Insurance || null;
      if (editInsurer) {
        setSelectedInsurerTax({
          GSTIN:
            editInsurer.GSTIN ||
            editInsurer.gstin ||
            editData.Insurance?.GSTIN ||
            editData.Insurance?.gstin ||
            "",
          dealerType:
            editInsurer.dealerType ||
            editData.Insurance?.dealerType ||
            "",
        });
      }
      if (editData.branch?.gst || editData.jobOrder?.branch?.gst) {
        setGst(editData.branch?.gst || editData.jobOrder?.branch?.gst);
      }

      if (editData.discountLevel === "TransactionLevel") {
        if (editData.discountPercent !== 0) {
          setDiscountAmount(editData.discountPercent);
          setDiscountType("percent");
        }
        if (editData.discountRate !== 0) {
          setDiscountAmount(editData.discountRate);
          setDiscountType("rupee");
        }
      }

      const updateItemList = [...editData.estimateItemInvoice];

      for (let i = 0; i < updateItemList.length; i++) {
        if (updateItemList[i].jobCode) {
          // Set partNumber to the actual jobCode object so the Details dropdown
          // can find it by partNumber.code matching dataTemp entries
          updateItemList[i].partNumber = { ...updateItemList[i].jobCode };
          updateItemList[i].rate =
            updateItemList[i].quantity * updateItemList[i].unitRate;
          const sac = updateItemList[i].sac || updateItemList[i].jobCode?.sac || null;
          updateItemList[i].hsn = sac;
          updateItemList[i].cgst = sac ? sac.cgst : 0;
          updateItemList[i].sgst = sac ? sac.sgst : 0;
          updateItemList[i].igst = sac ? sac.igst : 0;
          updateItemList[i].gstRate = sac
            ? (Number(sac.cgst) || 0) + (Number(sac.sgst) || 0)
            : 0;
          setUnitRate(updateItemList[i].unitRate);
          if (updateItemList[i].gstRate === GST28) {
            setGSTRate28(true);
          }
          if (updateItemList[i].gstRate === GST18) {
            setGSTRate18(true);
          }
          if (updateItemList[i].gstRate === GST12) {
            setGSTRate12(true);
          }
        } else {
          // Skip orphaned items (neither partNumber nor jobCode linked)
          if (!updateItemList[i].partNumber && !updateItemList[i].jobCode) {
            continue;
          }
          const item = updateItemList[i];
          item.rate = parseFloat(item.quantity || 0) * parseFloat(item.unitRate || 0);
          // Populate gstRate from stored cgst+sgst so GSTTable renders correctly
          item.gstRate = (Number(item.cgst || 0) + Number(item.sgst || 0));
          // Parse Decimal amounts to 2dp to avoid floating-point display issues
          item.cgstAmount = parseFloat(item.cgstAmount || 0).toFixed(2);
          item.sgstAmount = parseFloat(item.sgstAmount || 0).toFixed(2);
          item.igstAmount = parseFloat(item.igstAmount || 0).toFixed(2);
        }
      }

      // Set form values immediately
      const formValues = {
        JobNo: editData.jobOrder.id,
        branch: editData.branch?.name || editData.jobOrder.branch?.name,
        serviceType: editData.serviceType,
        discountType: editData.discountType,
        discountLevel: editData.discountLevel,
        labourCharge: editData.labourCharge || 0,
        consumableCharge: editData.consumableCharge || 0,
        partCharge: editData.partCharge || 0,
        totalDiscount: editData.totalDiscount || 0,
        sgst: editData.sgstAmount || 0,
        cgst: editData.cgstAmount || 0,
        igst: editData.igstAmount || 0,
        totalAmount: editData.estTotalAmount || 0,
      };

      if (editData.serviceType === "Accidental") {

        if (editData?.survivor && survivorList.every(s => s.id !== editData.survivor.id)) {
          setSurvivorList(prev => [...prev, editData.survivor]);
        }

        setFieldsValue({
          ...formValues,
          claimStatus: editData.claimStatus,
          claimType: editData.claimType || "",
          claimNumber: editData.claimNumber || "",
          insurer: editData.insurer?.name || undefined,
          survivor: editData.survivor?.id || undefined,
        });

        // Set state values after form values
        setClaimStatus(editData.claimStatus);
        setClaimType(editData.claimType || "");
        setClaimNumber(editData.claimNumber || "");
        setServiceType(editData.serviceType);
      } else {
        setFieldsValue(formValues);
      }

      // Set job order data
      setJobNo([editData.jobOrder]);
      setModel(editData.jobOrder.vehicle?.vehicle?.id);

      // Set item list
      setItemList(updateItemList);

      // Set delete data
      for (let item of editData.estimateItemInvoice) {
        if (item.jobCode) {
          jid.push(item.id);
        } else {
          pid.push(item.id);
        }
      }
      setPid(pid);
      setJid(jid);
    }
  }, [editData]);

  //setBranch
  useEffect(() => {
    platformApi.get("/api/user/currentUser").then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setBranch(response.data.profile.branch[0].id);
          setPBranch((prev) => prev || response.data.profile.branch[0].id);
        }
      }
    });

    // Set discount level after a small delay
    setTimeout(() => {
      setFieldsValue({
        discountLevel: discountLevel,
      });
    }, 0);
  }, []);
  //Props

  useEffect(() => {
    if (location.state && location.state.jobNo) {
      setFieldsValue({
        JobNo: location.state.jobNo,
      });

      const applyClaimIntimation = (jobOrderData) => {
        if (!jobOrderData) return;
        const claimObj = Array.isArray(jobOrderData.ClaimIntimation)
          ? jobOrderData.ClaimIntimation[0]
          : jobOrderData.ClaimIntimation;

        if (claimObj) {
          const cType = claimObj.claimType || "Cashless";
          const cNum = claimObj.claimNumber || "";
          const insurerName = claimObj.Insurance?.name || claimObj.insurer;
          const surveyorId = claimObj.Customer?.id || claimObj.surveyor;

          const hasClaimData = Boolean(claimObj.claimType && claimObj.insurer);

          form.setFieldsValue({
            claimStatus: hasClaimData,
          });
          setClaimStatus(hasClaimData);

          if (hasClaimData) {
            setClaimType(cType);
            setClaimNumber(cNum);

            if (claimObj.Insurance) {
              setSelectedInsurerTax({
                GSTIN:
                  claimObj.Insurance.GSTIN ||
                  claimObj.Insurance.gstin ||
                  "",
                dealerType: claimObj.Insurance.dealerType || "",
              });
              setInsurerList((prev) => {
                if (!prev.some((ins) => ins.id === claimObj.Insurance.id)) {
                  return [...prev, claimObj.Insurance];
                }
                return prev;
              });
            }

            if (claimObj.Customer) {
              // Normalize: build contacts from CustomerPhone if present
              const normalizedCustomer = {
                ...claimObj.Customer,
                contacts: claimObj.Customer.contacts?.length
                  ? claimObj.Customer.contacts
                  : (claimObj.Customer.CustomerPhone || []).map((cp) => ({
                      phone: cp.mobileNo || cp.phone || ""
                    }))
              };
              setSurvivorList((prev) => {
                if (!prev.some((s) => s.id === normalizedCustomer.id)) {
                  return [...prev, normalizedCustomer];
                }
                return prev;
              });
            }

            setTimeout(() => {
              form.setFieldsValue({
                claimType: cType,
                claimNumber: cNum,
                insurer: insurerName,
                survivor: surveyorId,
              });
            }, 300);
          }
        } else {
          form.setFieldsValue({
            claimStatus: false,
          });
          setClaimStatus(false);
          setSelectedInsurerTax({ GSTIN: "", dealerType: "" });
        }
      };

      if (!jobNo.some((tempItem) => location.state.jobNo === tempItem.id)) {
        platformApi.get("/api/jobOrder/" + location.state.jobNo).then((res) => {
          let { data } = res;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              setVehicleDetail(response.data.vehicle);
              setJobCustomerTax({
                GSTNo: response.data.customer?.GSTNo || "",
                GSTType: response.data.customer?.GSTType || "",
              });
              if (response.data.branch?.gst) {
                setGst(response.data.branch.gst);
              }
              setJobNo([...jobNo, response.data]);

              form.setFieldsValue({
                branch: response.data.branch?.name,
                serviceType:
                  response.data.serviceType === "Accidental"
                    ? "Accidental"
                    : "Non Accidental",
              });

              setServiceType(
                response.data.serviceType === "Accidental"
                  ? "Accidental"
                  : "Non Accidental"
              );

              applyClaimIntimation(response.data);
            }
          }
        });
      } else {
        const found = jobNo.find((item) => item.id === location.state.jobNo);
        if (found) {
          applyClaimIntimation(found);
        }
      }
    }
  }, [location.state, jobNo]);

  useEffect(() => {
    if (partsData || jobCode) {
      let temp = [];
      partsData.map((item) => {
        temp.push({
          label: `${item.partNumber} - ${item.partName}`,
          value: item.partNumber,
          id: item.id,
        });
      });

      jobCode.map((item) => {
        temp.push({
          label: item.code,
          value: item.code,
          id: item.id,
          consumable: item.consumable,
        });
      });
      setDataTemp(temp);
    }
  }, [partsData, jobCode]);

  useEffect(() => {
    if (claimStatus) {
      getInsurer();
      getSurvivor();
    }
  }, [claimStatus]);

  const getSurvivor = (searchString = "") => {
    const payload = {
      module: "customers",
      column: "phone",
      fields: ["contacts{phone}"],
      size: 50,
      searchColumns: ["contacts"],
      searchString: searchString,
    };
    platformApi.post("/api/options/get", payload).then((res) => {
      setSurvivorList(res.data?.response || []);
    });
  };

  const handleSurveyorSearch = (value) => {
    if (!value) {
      surveyorErrorShownRef.current = false;
      lastSearchRef.current = "";
      setContact("");
      setSurvivorList([]);
      getSurvivor("");
      return;
    }

    if (/\D/.test(value)) {
      if (!surveyorErrorShownRef.current) {
        message.error("Please enter Mobile No", 2);
        surveyorErrorShownRef.current = true;
      }
      setSurvivorList([]);
      return;
    }

    surveyorErrorShownRef.current = false;
    lastSearchRef.current = value;
    setContact(value);
    setSurvivorList([]);
    getSurvivor(value);
  };

  const getInsurer = () => {
    platformApi.get("/api/insurance").then((res) => {
      const result = res.data.response.data;
      setInsurerList(result);
    });
  };

  const getJobCodes = () => {
    platformApi
      .get("/api/jobCode/")
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          setJobCode(data.response.data);
        }
      })
      .catch((err) => {
        console.error("JobCode Fetch Error: ", err);
        message.error("Couldn't Fetch JobCodes");
      });
  };

  const getParts = () => {
    // platformApi
    //     .post(`/api/sparesInventory/branch/get`, {
    //         page: 1,
    //         size: 100,
    //         searchString: ""
    //     })
    //     .then((res) => {
    //         const { data } = res;
    //         if (data.code === 200) {
    //             const { response } = data;
    //             if (response.code === 200) {
    //                 let parts = []
    //                 for (let i = 0; i < response.data.length; i++) {
    //                     const element = response.data[i];
    //                     if (element.phyQuantity > 0) {
    //                         parts.push(element.partNo)
    //                     }
    //                 }
    //                 setPartsData(parts)
    //             }
    //         }
    //         else {
    //             message.error("Unable to fetch Parts", 2);
    //         }
    //     })
    //     .catch((error) => {
    //         console.error("Error on Parts Master : ", error);
    //         message.error("Unable to fetch Parts", 2);
    //     });
    let data = {
      module: "partsMasters",
      size: 100,
      column: "partNumber",
      fields: ["partNumber", "partName"],
    };
    platformApi
      .post("/api/options/get", data)
      .then((res) => {
        const { data } = res;
        setPartsData(data.response);
      })
      .catch((err) => {
        console.error("Part Fetch Error: ", err);
        message.error("Couldn't Fetch Parts");
      });
  };

  const getJobOrder = (value) => {
    setFieldsValue({
      JobNo: value,
    });
    let grandTotal = 0;
    let TotalCgst = 0;
    let TotalSgst = 0;
    let TotalIgst = 0;
    let pCharge = 0;
    let labourCharge = 0;
    let consumableCharge = 0;
    let estTotal = 0;
    let temp = 0;
    platformApi
      .get("/api/materialIssue/jobMaterial/" + value)
      .then((resp) => {
        let { data } = resp;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            if (response.data) {
              let partItemList = [];
              if (response.data.length && response.data[0].parts) {
                for (let i = 0; i < response.data.length; i++) {
                  const element = response.data[i];
                  partItemList.push(...element.parts);
                }
                // partItemList = [...response.data[0].parts]
              } else {
                message.info("No Materials in this JobOrder");
              }
              for (let i = 0; i < partItemList.length; i++) {
                const item = { ...partItemList[i].part };
                if (
                  !dataTemp.some(
                    (tempItem) => item.partNumber === tempItem.value
                  )
                ) {
                  platformApi.get("/api/partsMaster/" + item.id).then((res) => {
                    let { data } = res;
                    if (data.code === 200) {
                      let { response } = data;
                      if (response.code === 200) {
                        const temp = {
                          label: `${response.data.partNumber} - ${response.data.partName}`,
                          value: response.data.partNumber,
                          id: response.data.id,
                        };
                        setDataTemp([...dataTemp, temp]);
                      }
                    }
                  });
                }

                partItemList[i].partNumber = item;
                partItemList[i].partNumber.partName = partItemList[i].partName;
                partItemList[i].hsn = item.hsn;
                partItemList[i].cgst = item.hsn && item.hsn.cgst;
                partItemList[i].sgst = item.hsn && item.hsn.sgst;
                partItemList[i].igst = item.hsn && item.hsn.igst;
                partItemList[i].gstRate = item.hsn && item.hsn.igst;
                // partItemList[i].quantity = partItemList[i].quantity
                partItemList[i].unitRate = partItemList[i].mrp;
                partItemList[i].rate =
                  partItemList[i].quantity * partItemList[i].unitRate;
                partItemList[i].sgstAmount = parseFloat(
                  (partItemList[i].sgst / 100) * partItemList[i].rate
                ).toFixed(2);
                partItemList[i].igstAmount = parseFloat(
                  (partItemList[i].igst / 100) * partItemList[i].rate
                ).toFixed(2);
                partItemList[i].cgstAmount = parseFloat(
                  (partItemList[i].cgst / 100) * partItemList[i].rate
                ).toFixed(2);

                setSelectedPart(item.partNumber);

                let total = parseFloat(partItemList[i].rate);
                // let finTotal = parseFloat(partItemList[i].rate)
                // let gstRateValue = (partItemList[i].gstRate / 100) + parseInt(1);
                // taxExlusive = (total * (partItemList[i].gstRate / 100)).toFixed(2);
                // total = (parseFloat(total) + parseFloat(taxExlusive)).toFixed(2);
                // partItemList[i].grandTotal = finTotal

                partItemList[i].grandTotal = total;
                if (partItemList[i].gstRate === GST28) {
                  setGSTRate28(true);
                }
                if (partItemList[i].gstRate === GST18) {
                  setGSTRate18(true);
                }
                if (partItemList[i].gstRate === GST12) {
                  setGSTRate12(true);
                }
                if (partItemList[i].gstRate === GST5) {
                  setGSTRate5(true);
                }
              }
              let updateItemList = [...partItemList];

              for (let i = 0; i < updateItemList.length; i++) {
                grandTotal =
                  parseFloat(grandTotal) +
                  parseFloat(updateItemList[i].grandTotal);
                grandTotal = grandTotal.toFixed(2);
                estTotal =
                  parseFloat(estTotal) +
                  parseFloat(updateItemList[i].grandTotal);
                estTotal = estTotal.toFixed(0);
                TotalCgst =
                  parseFloat(TotalCgst) +
                  parseFloat(updateItemList[i].cgstAmount);
                TotalCgst = TotalCgst.toFixed(2);
                TotalSgst =
                  parseFloat(TotalSgst) +
                  parseFloat(updateItemList[i].sgstAmount);
                TotalSgst = TotalSgst.toFixed(2);
                TotalIgst =
                  parseFloat(TotalIgst) +
                  parseFloat(updateItemList[i].igstAmount);
                TotalIgst = TotalIgst.toFixed(2);

                if (updateItemList[i].rate) {
                  if (
                    updateItemList[i].partNumber.code ||
                    updateItemList[i].jobCode
                  ) {
                    if (
                      updateItemList[i].partNumber?.consumable ||
                      updateItemList[i].jobCode?.consumable
                    ) {
                      consumableCharge =
                        parseFloat(consumableCharge) +
                        parseFloat(updateItemList[i].rate);
                    } else {
                      labourCharge =
                        parseFloat(labourCharge) +
                        parseFloat(updateItemList[i].rate);
                    }
                  } else if (updateItemList[i].partNumber.hsn) {
                    pCharge =
                      parseFloat(pCharge) + parseFloat(updateItemList[i].rate);
                  }
                }
                let roundoff = String(grandTotal).split(".");
                if (roundoff[1] === "00") {
                  temp = "0.00";
                } else if (parseInt(roundoff[1]) >= 50) {
                  temp = 100 - parseInt(roundoff[1]);
                  temp = `+0.${temp}`;
                } else if (parseInt(roundoff[1]) < 50) {
                  temp = 100 - parseInt(roundoff[1]);
                  temp = `-0.${parseInt(roundoff[1])}`;
                }
              }
              form.setFieldsValue({
                grantTotal: estTotal,
                totalInvoice: estTotal,
                partCharge: pCharge,
                labourCharge: labourCharge,
                consumableCharge: consumableCharge,
                cgst: TotalCgst,
                sgst: TotalSgst,
                igst: TotalIgst,
                roundoff: temp,
              });
              // setGrandTotal(grandTotal);
              // setTotalInvoice(estTotal);
              // setInitialData(updateItemList)
              setItemList((prev) => {
                // build newItemList based on prev, not on a possibly stale closure
                const existingItems = prev.filter(
                  (item) =>
                    item.partNumber &&
                    (item.partNumber.partNumber ||
                      item.partNumber.code ||
                      item.jobCode)
                );
                const updatedList = [
                  ...existingItems,
                  ...updateItemList,
                  { ...partItemData, id: getUUID() },
                ];
                return updatedList;
              });
            }
          }
        }
      })
      .catch((error) => {
        message.error("Unable to get Materials");
        console.error("Error on get Materials : ", error);
      });
    platformApi.get("/api/jobOrder/" + value).then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          if (response.data) {
            setVehicleDetail(response.data.vehicle);
            setJobCustomerTax({
              GSTNo: response.data.customer?.GSTNo || "",
              GSTType: response.data.customer?.GSTType || "",
            });
            if (response.data.branch?.gst) {
              setGst(response.data.branch.gst);
            }
            setPBranch(response.data.branch && response.data.branch.id);
            setJobNo([...jobNo, response.data]);
            setModel(
              response.data.vehicle && response.data.vehicle?.vehicle?.id
            );
            form.setFieldsValue({
              branch: response.data.branch?.name,
            });
          }
        }
      }
    });
    // getJobNo();
  };
  //itemList
  useEffect(() => {
    // Only add new row if the last item has data
    if (
      itemList &&
      itemList?.length > 0 &&
      (itemList[itemList?.length - 1].partNumber?.partNumber ||
        itemList[itemList?.length - 1].partNumber?.code ||
        itemList[itemList?.length - 1].quantity?.length > 0) &&
      !itemList[itemList?.length - 1].isFromCsv // Add this check
    ) {
      handleAdd();
    }
    const selectItem = {};
    for (const item of itemList) {
      if (item.partNumber && item.partNumber.id) {
        selectItem[item.partNumber.id] = item.partNumber;
      }
    }
    setSelectItemObj(selectItem);
  }, [itemList]);

  //Quantity
  useEffect(() => {
    let num = 0;
    let newItemList = [...itemList];
    if (unitRate > 0 && quantity > 0) {
      if (newItemList.length > 0) {
        for (let i = 0; i < newItemList.length; i++) {
          if (newItemList[i].quantity > 0 && newItemList[i].unitRate > 0) {
            newItemList[i].rate = (
              parseFloat(newItemList[i].quantity) *
              parseFloat(newItemList[i].unitRate)
            ).toFixed(2);
            newItemList[i].sgstAmount = parseFloat(
              (newItemList[i].sgst / 100) * newItemList[i].rate
            ).toFixed(2);
            newItemList[i].igstAmount = parseFloat(
              (newItemList[i].igst / 100) * newItemList[i].rate
            ).toFixed(2);
            newItemList[i].cgstAmount = parseFloat(
              (newItemList[i].cgst / 100) * newItemList[i].rate
            ).toFixed(2);
            sgstAmt = newItemList[i].sgstAmount;
            cgstAmt = newItemList[i].cgstAmount;
            igstAmt = newItemList[i].igstAmount;
          }
        }
      }
      setSGSTAmount(sgstAmt);
      setIGSTAmount(igstAmt);
      setCGSTAmount(cgstAmt);
      setItemList(newItemList);
      setquantity(undefined);
      // setUnitRate(undefined)
    }
  }, [unitRate, quantity]);

  //PMC
  useEffect(() => {
    let grandTotal = 0;
    let TotalCgst = 0;
    let TotalSgst = 0;
    let TotalIgst = 0;
    let pCharge = 0;
    let taxExlusive = 0;
    let labourCharge = 0;
    let consumableCharge = 0;
    let estTotal = 0;
    let temp = 0;
    if (recPart === "yes") {
      const jobId = jobNo.filter((item) => {
        return item.id === getFieldValue("JobNo");
      });
      if (jobId.length) {
        platformApi
          .post("/api/pmc/getCodes", {
            model: jobId[0].vehicle?.vehicle.id,
            kms: jobId[0].kms,
            serviceNo: jobId[0].serviceNo,
            serviceType: jobId[0].serviceType,
          })
          .then((res) => {
            let { data } = res;
            if (data.code === 200) {
              let { response } = data;
              if (response.code === 200) {
                if (
                  response.data.length &&
                  (response.data[0].jobCodes.length ||
                    response.data[0].partsConsumable.length)
                ) {
                  let jobCodeItemList = [];
                  let partItemList = [];
                  if (response.data[0].jobCodes) {
                    jobCodeItemList = [...response.data[0].jobCodes];
                  }
                  if (response.data[0].partsConsumable) {
                    partItemList = [...response.data[0].partsConsumable];
                  }

                  for (let i = 0; i < partItemList.length; i++) {
                    // Skip items where partNumber is null or has no id
                    if (!partItemList[i].partNumber || !partItemList[i].partNumber.id) {
                      continue;
                    }
                    const item = { ...partItemList[i].partNumber };
                    if (
                      !dataTemp.some(
                        (tempItem) => item.partNumber === tempItem.value
                      )
                    ) {
                      platformApi
                        .get("/api/partsMaster/" + item.id)
                        .then((res) => {
                          let { data } = res;
                          if (data.code === 200) {
                            let { response } = data;
                            if (response.code === 200) {
                              const temp = {
                                label: `${response.data.partNumber} - ${response.data.partName}`,
                                value: response.data.partNumber,
                                id: response.data.id,
                              };
                              setDataTemp([...dataTemp, temp]);
                            }
                          }
                        });
                    }
                    partItemList[i].partNumber = item;
                    partItemList[i].hsn = item.hsn;
                    partItemList[i].cgst = item.hsn && item.hsn.cgst;
                    partItemList[i].sgst = item.hsn && item.hsn.sgst;
                    partItemList[i].igst = item.hsn && item.hsn.igst;
                    partItemList[i].gstRate = item.hsn
                      ? (Number(item.hsn.cgst || 0) + Number(item.hsn.sgst || 0))
                      : 0;
                    partItemList[i].unitRate = item.mrp ? item.mrp : 1;
                    partItemList[i].rate =
                      partItemList[i].quantity * partItemList[i].unitRate;
                    partItemList[i].sgstAmount = parseFloat(
                      (partItemList[i].sgst / 100) * partItemList[i].rate
                    ).toFixed(2);
                    partItemList[i].igstAmount = parseFloat(
                      (partItemList[i].igst / 100) * partItemList[i].rate
                    ).toFixed(2);
                    partItemList[i].cgstAmount = parseFloat(
                      (partItemList[i].cgst / 100) * partItemList[i].rate
                    ).toFixed(2);
                    setSelectedPart(item.partNumber);
                    // setUnitRate(item.mrp)

                    let total = parseFloat(partItemList[i].rate);
                    let finTotal = parseFloat(partItemList[i].rate);

                    let gstRateValue =
                      partItemList[i].gstRate / 100 + parseInt(1);
                    taxExlusive = (
                      total *
                      (partItemList[i].gstRate / 100)
                    ).toFixed(2);
                    total = (
                      parseFloat(total) + parseFloat(taxExlusive)
                    ).toFixed(2);

                    // partItemList[i].grandTotal = total
                    partItemList[i].grandTotal = finTotal;
                    if (partItemList[i].gstRate === GST28) {
                      setGSTRate28(true);
                    }
                    if (partItemList[i].gstRate === GST18) {
                      setGSTRate18(true);
                    }
                    if (partItemList[i].gstRate === GST12) {
                      setGSTRate12(true);
                    }
                    if (partItemList[i].gstRate === GST5) {
                      setGSTRate5(true);
                    }

                    // setSGSTAmount(sgstAmt)
                    // setIGSTAmount(igstAmt)
                    // setCGSTAmount(cgstAmt)
                  }

                  for (let j = 0; j < jobCodeItemList.length; j++) {
                    const jcItem = jobCodeItemList[j];
                    const jobCode = jcItem.jobCode;

                    if (!jobCode) continue; // skip if jobCode missing

                    // ✅ Set partNumber to the ACTUAL jobCode object so
                    //    partNumber.code is defined and submit filter keeps it
                    jcItem.partNumber = { ...jobCode };

                    const sac = jobCode.sac || null;
                    jcItem.hsn = sac;
                    jcItem.cgst = sac ? (sac.cgst || 0) : 0;
                    jcItem.sgst = sac ? (sac.sgst || 0) : 0;
                    jcItem.igst = sac ? (sac.igst || 0) : 0;
                    jcItem.gstRate = sac
                      ? (Number(sac.cgst) || 0) + (Number(sac.sgst) || 0)
                      : 0;

                    // Get price for this vehicle model (null-safe)
                    const vehiclePriceEntry = jobCode.vehicleModel &&
                      jobCode.vehicleModel.find(vm => vm.vehicle && vm.vehicle.id === jobId[0]?.vehicle?.vehicle?.id);
                    jcItem.unitRate = vehiclePriceEntry
                      ? vehiclePriceEntry.price
                      : (jobCode.vehicleModel?.[0]?.price || 0);

                    setSelectedPart(jobCode.code);

                    jcItem.rate = (
                      parseFloat(jcItem.quantity || 1) *
                      parseFloat(jcItem.unitRate || 0)
                    ).toFixed(2);

                    jcItem.sgstAmount = parseFloat(
                      (jcItem.sgst / 100) * jcItem.rate
                    ).toFixed(2);
                    jcItem.igstAmount = parseFloat(
                      (jcItem.igst / 100) * jcItem.rate
                    ).toFixed(2);
                    jcItem.cgstAmount = parseFloat(
                      (jcItem.cgst / 100) * jcItem.rate
                    ).toFixed(2);

                    // Labour & Consumables: GST-Exclusive — grandTotal = rate + GST on top
                    let total = parseFloat(jcItem.rate);
                    total = total + parseFloat((jcItem.gstRate / 100) * total);
                    jcItem.grandTotal = total;

                    if (jcItem.gstRate === GST28) setGSTRate28(true);
                    if (jcItem.gstRate === GST18) setGSTRate18(true);
                    if (jcItem.gstRate === GST12) setGSTRate12(true);
                    if (jcItem.gstRate === GST5) setGSTRate5(true);
                  }
                  // Bug fix: filter out orphaned PMC items skipped by `continue` in both loops.
                  // The `continue` only skips mutation — raw null-relation items still remain
                  // in the array and render as blank "Part Number" rows with NaN amounts.
                  const validPartItems = partItemList.filter(
                    item => item.partNumber && item.partNumber.id
                  );
                  const validJobCodeItems = jobCodeItemList.filter(
                    item => item.jobCode && item.jobCode.id
                  );
                  let updateItemList = [...validPartItems, ...validJobCodeItems];

                  for (let i = 0; i < updateItemList.length; i++) {
                    grandTotal =
                      parseFloat(grandTotal) +
                      parseFloat(updateItemList[i].grandTotal);
                    grandTotal = grandTotal.toFixed(2);
                    estTotal =
                      parseFloat(estTotal) +
                      parseFloat(updateItemList[i].grandTotal);
                    TotalCgst =
                      parseFloat(TotalCgst) +
                      parseFloat(updateItemList[i].cgstAmount);
                    TotalCgst = TotalCgst.toFixed(2);
                    TotalSgst =
                      parseFloat(TotalSgst) +
                      parseFloat(updateItemList[i].sgstAmount);
                    TotalSgst = TotalSgst.toFixed(2);
                    TotalIgst =
                      parseFloat(TotalIgst) +
                      parseFloat(updateItemList[i].igstAmount);
                    TotalIgst = TotalIgst.toFixed(2);

                    if (updateItemList[i].rate) {
                      if (
                        updateItemList[i].partNumber.code ||
                        updateItemList[i].jobCode
                      ) {
                        if (
                          updateItemList[i].partNumber?.consumable ||
                          updateItemList[i].jobCode?.consumable
                        ) {
                          consumableCharge =
                            parseFloat(consumableCharge) +
                            parseFloat(updateItemList[i].rate);
                        } else {
                          labourCharge =
                            parseFloat(labourCharge) +
                            parseFloat(updateItemList[i].rate);
                        }
                      } else if (updateItemList[i].partNumber.hsn) {
                        pCharge =
                          parseFloat(pCharge) +
                          parseFloat(updateItemList[i].rate);
                      }
                    }
                    // setGrandTotal(grandTotal);
                  }
                  let roundoff = String(grandTotal).split(".");
                  if (roundoff[1] === "00") {
                    temp = "0.00";
                  } else if (parseInt(roundoff[1]) >= 50) {
                    temp = 100 - parseInt(roundoff[1]);
                    temp = `+0.${temp}`;
                  } else if (parseInt(roundoff[1]) < 50) {
                    temp = 100 - parseInt(roundoff[1]);
                    temp = `-0.${parseInt(roundoff[1])}`;
                  }

                  form.setFieldsValue({
                    totalAmount: estTotal,
                    cgst: TotalCgst,
                    sgst: TotalSgst,
                    igst: TotalIgst,
                    partCharge: pCharge,
                    labourCharge: labourCharge,
                    consumableCharge: consumableCharge,
                    roundoff: temp,
                  });
                  setItemList((prev) => {
                    // build newItemList based on prev, not on a possibly stale closure
                    const existingItems = prev.filter(
                      (item) =>
                        item.partNumber &&
                        (item.partNumber.partNumber ||
                          item.partNumber.code ||
                          item.jobCode)
                    );
                    const updatedList = [
                      ...existingItems,
                      ...updateItemList,
                      { ...partItemData, id: getUUID() },
                    ];
                    return updatedList;
                  });
                } else {
                  message.info("No Recommended Parts and Job Codes");
                }
              } else {
                message.error("No Recommended Parts and Job Codes");
              }
            } else {
              message.error("No Recommended Parts and Job Codes");
            }
          })
          .catch((error) => {
            console.error("Error on PMC : ", error);
            message.error("Failed to fetch Parts and Job Codes");
          });
      }
    }
  }, [recPart]);

  //Discount
  useEffect(() => {
    let val = 0;
    let discountedPrice = 0;
    let newItemList = [...itemList];
    // Transaction level Dicount Calculation
    if (discountLevel === "TransactionLevel") {
      for (let i = 0; i < newItemList.length; i++) {
        let total = parseFloat(
          newItemList[i].unitRate * newItemList[i].quantity
        );
        let gstRateValue = newItemList[i].gstRate / 100 + parseInt(1);
        if (
          discountAmount > 0 &&
          newItemList[i].unitRate > 0 &&
          newItemList[i].quantity
        ) {
          if (discountType === "percent") {
            discountedPrice = (parseFloat(discountAmount) / 100) * total;
            val = val + discountedPrice;
            val = Math.round(val);
            setTotalDiscount(val || 0);
            setFieldsValue({
              totalDiscount: val,
            });
          } else if (discountType === "rupee") {
            val = val + parseFloat(discountAmount);
            setTotalDiscount(val || 0);
            setFieldsValue({
              totalDiscount: val,
            });
          }
        }
      }
    }
    // Item level Discount calculation
    if (discountLevel === "ItemLevel") {
      for (let i = 0; i < newItemList.length; i++) {
        let total = newItemList[i].unitRate * newItemList[i].quantity;
        let gstRateValue = newItemList[i].gstRate / 100 + parseInt(1);
        if (newItemList[i].discount > 0) {
          if (discountType === "percent") {
            discountedPrice =
              (parseFloat(newItemList[i].discount) / 100) * total;
            val = val + discountedPrice;
            setTotalDiscount(val || 0);
            setFieldsValue({
              totalDiscount: val,
            });
          } else if (discountType === "rupee") {
            val = val + parseFloat(newItemList[i].discount);
            setTotalDiscount(val || 0);
            setFieldsValue({
              totalDiscount: val,
            });
          }
        }
      }
    }
    setItemList(newItemList);
  }, [
    discountLevel,
    discountAmount,
    discountType,
    discount,
    quantity,
    unitRate,
    rate,
    grandTtl,
  ]);

  const addCustomerData = (customer) => {
    platformApi
      .post("/api/customer", customer)
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setSurvivorList((prev) => [...prev, response.data]);
            setFieldsValue({ survivor: response.data.id });
            setSelected(null);
            setModalOpen(false);
            message.success("Customer added successfully", 2);
          } else {
            message.error("Unable to add customer", 2);
          }
        } else if (data.code === 500 && data.err.code === 500) {
          message.error("Customer name already exists", 2);
        } else {
          message.error("Unable to add customer", 2);
        }
      })
      .catch((error) => {
        message.error("Unable to add customer", 2);
        console.error("Error on customer : ", error);
      });
  };

  //Render Column
  const renderColumns = () => {
    const columns = [
      {
        title: "S.No",
        dataIndex: "sno",
        key: "sno",
        width: 60,
        render: (text, record, index) => (
          <Form.Item>
            <span>{index + 1}</span>
          </Form.Item>
        ),
      },
      {
        title: "Details",
        dataIndex: "partNumber",
        key: "partNumber",
        width: 360,
        render: (record, data, key) => (
          <Form.Item>
            <Select
              dropdownStyle={{
                overflowY: "auto",
                overflowX: "hidden",
              }}
              onChange={(event) => {
                if (!event) handlePartDetail(event, data);
              }}
              onSelect={(value, option) => {
                handlePartDetail(value, data, option.rawObj);
              }}
              onDropdownVisibleChange={async (open) => {
                if (!open) return;
                // If searchResults already populated, keep existing list
                if (searchResults.length === 0) {
                  try {
                    const [partsRes, jobCodesRes] = await Promise.all([
                      platformApi.post("/api/options/get/", {
                        module: "partsMasters",
                        column: "partNumber",
                        searchString: "",
                        searchColumns: ["partNumber", "partName"],
                        size: 50,
                        page: 1,
                        except: null,
                      }),
                      platformApi.post("/api/options/get/", {
                        module: "jobCodes",
                        column: "code",
                        searchString: "",
                        searchColumns: ["code", "description"],
                        size: 50,
                        page: 1,
                        except: null,
                      }),
                    ]);
                    const freshParts = partsRes?.data?.response || [];
                    const freshJobCodes = jobCodesRes?.data?.response || [];
                    setPartsData(freshParts);
                    setJobCode(freshJobCodes);
                    const initialList = [];
                    freshParts.forEach((item) => {
                      initialList.push({
                        label: `${item.partNumber} - ${item.partName}`,
                        value: item.partNumber,
                        id: item.id,
                        rawObj: item,
                        type: "part",
                      });
                    });
                    freshJobCodes.forEach((item) => {
                      initialList.push({
                        label: `${item.code}${item.description ? ` - ${item.description}` : ""}`,
                        value: item.code,
                        id: item.id,
                        consumable: item.consumable,
                        rawObj: item,
                        type: "jobCode",
                      });
                    });
                    setSearchResults(initialList);
                  } catch (e) {
                    // silently ignore
                  }
                }
              }}
              onSearch={async (event) => {
                currentSearchRef.current = event;

                const [partsRes, jobCodesRes] = await Promise.all([
                  platformApi.post("/api/options/get/", {
                    module: "partsMasters",
                    column: "partNumber",
                    searchString: event,
                    searchColumns: ["partNumber", "partName"],
                    size: 100,
                    page: 1,
                    except: null,
                  }).catch(() => ({ data: { response: [] } })),
                  platformApi.post("/api/options/get/", {
                    module: "jobCodes",
                    column: "code",
                    searchString: event,
                    searchColumns: ["code", "description"],
                    size: 100,
                    page: 1,
                    except: null,
                  }).catch(() => ({ data: { response: [] } })),
                ]);

                if (currentSearchRef.current !== event) return;

                const freshParts = partsRes?.data?.response || [];
                const freshJobCodes = jobCodesRes?.data?.response || [];

                setPartsData(freshParts);
                setJobCode(freshJobCodes);

                const temp = [];
                freshParts.forEach((item) => {
                  temp.push({
                    label: `${item.partNumber} - ${item.partName}`,
                    value: item.partNumber,
                    id: item.id,
                    rawObj: item,
                    type: "part",
                  });
                });
                freshJobCodes.forEach((item) => {
                  temp.push({
                    label: `${item.code}${item.description ? ` - ${item.description}` : ""}`,
                    value: item.code,
                    id: item.id,
                    consumable: item.consumable,
                    rawObj: item,
                    type: "jobCode",
                  });
                });
                setSearchResults(temp);

                if (temp?.length === 1) {
                  const part = temp[0];
                  if (!(part.id in selectItemObj) || part.id === data.partNumber?.id) {
                    handlePartDetail(part.value, data, part.rawObj);
                    partsRef[key]?.focus();
                  }
                }
              }}
              value={
                record?.partNumber == undefined
                  ? record?.code
                    ? `${record.code}${record.description ? ` - ${record.description}` : ""}`
                    : record?.jobCode
                      ? `${record.jobCode.code}${record.jobCode.description ? ` - ${record.jobCode.description}` : ""}`
                      : "Part Number"
                  : `${record.partNumber} - ${record.partName}`
              }
              disabled={editable}
              showSearch
              filterOption={false}
              showAction={["click", "focus"]}
              placeholder="Part Number/Job Code"
            >
              {searchResults.map((part) => {
                if (part.id in selectItemObj && part.id !== data.partNumber?.id) return null;
                return (
                  <Select.Option key={part.id} value={part.value} rawObj={part.rawObj}>
                    {part.label}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        ),
      },
      serviceType === "Accidental" && {
        title: "Image",
        dataIndex: "image",
        key: "image",
        width: 130,
        render: (text, record, index) => {
          const handleImageUpload = async (info) => {
            if (!info.file) return;

            const formData = new FormData();
            formData.append("profile", info.file);
            formData.append("master", "Transaction Master");
            formData.append("module", "Job Order");

            try {
              const response = await platformApi.post(
                "/api/upload/image",
                formData
              );
              const imageUrl = response.data?.response?.data?.Location;

              if (imageUrl) {
                const newItemList = [...itemList];
                newItemList[index] = {
                  ...newItemList[index],
                  imageUrl: imageUrl,
                };
                setItemList((prev) => {
                  // build newItemList based on prev, not on a possibly stale closure
                  const updatedList = [...prev];
                  updatedList[index] = {
                    ...updatedList[index],
                    imageUrl: imageUrl,
                  };
                  return updatedList;
                });
                message.success("Image uploaded successfully");
              }
            } catch (error) {
              console.error("Image upload failed:", error);
              message.error("Failed to upload image");
            }
          };

          return (
            <Form.Item>
              {record.imageUrl ? (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <img
                    src={record.imageUrl}
                    alt="Part"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                  <Upload
                    showUploadList={false}
                    beforeUpload={() => false}
                    onChange={handleImageUpload}
                    disabled={serviceType.toLowerCase() !== "accidental" || (editData?.estimateStatus === "PENDING" && editable)}
                  >
                    <Button type="link" disabled={serviceType.toLowerCase() !== "accidental" || (editData?.estimateStatus === "PENDING" && editable)}>Change</Button>
                  </Upload>
                </div>
              ) : (
                <Upload
                  showUploadList={false}
                  beforeUpload={() => false}
                  onChange={handleImageUpload}
                  disabled={serviceType.toLowerCase() !== "accidental" || (editData?.estimateStatus === "PENDING" && editable)}
                >
                  <Button disabled={serviceType.toLowerCase() !== "accidental" || (editData?.estimateStatus === "PENDING" && editable)}>
                    Upload Image
                  </Button>
                </Upload>
              )}
            </Form.Item>
          );
        },
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 80,
        render: (data, record, index) => {
          const qtyNegative = isNegativeNumber(record?.quantity);
          return (
            <Form.Item>
              <Input
                key="quantity"
                className={qtyNegative ? "estimate-input-error" : undefined}
                disabled={editable}
                onChange={(event) => {
                  handlequantity(event, record);
                }}
                onBlur={(event) => {
                  handleQuantityBlur(event, record);
                }}
                ref={(el) => (partsRef[index] = el)}
                placeholder="quantity"
                value={record && record.quantity}
              />
            </Form.Item>
          );
        },
      },
      {
        title: "Unit rate",
        dataIndex: "unitRate",
        key: "unitRate",
        width: 100,
        render: (data, record, index) => {
          const rateNegative = isNegativeNumber(record?.unitRate);
          return (
            <Form.Item>
              <Input
                key="unitRate"
                className={rateNegative ? "estimate-input-error" : undefined}
                disabled={editable}
                onChange={(event) => {
                  handleUnitrate(event, record);
                }}
                placeholder="Unit Rate"
                value={record && record.unitRate}
              />
            </Form.Item>
          );
        },
      },
      {
        title: "Amount",
        dataIndex: "rate",
        key: "rate",
        width: 120,
        render: (data, record) => {
          const amount =
            (parseFloat(record?.quantity) || 0) *
            (parseFloat(record?.unitRate) || 0);
          const amountNegative = amount < 0;
          return (
            <Form.Item>
              <Input
                key="rate"
                className={amountNegative ? "estimate-input-error" : undefined}
                disabled={editable}
                placeholder="Amount"
                value={
                  record &&
                  record.quantity !== "" &&
                  record.quantity != null &&
                  record.unitRate !== "" &&
                  record.unitRate != null
                    ? amount
                    : record && record.quantity * record.unitRate
                }
              />
            </Form.Item>
          );
        },
      },
      {
        title: "GST%",
        dataIndex: "gstRate",
        key: "gstRate",
        width: 70,
        render: (data, record) => (
          <Form.Item>
            <span>{record && record.igst}</span>
          </Form.Item>
        ),
      },
      {
        title: "Discount",
        dataIndex: "discount",
        key: "discount",
        width: 80,
        render: (data, record) => (
          <Form.Item>
            <Input
              key="discount"
              onChange={(event) => {
                handleDiscount(event, record);
              }}
              disabled={editable}
              placeholder="Discount"
              value={record && record.discount}
            />
          </Form.Item>
        ),
      },
      {
        title: "Action",
        dataIndex: "remove",
        key: "x",
        width: 90,
        render: (data, record) => (
          <Form.Item>
            {!editable && (
              itemList.length > 1 ? (
                <Popconfirm
                  title="Sure to delete?"
                  onConfirm={() => {
                    handleDelete(record.id);
                  }}
                >
                  <a style={{ color: "#6c7b8a" }}>Delete</a>
                </Popconfirm>
              ) : (
                <a style={{ color: "#ccc", cursor: "not-allowed" }}>Delete</a>
              )
            )}
          </Form.Item>
        ),
      },
    ].filter(Boolean);


    return columns.filter((col) =>
      discountLevel === "TransactionLevel" ? col.dataIndex !== "discount" : col
    );
  };

  //Handle PartDetail
  const handlePartDetail = async (event, data, rawPartObj = null) => {
    if (data && data.partNumber && data.partNumber.id) {
      const orderedQty = editData?.orderedParts?.[data.partNumber.id] || 0;
      if (orderedQty > 0) {
        message.error(`Cannot change part ${data.partNumber.partNumber || data.partNumber.code} because it has already been ordered in Order Management.`);
        return;
      }
    }
    setSelectedPart(event);
    const newItemList = [...itemList];
    if (event !== undefined && event !== null && event !== "") {
      let partObj = rawPartObj;
      let jobCodeObj = null;

      if (partObj) {
        if (partObj.code && !partObj.partNumber) {
          jobCodeObj = partObj;
          partObj = null;
        }
      }

      if (!partObj && !jobCodeObj) {
        partObj = partsData.find((p) => p.partNumber === event);
        if (!partObj) {
          jobCodeObj = jobCode.find((j) => j.code === event);
        }
      }

      if (!partObj && !jobCodeObj) {
        const matchedSearch = searchResults.find((s) => s.value === event);
        if (matchedSearch && matchedSearch.rawObj) {
          if (matchedSearch.type === "part" || matchedSearch.rawObj.partNumber) {
            partObj = matchedSearch.rawObj;
          } else {
            jobCodeObj = matchedSearch.rawObj;
          }
        }
      }

      if (!partObj && !jobCodeObj) {
        try {
          const [partRes, jobRes] = await Promise.all([
            platformApi.post("/api/options/get/", {
              module: "partsMasters",
              column: "partNumber",
              searchString: event,
              searchColumns: ["partNumber"],
              size: 1,
              page: 1,
            }).catch(() => null),
            platformApi.post("/api/options/get/", {
              module: "jobCodes",
              column: "code",
              searchString: event,
              searchColumns: ["code"],
              size: 1,
              page: 1,
            }).catch(() => null),
          ]);
          if (partRes?.data?.response?.length > 0) {
            partObj = partRes.data.response[0];
          } else if (jobRes?.data?.response?.length > 0) {
            jobCodeObj = jobRes.data.response[0];
          }
        } catch (e) {
          console.error("Error fetching part details on select:", e);
        }
      }

      if (partObj) {
        for (let item of newItemList) {
          if (item.id === data.id) {
            item.partNumber = partObj;
            item.value = partObj;
            item.hsn = partObj.hsn || null;
            item.cgst = partObj.hsn ? partObj.hsn.cgst : 0;
            item.igst = partObj.hsn ? partObj.hsn.igst : 0;
            item.sgst = partObj.hsn ? partObj.hsn.sgst : 0;
            item.gstRate = partObj.hsn ? (Number(partObj.hsn.cgst || 0) + Number(partObj.hsn.sgst || 0)) : 0;
            item.unitRate = partObj.mrp;
            item.quantity = 1;
            setquantity(1);
            setUnitRate(partObj.mrp);
            if (item.gstRate === GST18) setGSTRate18(true);
            if (item.gstRate === GST28) setGSTRate28(true);
            if (item.gstRate === GST12) setGSTRate12(true);
            if (item.gstRate === GST5) setGSTRate5(true);
            setCGST(partObj.hsn ? partObj.hsn.cgst : 0);
            setSGST(partObj.hsn ? partObj.hsn.sgst : 0);
            setIGST(partObj.hsn ? partObj.hsn.igst : 0);
          }
        }
      } else if (jobCodeObj) {
        for (let item of newItemList) {
          if (item.id === data.id) {
            item.partNumber = jobCodeObj;
            item.hsn = jobCodeObj.sac || null;
            item.cgst = jobCodeObj.sac ? jobCodeObj.sac.cgst : 0;
            item.igst = jobCodeObj.sac ? jobCodeObj.sac.igst : 0;
            item.sgst = jobCodeObj.sac ? jobCodeObj.sac.sgst : 0;
            item.gstRate = jobCodeObj.sac ? (Number(jobCodeObj.sac.cgst || 0) + Number(jobCodeObj.sac.sgst || 0)) : 0;
            let price = (jobCodeObj.vehicleModel || []).filter(
              (vItem) => vItem.vehicle && vItem.vehicle.id === model
            );
            item.unitRate = price.length ? price[0].price : 0;
            item.quantity = 1;
            setquantity(1);
            setUnitRate(price.length ? price[0].price : 0);
            if (item.gstRate === GST18) setGSTRate18(true);
            if (item.gstRate === GST28) setGSTRate28(true);
            if (item.gstRate === GST12) setGSTRate12(true);
            if (item.gstRate === GST5) setGSTRate5(true);
            setCGST(jobCodeObj.sac ? jobCodeObj.sac.cgst : 0);
            setSGST(jobCodeObj.sac ? jobCodeObj.sac.sgst : 0);
            setIGST(jobCodeObj.sac ? jobCodeObj.sac.igst : 0);
          }
        }
      }
    }
    setItemList(newItemList);
    getParts();
    getJobCodes();
  };

  //Calculation
  useEffect(() => {
    if (discountLevel === "TransactionLevel") {
      calculateTransactionTax();
    } else if (discountLevel === "ItemLevel") {
      calculateItemTax();
    }
  }, [
    unitRate,
    quantity,
    rate,
    discountAmount,
    discount,
    grandTtl,
    discountLevel,
    discountType,
    deleteItem,
  ]);

  //TranscationMax
  const calculateTransactionTax = (customList) => {
    let newItemList = customList ? [...customList] : [...itemList];
    let subTotal = 0;   // sum of all item rates (before discount)
    let TotalCgst = 0;
    let TotalSgst = 0;
    let TotalIgst = 0;
    let pCharge = 0;   // parts charge
    let labourCharge = 0;   // job-code labour
    let consumableCharge = 0;// job-code consumable
    let temp = "0.00";
    const isInterState =
      Boolean(stateName) &&
      Boolean(gst) &&
      String(stateName).slice(0, 2) !== String(gst).slice(0, 2);

    // ── Step 1: per-item GST amounts (on undiscounted rate) ──────────────
    for (let i = 0; i < newItemList.length; i++) {
      const item = newItemList[i];
      const rate = parseFloat(item.rate) || 0;
      const cgstPct = parseFloat(item.cgst) || 0;
      const sgstPct = parseFloat(item.sgst) || 0;
      const igstPct = parseFloat(item.igst) || 0;
      const gstRate = parseFloat(item.gstRate) || parseFloat(item.igst) || (parseFloat(item.cgst) + parseFloat(item.sgst)) || 0;

      if (rate <= 0) {
        // Empty / blank row — zero out amounts
        item.cgstAmount = "0.00";
        item.sgstAmount = "0.00";
        item.igstAmount = "0.00";
        item.grandTotal = 0;
        continue;
      }

      subTotal += rate;

      // Accumulate charge categories (null-safe partNumber checks)
      const isJobCode = Boolean(item.partNumber?.code || item.jobCode);
      const isPart = Boolean(item.partNumber?.partNumber);
      const isConsumable = Boolean(item.partNumber?.consumable || item.jobCode?.consumable);

      if (isJobCode) {
        if (isConsumable) {
          consumableCharge += rate;
        } else {
          labourCharge += rate;
        }
      } else if (isPart) {
        pCharge += rate;
      }
    }

    // ── Step 2: apply Transaction-Level discount ──────────────────────────
    const discAmt = parseFloat(discountAmount) || 0;
    let totalDisc = 0;

    if (discAmt > 0) {
      if (discountType === "percent") {
        totalDisc = parseFloat((subTotal * discAmt / 100).toFixed(2));
      } else {
        totalDisc = discAmt;
      }
    }

    const discountedTotal = Math.max(0, subTotal - totalDisc);
    const discountRatio = subTotal > 0 ? discountedTotal / subTotal : 1;

    let accumCgst = 0;
    let accumSgst = 0;
    let accumIgst = 0;
    let totalGrandPayable = 0;

    for (let i = 0; i < newItemList.length; i++) {
      const item = newItemList[i];
      const rate = parseFloat(item.rate) || 0;
      if (rate <= 0) continue;

      const cgstPct = parseFloat(item.cgst) || 0;
      const sgstPct = parseFloat(item.sgst) || 0;
      const igstPct = parseFloat(item.igst) || 0;

      const discountedRate = rate * discountRatio;
      const gstRate = parseFloat(item.gstRate) || parseFloat(item.igst) || (parseFloat(item.cgst) + parseFloat(item.sgst)) || 0;

      let cgstAmount = 0;
      let sgstAmount = 0;
      let igstAmount = 0;
      let linePayable = 0;

      const isJobCode = Boolean(item.partNumber?.code || item.jobCode);
      const isConsumable = Boolean(item.partNumber?.consumable || item.jobCode?.consumable);
      const isLabourAlone = isJobCode && !isConsumable;
      const isExclusiveTax = isLabourAlone || isConsumable;

      if (isExclusiveTax) {
        // Labour & Consumable Parts: GST-Exclusive (GST added on top of discounted rate)
        // NOTE: HSN/SAC stores cgst+sgst+igst simultaneously. Only add netTaxAmount ONCE
        // to avoid double-counting (cgst+sgst already equals full tax for intra-state).
        let netTaxAmount = 0;
        if (gstRate > 0) {
          netTaxAmount = (discountedRate * gstRate) / 100;
          cgstAmount = netTaxAmount * (cgstPct / gstRate);
          sgstAmount = netTaxAmount * (sgstPct / gstRate);
          igstAmount = netTaxAmount * (igstPct / gstRate);
        }
        linePayable = discountedRate + netTaxAmount;
      } else {
        // Inventory Spare Parts: GST-Inclusive (GST extracted from rate)
        if (gstRate > 0) {
          const taxableValue = (discountedRate * 100) / (100 + gstRate);
          const totalGstAmount = discountedRate - taxableValue;
          cgstAmount = totalGstAmount * (cgstPct / gstRate);
          sgstAmount = totalGstAmount * (sgstPct / gstRate);
          igstAmount = totalGstAmount * (igstPct / gstRate);
        }
        linePayable = discountedRate;
      }

      // Inter-state: keep IGST only (derive from CGST+SGST when HSN has no IGST %)
      if (isInterState) {
        if (igstAmount <= 0) igstAmount = cgstAmount + sgstAmount;
        cgstAmount = 0;
        sgstAmount = 0;
      } else {
        igstAmount = 0;
      }

      item.cgstAmount = cgstAmount.toFixed(2);
      item.sgstAmount = sgstAmount.toFixed(2);
      item.igstAmount = igstAmount.toFixed(2);
      item.grandTotal = linePayable;

      accumCgst += cgstAmount;
      accumSgst += sgstAmount;
      accumIgst += igstAmount;
      totalGrandPayable += linePayable;
    }

    // ── Step 3: totals ────────────────────────────────────────────────────
    TotalCgst = accumCgst;
    TotalSgst = accumSgst;
    TotalIgst = accumIgst;

    const estTotal = Math.round(totalGrandPayable);
    const roundoffVal = estTotal - totalGrandPayable;
    if (Math.abs(roundoffVal) < 0.001) {
      temp = "0.00";
    } else if (roundoffVal > 0) {
      temp = `+${roundoffVal.toFixed(2)}`;
    } else {
      temp = `${roundoffVal.toFixed(2)}`;
    }

    setGrandTotal(totalGrandPayable.toFixed(2));

    form.setFieldsValue({
      totalAmount: estTotal,
      cgst: TotalCgst.toFixed(2),
      sgst: TotalSgst.toFixed(2),
      igst: TotalIgst.toFixed(2),
      partCharge: parseFloat(pCharge.toFixed(2)),
      labourCharge: parseFloat(labourCharge.toFixed(2)),
      consumableCharge: parseFloat(consumableCharge.toFixed(2)),
      totalDiscount: parseFloat(totalDisc.toFixed(2)),
      roundoff: temp,
    });

    setItemList(newItemList);
  };




  //ItemMax
  const calculateItemTax = (customList) => {
    let newItemList = customList ? [...customList] : [...itemList];
    let pCharge = 0;
    let labourCharge = 0;
    let consumableCharge = 0;
    let TotalCgst = 0;
    let TotalSgst = 0;
    let TotalIgst = 0;
    let totalGrandPayable = 0;
    const isInterState =
      Boolean(stateName) &&
      Boolean(gst) &&
      String(stateName).slice(0, 2) !== String(gst).slice(0, 2);

    for (let i = 0; i < newItemList.length; i++) {
      const item = newItemList[i];
      const rate = parseFloat(item.rate) || 0;
      if (rate <= 0) {
        item.cgstAmount = "0.00";
        item.sgstAmount = "0.00";
        item.igstAmount = "0.00";
        item.grandTotal = 0;
        continue;
      }

      const cgstPct = parseFloat(item.cgst) || 0;
      const sgstPct = parseFloat(item.sgst) || 0;
      const igstPct = parseFloat(item.igst) || 0;
      const gstRate = parseFloat(item.gstRate) || parseFloat(item.igst) || (cgstPct + sgstPct) || 0;

      const isJobCode = Boolean(item.partNumber?.code || item.jobCode);
      const isPart = Boolean(item.partNumber?.partNumber);
      const isConsumable = Boolean(item.partNumber?.consumable || item.jobCode?.consumable);
      const isLabourAlone = isJobCode && !isConsumable;
      const isExclusiveTax = isLabourAlone || isConsumable;

      // Accumulate undiscounted base charge categories
      if (isJobCode) {
        if (isConsumable) {
          consumableCharge += rate;
        } else {
          labourCharge += rate;
        }
      } else if (isPart) {
        pCharge += rate;
      }

      // Calculate item-level discount
      let netRate = rate;
      const itemDisc = parseFloat(item.discount) || 0;
      if (itemDisc > 0) {
        if (discountType === "percent") {
          netRate = rate - (rate * itemDisc / 100);
        } else {
          netRate = rate - itemDisc;
        }
      }
      netRate = Math.max(0, netRate);

      let cgstAmount = 0;
      let sgstAmount = 0;
      let igstAmount = 0;
      let linePayable = 0;

      if (isExclusiveTax) {
        // Labour & Consumable Parts: GST-Exclusive
        // NOTE: HSN/SAC stores cgst+sgst+igst simultaneously. Only add netTaxAmount ONCE.
        let netTaxAmount = 0;
        if (gstRate > 0) {
          netTaxAmount = (netRate * gstRate) / 100;
          cgstAmount = netTaxAmount * (cgstPct / gstRate);
          sgstAmount = netTaxAmount * (sgstPct / gstRate);
          igstAmount = netTaxAmount * (igstPct / gstRate);
        }
        linePayable = netRate + netTaxAmount;
      } else {
        // Inventory Spare Parts: GST-Inclusive
        if (gstRate > 0) {
          const taxableValue = (netRate * 100) / (100 + gstRate);
          const totalGstAmount = netRate - taxableValue;
          cgstAmount = totalGstAmount * (cgstPct / gstRate);
          sgstAmount = totalGstAmount * (sgstPct / gstRate);
          igstAmount = totalGstAmount * (igstPct / gstRate);
        }
        linePayable = netRate;
      }

      if (isInterState) {
        if (igstAmount <= 0) igstAmount = cgstAmount + sgstAmount;
        cgstAmount = 0;
        sgstAmount = 0;
      } else {
        igstAmount = 0;
      }

      item.cgstAmount = cgstAmount.toFixed(2);
      item.sgstAmount = sgstAmount.toFixed(2);
      item.igstAmount = igstAmount.toFixed(2);
      item.grandTotal = linePayable;

      TotalCgst += cgstAmount;
      TotalSgst += sgstAmount;
      TotalIgst += igstAmount;
      totalGrandPayable += linePayable;
    }

    const estTotal = Math.round(totalGrandPayable);
    const roundoffVal = estTotal - totalGrandPayable;
    let temp = "0.00";
    if (Math.abs(roundoffVal) >= 0.001) {
      temp = roundoffVal > 0 ? `+${roundoffVal.toFixed(2)}` : `${roundoffVal.toFixed(2)}`;
    }

    setGrandTotal(totalGrandPayable.toFixed(2));
    form.setFieldsValue({
      totalAmount: estTotal,
      cgst: TotalCgst.toFixed(2),
      sgst: TotalSgst.toFixed(2),
      igst: TotalIgst.toFixed(2),
      partCharge: parseFloat(pCharge.toFixed(2)),
      labourCharge: parseFloat(labourCharge.toFixed(2)),
      consumableCharge: parseFloat(consumableCharge.toFixed(2)),
      roundoff: temp,
    });
    setItemList(newItemList);
  };
  //Handle Add
  const handleAdd = () => {
    let newArr = [...itemList, partItemData];
    setItemList(newArr);
  };
  // Allow optional leading "-" plus digits/one decimal (Qty / Unit Rate)
  const sanitizeSignedDecimal = (raw) => {
    let value = String(raw ?? "");
    const isNegative = value.trim().startsWith("-");
    value = value.replace(/[^0-9.]/g, "");
    const decimalCount = (value.match(/\./g) || []).length;
    if (decimalCount > 1) {
      value = value.slice(0, value.lastIndexOf("."));
    }
    if (isNegative && value !== "") {
      value = `-${value}`;
    } else if (isNegative && value === "") {
      value = "-";
    }
    return value;
  };

  const isNegativeNumber = (raw) => {
    if (raw === "" || raw === null || raw === undefined || raw === "-") {
      return false;
    }
    const n = parseFloat(raw);
    return !Number.isNaN(n) && n < 0;
  };

  //Handle UnitRate
  const handleUnitrate = (event, record) => {
    const value = sanitizeSignedDecimal(event.target.value);

    setUnitRate(value);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.unitRate = value;
        item.rate = (parseFloat(item.quantity) || 0) * (parseFloat(value) || 0);
        break;
      }
    }
    setItemList(newItemList);
  };
  //Handle Discount
  const handleDiscount = (event, record) => {
    const value = event.target.value.replace(/[^0-9.]/g, "");
    setDiscount(value);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.discount = value;
        break;
      }
    }
  };
  //Handle Quantity Blur
  const handleQuantityBlur = (event, record) => {
    // No action on blur so user input is preserved until save is clicked
  };

  //Handle Quantity
  const handlequantity = (event, record) => {
    const value = sanitizeSignedDecimal(event.target.value);

    setquantity(value);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.quantity = value;
        item.rate = (parseFloat(value) || 0) * (parseFloat(item.unitRate) || 0);
        break;
      }
    }
    setItemList(newItemList);
  };
  //Handle Cancel
  const handleCancel = () => {
    form.resetFields();
    setGrandTotal(0);
    setDiscountAmount(0);
    setSelectedPart("");
    setItemList([partItemData]);
    setRecPart("");
    setJobNo([]);
    setPartsData([]);
    setJobCode([]);
    setDeleteData1([]);
    setDeleteData2([]);
    setStateName("");
    setJobCustomerTax({ GSTNo: "", GSTType: "" });
    setSelectedInsurerTax({ GSTIN: "", dealerType: "" });
    // setJobid('');
    setGst("");
    history.push("/autoadmin/estimate");
  };
  //Handle Submit
  const handleSubmit = () => {
    form.validateFields((validationError) => {
      // Block save if Qty / Unit Rate / Amount is negative on any real line
      for (const item of itemList) {
        if (!item?.partNumber) continue;
        const hasPart = Boolean(
          item.partNumber.partNumber || item.partNumber.code || item.imageUrl
        );
        if (!hasPart) continue;
        const qty = parseFloat(item.quantity);
        const unit = parseFloat(item.unitRate);
        const amount = (Number.isNaN(qty) ? 0 : qty) * (Number.isNaN(unit) ? 0 : unit);
        if (
          (!Number.isNaN(qty) && qty < 0) ||
          (!Number.isNaN(unit) && unit < 0) ||
          amount < 0
        ) {
          message.error(
            "Quantity, Unit Rate, and Amount cannot be negative. Fix highlighted fields before saving."
          );
          return;
        }
      }

      let totalSGSTAmt = 0;
      let totalCGSTAmt = 0;
      let totalIGSTAmt = 0;
      let newItemList = [...itemList];
      const customerStateCode = stateName ? String(stateName).slice(0, 2) : "";
      const branchStateCode = gst ? String(gst).slice(0, 2) : "";
      const isInterState =
        Boolean(customerStateCode) &&
        Boolean(branchStateCode) &&
        customerStateCode !== branchStateCode;

      for (let i = 0; i < newItemList.length; i++) {
        const sgstAmtVal = parseFloat(newItemList[i].sgstAmount) || 0;
        const cgstAmtVal = parseFloat(newItemList[i].cgstAmount) || 0;
        let igstAmtVal = parseFloat(newItemList[i].igstAmount) || 0;

        // HSN/SAC often only has CGST+SGST %; derive IGST amount for inter-state
        if (isInterState && igstAmtVal <= 0 && cgstAmtVal + sgstAmtVal > 0) {
          igstAmtVal = cgstAmtVal + sgstAmtVal;
          newItemList[i].igstAmount = igstAmtVal.toFixed(2);
        }
        if (isInterState) {
          newItemList[i].cgstAmount = null;
          newItemList[i].sgstAmount = null;
        } else {
          newItemList[i].igstAmount = null;
        }

        if (sgstAmtVal > 0) totalSGSTAmt += sgstAmtVal;
        if (cgstAmtVal > 0) totalCGSTAmt += cgstAmtVal;
        if (igstAmtVal > 0) totalIGSTAmt += igstAmtVal;

        newItemList[i].discountPercent =
          discountType === "percent" ? newItemList[i].discount : 0;
        newItemList[i].discountRate =
          discountType === "rupee" ? newItemList[i].discount : 0;
      }
      if (newItemList.length > 1) {
        newItemList = newItemList.filter((item) => {
          // Must have a partNumber object and a rate to be considered valid
          if (!item.partNumber || !item.rate) return false;

          const isJobCode = Boolean(item.partNumber.code);
          const isPart = Boolean(item.partNumber.partNumber);

          if (isJobCode) {
            // Job codes: only need code + unitRate (SAC/GST may be 0 or missing)
            return true;
          }
          if (isPart) {
            // Parts: need partNumber + rate (hsn/GST may be 0 for some items)
            return true;
          }
          // Allow image-only rows (accidental service)
          return Boolean(item.imageUrl);
        });
      }

      const filteredList = newItemList.filter((item) => {
        if (!item || !item.partNumber || !item.rate) return false;
        const isJobCode = Boolean(item.partNumber.code);
        const isPart = Boolean(item.partNumber.partNumber);
        return isJobCode || isPart || Boolean(item.imageUrl);
      });

      if (filteredList.length === 0) {
        message.error("Please add at least one part or labor item before submitting.");
        return;
      }

      const totalAmt = parseFloat(getFieldValue("totalAmount") || grandTtl || 0);
      if (isNaN(totalAmt) || totalAmt <= 0) {
        message.error("Total amount must be greater than zero.");
        return;
      }

      newItemList = filteredList;
      setItemList(newItemList);

      // Get survivor data from the selected survivor
      const selectedSurvivor = getFieldValue("survivor");
      const survivorData =
        survivorList.find((s) => s.id === selectedSurvivor) || {};

      const insurerData =
        insurerList.find((i) => i.name === getFieldValue("insurer")) || {};

      const data = {
        estimateNo: estimateNo,
        jobOrder: getFieldValue("JobNo"),
        discountLevel,
        discountType,
        currentDate: moment(Date.now()),
        discountPercent: discountType === "percent" ? discountAmount : 0,
        discountRate: discountType === "rupee" ? discountAmount : 0,
        cgstAmount: isInterState ? null : totalCGSTAmt,
        sgstAmount: isInterState ? null : totalSGSTAmt,
        igstAmount: isInterState
          ? totalIGSTAmt || totalCGSTAmt + totalSGSTAmt
          : null,
        labourCharge: getFieldValue("labourCharge")
          ? getFieldValue("labourCharge")
          : 0,
        consumableCharge: getFieldValue("consumableCharge")
          ? getFieldValue("consumableCharge")
          : 0,
        partCharge: getFieldValue("partCharge")
          ? getFieldValue("partCharge")
          : 0,
        estTotalAmount: getFieldValue("totalAmount")
          ? getFieldValue("totalAmount")
          : grandTtl,
        totalDiscount,
        estimateItemInvoice: newItemList,
        branch: pBranch || branch,
        deleteData1: deleteData1,
        deleteData2: deleteData2,
        // Add accidental type and related fields
        serviceType: serviceType,
        claimStatus: claimStatus,
        claimType: claimType,
        claimNumber: claimNumber,
        insurer: insurerData?.id || null,
        survivorName: survivorData?.name || null,
        survivor: selectedSurvivor || survivorData?.id || null,
        survivorContact: survivorData?.contacts?.[0]?.phone || survivorData?.CustomerPhone?.[0]?.mobileNo || survivorData?.CustomerPhone?.[0]?.phone || survivorData?.mobileNo || survivorData?.phone || null,
      };

      if (validationError === null) {
        // Pre-submit validation for ordered/received parts quantity
        if (modifyType && editData?.orderedParts) {
          for (let item of newItemList) {
            if (item.partNumber && item.partNumber.id) {
              const partId = item.partNumber.id;
              const orderedQty = editData.orderedParts[partId] || 0;
              const currentQty = parseFloat(item.quantity) || 0;
              if (orderedQty > 0 && currentQty < orderedQty) {
                const partNoStr = item.partNumber.partNumber || item.partNumber.code || "Part";
                message.error(`Cannot reduce quantity of part ${partNoStr} below the already ordered quantity of ${orderedQty}.`);
                setBtnFlag(false);
                return;
              }
            }
          }
        }

        setBtnFlag(true);
        if (!modifyType) {
          platformApi
            .post("/api/estimate/", data)
            .then((result) => {
              let { data } = result;
              if (data.code === 200) {
                let { response } = data;
                if (response.code === 200) {
                  message.success('Estimate Added Successfully');
                  history.push('/autoadmin/estimate');
                } else {
                  message.error(response.message || "Couldn't Add Estimate");
                  setBtnFlag(false);
                }
              } else {
                message.error(data.msg || "Couldn't Add Estimate");
                setBtnFlag(false);
              }
            })
            .catch((err) => {
              console.log(err);
              message.error("Couldn't Add Estimate");
              setBtnFlag(false);
            });
        } else {
          platformApi
            .put(`/api/estimate/${id}`, data)
            .then((result) => {
              let { data } = result;
              if (data.code === 200) {
                let { response } = data;
                if (response.code === 200) {
                  message.success('Estimate Modified Successfully');
                  history.push('/autoadmin/estimate');
                } else {
                  // Revert any invalid quantities if server returns error response
                  if (editData?.orderedParts) {
                    const updatedList = [...itemList];
                    let stateChanged = false;
                    for (let item of updatedList) {
                      if (item.partNumber && item.partNumber.id) {
                        const orderedQty = editData.orderedParts[item.partNumber.id] || 0;
                        if (orderedQty > 0 && (parseFloat(item.quantity) || 0) < orderedQty) {
                          item.quantity = orderedQty;
                          item.rate = orderedQty * (parseFloat(item.unitRate) || 0);
                          stateChanged = true;
                        }
                      }
                    }
                    if (stateChanged) {
                      setItemList(updatedList);
                    }
                  }
                  message.error(response.message || "Estimate Modification Failed");
                  setBtnFlag(false);
                }
              } else {
                message.error("Estimate Modification Failed");
                setBtnFlag(false);
              }
            })
            .catch((err) => {
              console.error("Estimate Add Error: ", err);
              message.error("Couldn't update Estimate");
              setBtnFlag(false);
            });
        }
      } else {
        message.error("select atleast one item list");
      }
    });
  };

  //Handle Delete
  const handleDelete = (selectedId) => {
    const itemToDelete = itemList.find((item) => item.id === selectedId);
    if (itemToDelete && itemToDelete.partNumber && itemToDelete.partNumber.id) {
      const partId = itemToDelete.partNumber.id;
      const partNoStr = itemToDelete.partNumber.partNumber || itemToDelete.partNumber.code;
      const orderedQty = editData?.orderedParts?.[partId] || 0;
      if (orderedQty > 0) {
        message.error(`Cannot delete part ${partNoStr} because it has already been ordered in Order Management.`);
        return;
      }
    }
    const updatedDataSource = itemList.filter((item) => item.id !== selectedId);
    deleteParts(selectedId);
    if (discountLevel === "TransactionLevel") {
      calculateTransactionTax(updatedDataSource);
    } else if (discountLevel === "ItemLevel") {
      calculateItemTax(updatedDataSource);
    } else {
      setItemList(updatedDataSource);
    }
  };

  const deleteParts = (e) => {
    if (pid.indexOf(e) >= 0) {
      deleteData1.push(e);
    } else if (jid.indexOf(e) >= 0) {
      deleteData2.push(e);
    }
    setDeleteData1(deleteData1);
    setDeleteData2(deleteData2);
  };
  //Searches
  const searchJobNo = (search) => {
    platformApi
      .post("/api/options/get/", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        fields: search.fields,
        size: 100,
        page: 1,
        except: null,
      })
      .then((res) => {
        search.setValue(res.data.response);
      });
  };

  const searchParts = async (search) => {
    // const res = await platformApi
    //     .post("/api/options/get/", {
    //         module: search.module,
    //         column: search.column,
    //         searchString: search.searchString,
    //         fields: search.fields,
    //         size: 100,
    //         page: 1,
    //         except: null,
    //         branch: pBranch
    //     })
    // let parts = [];
    // // console.log("Response", res.data)
    // for (let i = 0; i < res.data.response?.length; i++) {
    //     const element = res.data.response[i];
    //     parts.push(element.partNo)
    // }
    // search.setValue(parts)
    // return 1
    // .then((res) => {
    //     let parts = [];
    //     for (let i = 0; i < res.data.response.length; i++) {
    //         const element = res.data.response[i];
    //         parts.push(element.partNo)
    //     }
    //     setPartsData(parts)
    //     return parts;
    // });

    const res = await platformApi.post("/api/options/get/", {
      module: search.module,
      column: search.column,
      searchString: search.searchString,
      fields: search.fields,
      size: 100,
      page: 1,
      except: null,
    });
    search.setValue(res.data.response);
    return 1;
  };

  const searchJobCode = (search) => {
    platformApi
      .post("/api/options/get/", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        fields: search.fields,
        size: 100,
        page: 1,
        except: null,
      })
      .then((res) => {
        search.setValue(() => {
          return res.data.response;
        });
      });
  };

  const getJobNo = () => {
    platformApi
      .post("/api/jobOrder/getJobNo", {
        size: 100,
        page: 1,
      })
      .then((res) => {
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            setJobNo(response.data);
          } else {
            message.error("Failed to fetch Job Order");
          }
        } else {
          message.error("Failed to fetch Job Order");
        }
      })
      .catch((error) => {
        console.error("Error on Job Order : ", error);
        message.error("Failed to fetch Job Order");
      });
  };

  // Add a useEffect to reset the field value if survivorList changes and only one result is present
  useEffect(() => {
    if (survivorList.length === 1) {
      setFieldsValue({ survivor: survivorList[0].id });
    }
  }, [survivorList]);

  useEffect(() => {
    if (lastSearchRef.current && survivorList.length > 0) {
      const match = survivorList.find((survivor) => {
        const phone = survivor.contacts?.[0]?.phone || survivor.CustomerPhone?.[0]?.mobileNo || survivor.CustomerPhone?.[0]?.phone || survivor.mobileNo || survivor.phone;
        return phone && phone.includes(lastSearchRef.current);
      });
      if (match) {
        setFieldsValue({ survivor: match.id });
      }
    }
  }, [survivorList]);

  // UI display only: IGST vs CGST+SGST (same rule as GSTTable / BE tax party)
  const partyStateCode = stateName ? String(stateName).slice(0, 2) : "";
  const branchStateCode = gst ? String(gst).slice(0, 2) : "";
  const isInterStateTaxDisplay =
    Boolean(partyStateCode) &&
    Boolean(branchStateCode) &&
    partyStateCode !== branchStateCode;

  return (
    <div>
      <Form className="purchase-form">
        <Row>
          <Col span={12}>
            <Text strong>
              Estimate No&nbsp;&nbsp;&nbsp;:
              {!editData ? estimateNo : editData.estimateNo}
            </Text>
            <Form.Item
              className="purchase-form-element"
              label={<Text strong> Estimate Status&nbsp;&nbsp;&nbsp;</Text>}
            >
              <div style={{ marginLeft: "20px" }}>
                <Text strong>
                  {editData && editData.estimateStatus
                    ? editData.estimateStatus
                    : "-"}
                </Text>
              </div>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Date & Time"
              name="currentDate"
            >
              <DatePicker
                disabled={true}
                placeholder={moment(Date.now()).format("LL")}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              colon={false}
              className="purchase-form-element"
              label={<Text>Ass.Job No</Text>}
            >
              {getFieldDecorator("JobNo", {
                rules: [
                  {
                    required: true,
                    message: "Select Job No",
                  },
                ],
              })(
                <Select
                  showAction={["click", "focus"]}
                  showSearch
                  filterOption={null}
                  disabled={editable}
                  placeholder="Job No"
                  onSearch={(e) => {
                    const search = {
                      module: "jobOrders",
                      column: "jobNo",
                      searchString: e,
                      searchColumns: ["jobNo"],
                      setValue: setJobNo,
                    };
                    searchJobNo(search);
                  }}
                  onSelect={getJobOrder}
                >
                  {jobNo.length > 0 &&
                    jobNo
                      .filter((item) => {
                        if (editData && editData.jobOrder && editData.jobOrder.id === item.id) {
                          return true;
                        }
                        const st = (item.jobStatus || "").toUpperCase();
                        return !st.includes("COMPLETED") && !st.includes("PAID") && !st.includes("DELETED");
                      })
                      .map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.jobNo}
                        </Select.Option>
                      ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              colon={false}
              className="purchase-form-element"
              label={<Text>Branch</Text>}
            >
              {getFieldDecorator("branch", {
                rules: [
                  {
                    required: false,
                    message: "Select Job No",
                  },
                ],
              })(<Input disabled={true} placeholder={"Branch"} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {vehicleDetail && (
            <Col span={24}>
              <Title level={4}>Vehicle Details</Title>
              <Row gutter={16}>
                {" "}
                {/* Main row for details and image */}
                <Col span={18}>
                  {" "}
                  {/* Column for all textual details */}
                  <Row gutter={16}>
                    {" "}
                    {/* First row of 3 details — Model Name +10% width */}
                    <Col span={9}>
                      <Form.Item label="Model Name">
                        <Input
                          value={vehicleDetail.vehicle?.modelName}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={7}>
                      <Form.Item label="Model Code">
                        <Input
                          value={vehicleDetail.vehicle?.modelCode}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Customer Name">
                        <Input
                          value={vehicleDetail.customer?.[0]?.customer?.name}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    {" "}
                    {/* Second row of 3 details */}
                    <Col span={8}>
                      <Form.Item label="Chassis No">
                        <Input value={vehicleDetail.chassisNo} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Register No">
                        <Input value={vehicleDetail.registerNo} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Engine No">
                        <Input value={vehicleDetail.engineNo} disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {" "}
                  {/* Column for the image, effectively spanning rows */}
                  {vehicleDetail.color?.url && (
                    <div style={{ textAlign: "center" }}>
                      <img
                        src={vehicleDetail.color.url}
                        alt={vehicleDetail.color.color}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "145px",
                          objectFit: "contain",
                        }} /* Adjusted maxHeight */
                      />
                      <p style={{ marginTop: "8px" }}>
                        Color: {vehicleDetail.color.color}
                      </p>
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          )}
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              className="form-element-type"
              label={<Text strong>Service type?</Text>}
            >
              {getFieldDecorator("serviceType", {
                rules: [
                  {
                    required: false,
                    message: "Select Service Type",
                  },
                ],
              })(
                <Group
                  onChange={(e) => {
                    setFieldsValue({
                      serviceType: e.target.value,
                    });
                    setServiceType(e.target.value);
                  }}
                  disabled={editable || !!location?.state?.jobNo}
                >
                  <Radio value={"Accidental"}><span style={{ color: (editable || !!location?.state?.jobNo) ? "rgba(0, 0, 0, 0.65)" : "inherit" }}>Accidental</span></Radio>
                  <Radio value={"Non Accidental"}><span style={{ color: (editable || !!location?.state?.jobNo) ? "rgba(0, 0, 0, 0.65)" : "inherit" }}>Non Accidental</span></Radio>
                </Group>
              )}
            </Form.Item>
          </Col>

          {serviceType === "Accidental" && (
            <>
              <Col span={12}>
                <Form.Item
                  className="form-element-type"
                  label={<Text strong>Insurance to be Claimed</Text>}
                >
                  {getFieldDecorator("claimStatus", {
                    rules: [
                      {
                        required: true,
                        message: "Select Insurance to be Claimed",
                      },
                    ],
                    initialValue: editData?.claimStatus,
                  })(
                    <Group
                      onChange={(e) => {
                        const nextClaim = e.target.value;
                        setFieldsValue({
                          claimStatus: nextClaim,
                        });
                        setClaimStatus(nextClaim);
                        if (!nextClaim) {
                          setSelectedInsurerTax({ GSTIN: "", dealerType: "" });
                        }
                      }}
                      disabled={editable || !!location?.state?.jobNo}
                    >
                      <Radio value={true}><span style={{ color: (editable || !!location?.state?.jobNo) ? "rgba(0, 0, 0, 0.65)" : "inherit" }}>Yes</span></Radio>
                      <Radio value={false}><span style={{ color: (editable || !!location?.state?.jobNo) ? "rgba(0, 0, 0, 0.65)" : "inherit" }}>No</span></Radio>
                    </Group>
                  )}
                </Form.Item>
              </Col>
            </>
          )}

          {claimStatus && (
            <>
              <Col span={12}>
                <Form.Item
                  className="form-element-type"
                  label={<Text strong>Claim type</Text>}
                >
                  {getFieldDecorator("claimType", {
                    rules: [
                      {
                        required: true,
                        message: "Select claim type",
                      },
                    ],
                    initialValue: editData?.claimType || undefined,
                  })(
                    <Group
                      onChange={(e) => {
                        setFieldsValue({
                          claimType: e.target.value,
                          insurer: undefined,
                        });
                        setClaimType(e.target.value);
                      }}
                      disabled={true}
                    >
                      <Radio value="Cashless"><span style={{ color: "rgba(0, 0, 0, 0.65)" }}>Cashless</span></Radio>
                      <Radio value="Non Cashless"><span style={{ color: "rgba(0, 0, 0, 0.65)" }}>Non Cashless</span></Radio>
                    </Group>
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="form-element-type"
                  label={<Text strong>Claim Number</Text>}
                >
                  {getFieldDecorator("claimNumber", {
                    rules: [
                      {
                        required: false,
                        message: "Enter claim number",
                      },
                    ],
                    initialValue: editData?.claimNumber || undefined,
                  })(
                    <Input
                      placeholder="Claim Number"
                      disabled={true}
                      style={{ color: "rgba(0, 0, 0, 0.65)" }}
                      onChange={(e) => {
                        setFieldsValue({
                          claimNumber: e.target.value,
                          survivor: undefined,
                        });
                        setClaimNumber(e.target.value);
                      }}
                    />
                  )}
                </Form.Item>
              </Col>
            </>
          )}
        </Row>

        {claimStatus && (
          <Row gutter={16}>
            {(getFieldValue("claimType") || claimType) && (
              <Col span={12}>
                <Form.Item
                  colon={false}
                  className="purchase-form-element"
                  label={<Text>Insurer name</Text>}
                >
                  {getFieldDecorator("insurer", {
                    rules: [
                      {
                        required: true,
                        message: "Select insurer name",
                      },
                    ],
                    initialValue: editData?.insurer?.name || undefined,
                  })(
                    <Select
                      placeholder="Select insurer"
                      disabled={true}
                      style={{ color: "rgba(0, 0, 0, 0.65)" }}
                      showSearch
                      filterOption={(input, option) =>
                        option?.props?.children
                          ?.toString()
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onChange={(value) => {
                        setFieldsValue({
                          insurer: value,
                        });
                      }}
                    >
                      {insurerList
                        ?.filter((insurer) => {
                          if (!insurer || !insurer.name || insurer.name.trim() === "") return false;
                          if (String(insurer.status || "").toUpperCase() !== "ACTIVE") return false;
                          const cashlessVal = String(insurer.cashless || "").toLowerCase();
                          const selectedClaimType = (getFieldValue("claimType") || claimType)?.toLowerCase();
                          if (selectedClaimType === "cashless") {
                            return cashlessVal === "yes" || cashlessVal === "true";
                          } else {
                            return cashlessVal === "no" || cashlessVal === "false";
                          }
                        })
                        ?.map((insurer) => (
                          <Select.Option key={insurer.id} value={insurer.name}>
                            {insurer.name}
                          </Select.Option>
                        ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            )}

            <Col span={12}>
              <Form.Item
                colon={false}
                className="purchase-form-element"
                label={<Text>Surveyor</Text>}
              >
                {getFieldDecorator("survivor", {
                  rules: [
                    {
                      required: false,
                      message: "Select Surveyor",
                    },
                  ],
                  initialValue: editData?.survivor
                    ? editData.survivor.id
                    : undefined,
                })(
                  <Select
                    showAction={["click", "focus"]}
                    showSearch
                    filterOption={false}
                    disabled={true}
                    style={{ color: "rgba(0, 0, 0, 0.65)" }}
                    placeholder="Surveyor"
                    value={getFieldValue("survivor")}
                    onSearch={handleSurveyorSearch}
                    onChange={(value) => {
                      setFieldsValue({
                        survivor: value,
                      });
                    }}
                    notFoundContent={
                      <Button
                        type="primary"
                        style={{
                          justifyContent: "center",
                          width: "100%",
                        }}
                        onClick={() => {
                          setContact(lastSearchRef.current); // Restore last search value
                          setModalOpen(true);
                        }}
                      >
                        Add Surveyor
                      </Button>
                    }
                  >
                    {survivorList.length > 0
                      ? survivorList
                        .filter((survivor) => {
                          if (!survivor) return false;
                          if (survivor.id === getFieldValue("survivor")) return true;
                          const phone = survivor.contacts?.[0]?.phone || survivor.CustomerPhone?.[0]?.mobileNo || survivor.CustomerPhone?.[0]?.phone || survivor.mobileNo || survivor.phone || "";
                          if (lastSearchRef.current) {
                            return phone.includes(lastSearchRef.current);
                          }
                          return true;
                        })
                        .map((survivor) => {
                          const phone = survivor.contacts?.[0]?.phone || survivor.CustomerPhone?.[0]?.mobileNo || survivor.CustomerPhone?.[0]?.phone || survivor.mobileNo || survivor.phone || "";
                          return (
                            <Select.Option key={survivor.id} value={survivor.id}>
                              {survivor.name}
                              {phone ? ` - ${phone}` : ""}
                            </Select.Option>
                          );
                        })
                      : null}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row>
          <Col span={12}>
            <Form.Item
              className="form-element-type"
              label={<Text strong>Discount Type?</Text>}
            >
              {getFieldDecorator("discountType", {
                rules: [
                  {
                    required: false,
                    message: "Select discountType",
                  },
                ],
              })(
                <Group
                  // onChange={(value) => setDiscountType(value)}
                  onChange={(e) => {
                    setFieldsValue({
                      discountType: e.target.value,
                    });
                    setDiscountType(e.target.value);
                  }}
                  // value={discountLevel}
                  disabled={editable}
                >
                  <Radio value="percent">Percentage(%) </Radio>
                  <Radio value="rupee"> Amount (Rs) </Radio>
                </Group>
              )}
            </Form.Item>
          </Col>
          {serviceType !== "Accidental" && (
            <Col span={12}>
              <Form.Item
                className="form-element-type"
                label={<Text strong>Add Recommended Parts & Services?</Text>}
              >
                {getFieldDecorator("recPart", {
                  rules: [
                    {
                      required: false,
                      message: "Select Recommended Parts & Services",
                    },
                  ],
                })(
                  <Group
                    onChange={(e) => {
                      setFieldsValue({
                        recPart: e.target.value,
                      });
                      setRecPart(e.target.value);
                    }}
                    // value={discountLevel}
                    disabled={editable}
                  >
                    <Radio value="yes">Yes </Radio>
                    <Radio value="no"> No </Radio>
                  </Group>
                )}
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              className="form-element-type"
              label="Discount Level"
              name="dicountLevel"
            >
              {getFieldDecorator("discountLevel", {
                rules: [
                  {
                    required: false,
                    message: "Select Discount Level",
                  },
                ],
              })(
                <Select
                  showSearch
                  showAction={["click", "focus"]}
                  style={{ width: 200 }}
                  disabled={editable}
                  placeholder="Select Discount Level"
                  onChange={(e) => {
                    setDiscountLevel(e);
                    setFieldsValue({
                      discountLevel: e,
                    });
                  }}
                // onChange={(value) => setDiscountType(value)}
                // value={discountType}
                >
                  <Option value="TransactionLevel">At Transaction Level</Option>
                  {/* <Option value="ItemLevel">At Item Level</Option> */}
                </Select>
              )}
            </Form.Item>
          </Col>
          {discountLevel === "TransactionLevel" && (
            <Col span={6}>
              <Form.Item
                className="form-element-type"
                label={
                  discountType === "percent"
                    ? "Discount Percent"
                    : "Discount Rupee"
                }
                name="discountAmount"
                rules={[{}]}
              >
                <Input
                  disabled={editable}
                  placeholder={
                    discountType === "percent"
                      ? "Discount Percent"
                      : "Discount Rupee"
                  }
                  onChange={(e) => {
                    let value = e.target.value.replace(/[^0-9.]/g, "");
                    value = value.replace(/^0+(?=\d)/, "");
                    setDiscountAmount(value);
                  }}
                  onInput={(e) => {
                    let value = e.target.value.replace(/[^0-9.]/g, "");
                    value = value.replace(/^0+(?=\d)/, "");
                    e.target.value = value;
                  }}
                  value={
                    discountLevel === "TransactionLevel" && discountAmount !== 0
                      ? discountAmount
                      : discountAmount
                  }
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col span={3}>
            <Upload
              accept=".csv"
              showUploadList={false}
              beforeUpload={(file) => {
                uploadCsv(file);
                return false;
              }}
            >
              <Button
                icon={<UploadOutlined />}
                style={{ marginTop: "6.4vh", marginRight: "3.4vh" }}
                type="primary"
              >
                Upload CSV
              </Button>
            </Upload>
          </Col>
          <Col span={3}>
            <Button
              onClick={() =>
                window.open("https://www.yamaha-motor-india.com/", "_blank")
              }
              style={{ marginTop: "6.4vh" }}
              type="primary"
            >
              Parts catalogue
            </Button>
          </Col>
        </Row>
        <Table
          className="parts-invoice-table"
          rowKey={(record) => {
            record.id;
          }}
          columns={renderColumns()}
          dataSource={itemList}
          tableLayout="fixed"
          pagination={false}
          style={{ marginTop: "1rem", marginBottom: "1rem" }}
        />
        <br />
        <Row gutter={16}>
          <Col span={7}>
            <Form.Item className="form-element" label="Labour Charge">
              {getFieldDecorator("labourCharge", {
                rules: [
                  {
                    required: false,
                    message: "Enter Labour Charge",
                  },
                ],
              })(<Input placeholder="Labour Charge" disabled={true} />)}
            </Form.Item>
            {!isInterStateTaxDisplay && (
              <Form.Item className="form-element" label="CGST">
                {getFieldDecorator("cgst", {
                  rules: [
                    {
                      required: false,
                      message: "Enter  CGST",
                    },
                  ],
                })(<Input placeholder="CGST" disabled={true} />)}
              </Form.Item>
            )}
            <Form.Item className="form-element" label="Total Discount">
              {getFieldDecorator("totalDiscount", {
                rules: [
                  {
                    required: false,
                    message: "Enter Total Discount",
                  },
                ],
              })(<Input placeholder="Total Discount" disabled={true} />)}
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item className="form-element" label="Consumable Charge">
              {getFieldDecorator("consumableCharge", {
                rules: [
                  {
                    required: false,
                    message: "Enter Consumable Charge",
                  },
                ],
              })(<Input placeholder="Consumable Charge" disabled={true} />)}
            </Form.Item>
            {!isInterStateTaxDisplay && (
              <Form.Item className="form-element" label="SGST">
                {getFieldDecorator("sgst", {
                  rules: [
                    {
                      required: false,
                      message: "Enter SGST",
                    },
                  ],
                })(<Input placeholder="SGST" disabled={true} />)}
              </Form.Item>
            )}
            <Form.Item className="form-element" label="Round Off">
              {getFieldDecorator("roundoff", {
                rules: [
                  {
                    required: false,
                    message: "Enter Roundoff",
                  },
                ],
              })(<Input placeholder="Round Off" disabled={true} />)}
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item className="form-element" label="Part Charge">
              {getFieldDecorator("partCharge", {
                rules: [
                  {
                    required: false,
                    message: "Enter Part Charge",
                  },
                ],
              })(<Input placeholder="Part Charge" disabled={true} />)}
            </Form.Item>
            {isInterStateTaxDisplay && (
              <Form.Item className="form-element" label="IGST">
                {getFieldDecorator("igst", {
                  rules: [
                    {
                      required: false,
                      message: "Enter IGST",
                    },
                  ],
                })(<Input placeholder="IGST" disabled={true} />)}
              </Form.Item>
            )}
          </Col>
        </Row>
        <br />
        <div className="gst-total-row">
          <div className="gst-total-row__gst">
            <div className="gst-table">
              <Title level={4} className="gst-title">
                GST Data
              </Title>
              <GSTTable
                gst={gst}
                stateName={stateName}
                SGST={SGST}
                CGST={CGST}
                IGST={IGST}
                itemList={itemList}
                GSTRate18={GSTRate18}
                GSTRate28={GSTRate28}
                GSTRate5={GSTRate5}
                GSTRate12={GSTRate12}
              />
            </div>
          </div>
          <div className="gst-total-row__total">
            <div className="total-estimated-amount-row">
              <Text strong className="total-estimated-amount-label">
                Total Estimated Amount&nbsp;:
              </Text>
              <Form.Item className="total-estimated-amount-field">
                {getFieldDecorator("totalAmount", {
                  rules: [
                    {
                      required: false,
                      message: "Enter Estimated Amount",
                    },
                  ],
                })(
                  <Input placeholder="Estimated Amount" disabled={true} />
                )}
              </Form.Item>
            </div>
          </div>
        </div>
        <div style={{ float: "right" }}>
          <Button
            style={{ marginRight: "1rem" }}
            size="large"
            onClick={() => handleCancel()}
          >
            Cancel
          </Button>
          {!editable ? (
            <Button
              type="primary"
              size="large"
              disabled={btnFlag}
              onClick={() => handleSubmit()}
            >
              {"Save"}
            </Button>
          ) : (
            (editData?.estimateStatus === "PENDING" || editData?.estimateStatus === "PARTIALLY APPROVED") && modifyAccess && (
              <Button
                type="primary"
                size="large"
                disabled={btnFlag}
                onClick={() => onEdit(false)}
              >
                {"Modify"}
              </Button>
            )
          )}
        </div>
      </Form>
      <WrappedCustomerAddModal
        data={selected}
        setData={setSelected}
        contact={contact}
        emitData={(data) => addCustomerData(data)}
        open={modalOpen}
        close={() => {
          setSelected(null);
          setModalOpen(false);
          setContact(lastSearchRef.current);
          if (lastSearchRef.current) {
            getSurvivor(lastSearchRef.current);
          }
        }}
        editable={true}
        cusId={cusId}
        setCusId={setCusId}
        defaultCustomerType="Insurance Surveyor"
      />
    </div>
  );
};
const WrappedEstimateForm = Form.create()(EstimateForm);

export default WrappedEstimateForm;
